export const flyteBadge = {
  icon: [
    1071,
    1000,
    [],
    '',
    [
      'M349.136 707.992l187.661-454.869v419.955l-8.332 8.728-108.907 114.263zM418.368 821.461v0zM339.019 709.381v0 0h-1.389zM1071.213 511.207c0 53.561-85.697 93.037-101.368 141.241s29.756 132.116 0 173.775-123.189 24.003-165.244 54.552-52.37 124.181-102.36 140.646-112.477-53.164-166.633-53.164-117.238 69.232-165.443 53.561-60.504-109.303-102.162-140.25-134.695-12.101-165.244-54.156 16.267-123.785-0.992-172.783-101.765-88.276-101.765-141.836 85.697-92.838 101.368-141.241-29.756-132.116 0-173.775 123.189-23.805 165.244-54.552 52.767-123.388 102.757-140.448 112.081 53.164 166.236 52.966 116.643-69.034 164.848-53.362 61.099 109.898 102.757 140.051 134.695 12.101 165.244 54.156-15.275 123.785 0 173.775 102.757 87.482 102.757 140.845zM769.091 710.769l-232.294-542.351-234.675 543.938 115.651 143.423 121.602-126.363 116.445 123.586z'
    ]
  ],
  prefix: 'fd',
  iconName: 'flyte-badge'
};
export const circle = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'circle'
};
export const fileLogo = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M838.997 217.088l-178.517-178.176c-24.876-22.382-57.34-36.769-93.105-38.892l-0.42-0.020h-512c-30.351 0-54.955 24.604-54.955 54.955v0 914.091c0 30.351 24.604 54.955 54.955 54.955v0h768c30.203-0.194 54.613-24.723 54.613-54.954 0-0-0-0.001-0-0.001l0 0v-658.091c-1.931-36.275-16.222-68.883-38.7-94.014l0.129 0.147zM585.045 77.824c9.048 2.867 16.889 7.179 23.678 12.729l-0.126-0.1 178.859 178.859c5.469 6.548 9.783 14.279 12.495 22.727l0.134 0.483h-215.040zM804.523 950.955h-731.477v-877.909h438.955v238.933c0.194 30.203 24.723 54.613 54.954 54.613 0 0 0.001-0 0.001-0l238.933 0z M273.067 712.363l84.651 106.837 89.088-94.208 84.992 92.16 82.603-106.155-170.667-403.797zM357.717 793.6l-63.829-81.92 150.187-375.467v365.227z'
    ]
  ],
  prefix: 'fd',
  iconName: 'file-logo'
};
export const database = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M438.857 438.857c172 0 344.571-30.857 438.857-97.143v97.143c0 80.571-196.571 146.286-438.857 146.286s-438.857-65.714-438.857-146.286v-97.143c94.286 66.286 266.857 97.143 438.857 97.143zM438.857 877.714c172 0 344.571-30.857 438.857-97.143v97.143c0 80.571-196.571 146.286-438.857 146.286s-438.857-65.714-438.857-146.286v-97.143c94.286 66.286 266.857 97.143 438.857 97.143zM438.857 658.286c172 0 344.571-30.857 438.857-97.143v97.143c0 80.571-196.571 146.286-438.857 146.286s-438.857-65.714-438.857-146.286v-97.143c94.286 66.286 266.857 97.143 438.857 97.143zM438.857 0c242.286 0 438.857 65.714 438.857 146.286v73.143c0 80.571-196.571 146.286-438.857 146.286s-438.857-65.714-438.857-146.286v-73.143c0-80.571 196.571-146.286 438.857-146.286z'
    ]
  ],
  prefix: 'fd',
  iconName: 'database'
};
export const ban = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M749.714 510.286c0-62.286-18.286-120-49.714-168.571l-430.857 430.286c49.143 32 107.429 50.857 169.714 50.857 171.429 0 310.857-140 310.857-312.571zM178.857 681.143l431.429-430.857c-49.143-33.143-108-52-171.429-52-171.429 0-310.857 140-310.857 312 0 63.429 18.857 121.714 50.857 170.857zM877.714 510.286c0 243.429-196.571 440.571-438.857 440.571s-438.857-197.143-438.857-440.571c0-242.857 196.571-440 438.857-440s438.857 197.143 438.857 440z'
    ]
  ],
  prefix: 'fd',
  iconName: 'ban'
};
export const caretRight = {
  icon: [
    329,
    1000,
    [],
    '',
    [
      'M329.143 512c0 9.714-4 18.857-10.857 25.714l-256 256c-6.857 6.857-16 10.857-25.714 10.857-20 0-36.571-16.571-36.571-36.571v-512c0-20 16.571-36.571 36.571-36.571 9.714 0 18.857 4 25.714 10.857l256 256c6.857 6.857 10.857 16 10.857 25.714z'
    ]
  ],
  prefix: 'fd',
  iconName: 'caret-right'
};
export const flytedeskLogo = {
  icon: [
    1150.8,
    311.1,
    [],
    '',
    [
      'M212.8,132.8c4.8,0,7.6.7,9.1,1.1v-24.4c-2.4-1.1-8.3-2.2-14.4-2.2-23.7,0-38.9,15.7-38.9,39.8v12.2h-17.8v24.8h17.8v82.2h29.1v-82.2h24.1v-24.8h-24.1v-11.7c0-12,8.5-14.8,15-14.8ZM264.6,266.3V108.9h-28.9v157.5h28.9ZM434,127.3h-26.1v15c0,9.6-5.2,17-16.5,17h-5.4v25.7h19.4v49.8c0,20.7,13.1,33.1,33.9,33.1s13.7-1.5,16.3-2.6v-23.9c-1.5.4-5.4.9-8.9.9-8.3,0-12.6-3-12.6-12.4v-44.8h21.5v-25.7h-21.5v-32M490.3,200.6c.7-9.8,8.9-21.1,23.9-21.1s23.5,10.4,23.9,21.1h-47.9ZM540.9,228.5c-3.5,9.6-10.9,16.3-24.4,16.3s-26.3-10.2-27-24.4h76.6c0-.4.4-4.8.4-8.9,0-34.4-19.8-55.5-52.9-55.5s-52.6,22.2-52.6,56.3,25.9,57.2,55.2,57.2,43.3-15.4,48.7-33.9l-24.1-7.2ZM723.2,200.6c.7-9.8,8.9-21.1,23.9-21.1s23.5,10.4,23.9,21.1h-47.9ZM773.9,228.5c-3.5,9.6-10.9,16.3-24.4,16.3s-26.3-10.2-27-24.4h76.6c0-.4.4-4.8.4-8.9,0-34.4-19.8-55.5-52.9-55.5s-52.6,22.2-52.6,56.3,25.9,57.2,55.2,57.2,43.3-15.4,48.7-33.9l-24.1-7.2M802.5,236.5c1.3,12.2,12.4,33.1,44.6,33.1s41.5-17.8,41.5-35.2-10.7-28.5-31.8-32.8l-15.2-3.3c-5.9-1.1-9.8-4.4-9.8-9.6s6.1-10.7,13.7-10.7c12.2,0,16.7,8,17.6,14.4l24.1-5.4c-1.3-11.5-11.5-30.9-42-30.9s-40,15.9-40,35,9.4,27.4,30,32l14.1,3.3c8.3,1.7,11.5,5.7,11.5,10.4s-4.6,10.7-14.1,10.7-18.9-7.8-19.6-16.3l-24.8,5.4ZM998.5,159.3h-37.8l-37,39.8v-90.3h-28.9v157.5h28.9v-28.3l12-12.6,28.3,40.9h35.5l-43.7-62,42.8-45M687.9,108.9h-28.5v61.1c-3-5.7-11.7-13.3-30.2-13.3-30.2,0-51.3,24.6-51.3,55.9s21.8,56.3,52.2,56.3,25.2-6.5,30-15c0,5,.7,10.2,1.1,12.4h27.6c-.4-4.3-.9-12.2-.9-19.4V108.9ZM606.9,212.6c0-19.1,11.7-30,26.5-30s26.3,10.7,26.3,29.8-11.5,30.7-26.3,30.7-26.5-11.3-26.5-30.5ZM352.3,159h30l-39.5,108.6c-5.6,15.6-13.2,26.9-22.6,33.9-9.3,7.1-20.8,10.3-34.7,9.6v-26c7.5.1,13.5-1.4,17.8-4.8,4.5-3.3,8-8.7,10.6-16.1l-44.5-105.1h30.6l28.2,72.9,24.1-72.9M1046.3,121.7L1150.8,1.5s-41,160.2-48.5,168.8c-7.3,8.4-44.1,5.8-49.8.8-5.7-5-6.1-49.5-6.1-49.5ZM1031.8,108.6L1148.3,0s-158.6,46.6-167,54.4c-8.1,7.6-4.2,44.3.9,49.8,5.2,5.5,49.6,4.4,49.6,4.4Z'
    ]
  ],
  prefix: 'fd',
  iconName: 'flytedesk-logo'
};

export const flyteboard = {
  icon: [
    3197,
    1000,
    [],
    '',
    [
      'M269.312 400.384v187.392h-95.232v-187.392h-32.768v-77.824h32.768v-45.056c0-27.648 3.072-58.368 24.576-87.040 24.576-32.768 60.416-41.984 92.16-41.984 17.408 0 31.744 3.072 45.056 8.192v82.944c-12.288-8.192-24.576-9.216-29.696-9.216-14.336 0-22.528 5.12-26.624 10.24-10.24 11.264-10.24 31.744-10.24 44.032v37.888h66.56v77.824h-66.56zM484.352 154.624v433.152h-95.232v-433.152h95.232zM656.384 551.936l-128-229.376h110.592l70.656 135.168 68.608-135.168h108.544l-212.992 401.408h-105.472l88.064-172.032zM1046.528 400.384v187.392h-95.232v-187.392h-30.72v-77.824h30.72v-88.064h95.232v88.064h54.272v77.824h-54.272zM1417.216 473.088h-197.632c0 14.336 5.12 32.768 16.384 44.032 6.144 6.144 18.432 13.312 38.912 13.312 3.072 0 19.456-1.024 31.744-7.168 5.12-4.096 12.288-9.216 16.384-18.432h91.136c-4.096 15.36-12.288 35.84-31.744 55.296-20.48 18.432-51.2 36.864-108.544 36.864-34.816 0-76.8-8.192-109.568-40.96-17.408-17.408-38.912-49.152-38.912-100.352 0-44.032 16.384-79.872 39.936-102.4 21.504-21.504 56.32-38.912 108.544-38.912 31.744 0 70.656 7.168 102.4 36.864 36.864 35.84 41.984 81.92 41.984 111.616v10.24zM1330.176 417.792c-2.048-10.24-8.192-21.504-15.36-28.672-12.288-12.288-29.696-14.336-39.936-14.336-15.36 0-27.648 4.096-37.888 14.336-7.168 7.168-12.288 16.384-14.336 28.672h107.52zM1555.456 154.624v193.536c17.408-18.432 41.984-34.816 78.848-34.816 32.768 0 67.584 11.264 93.184 35.84 24.576 22.528 44.032 59.392 44.032 105.472 0 41.984-16.384 78.848-43.008 105.472-24.576 24.576-55.296 36.864-93.184 36.864-18.432 0-53.248-4.096-79.872-38.912v29.696h-95.232v-433.152h95.232zM1655.808 498.688c12.288-13.312 17.408-28.672 17.408-41.984 0-18.432-7.168-34.816-17.408-45.056-9.216-9.216-22.528-17.408-41.984-17.408-18.432 0-33.792 6.144-44.032 17.408-9.216 10.24-17.408 27.648-17.408 43.008s7.168 33.792 19.456 45.056c10.24 8.192 25.6 15.36 40.96 15.36 14.336 1.024 29.696-4.096 43.008-16.384zM2093.056 552.96c-34.816 34.816-75.776 44.032-118.784 44.032-38.912 0-80.896-8.192-117.76-44.032-29.696-28.672-40.96-62.464-40.96-98.304 0-47.104 21.504-78.848 40.96-97.28 21.504-21.504 60.416-44.032 117.76-44.032 58.368 0 97.28 23.552 118.784 44.032 19.456 19.456 40.96 50.176 40.96 97.28 0 35.84-11.264 69.632-40.96 98.304zM1932.288 411.648c-12.288 11.264-18.432 27.648-18.432 43.008 0 16.384 7.168 31.744 18.432 43.008 11.264 10.24 26.624 17.408 41.984 17.408 16.384 0 31.744-7.168 43.008-17.408 11.264-11.264 17.408-26.624 17.408-43.008 0-13.312-6.144-30.72-17.408-43.008-11.264-10.24-27.648-17.408-43.008-17.408-14.336 0-30.72 7.168-41.984 17.408zM2394.112 322.56h95.232v265.216h-95.232v-29.696c-21.504 30.72-56.32 38.912-81.92 38.912-28.672 0-63.488-8.192-96.256-41.984-25.6-27.648-37.888-58.368-37.888-97.28 0-50.176 19.456-84.992 40.96-106.496 22.528-22.528 57.344-36.864 95.232-36.864 43.008 0 68.608 21.504 79.872 33.792v-25.6zM2294.784 411.648c-13.312 12.288-19.456 29.696-19.456 43.008 0 16.384 7.168 32.768 18.432 44.032 10.24 9.216 26.624 17.408 41.984 17.408 16.384 0 31.744-6.144 43.008-17.408 8.192-9.216 17.408-21.504 17.408-43.008 0-12.288-3.072-29.696-17.408-44.032-9.216-8.192-22.528-17.408-43.008-17.408-11.264 0-27.648 4.096-40.96 17.408zM2543.616 322.56h94.208v43.008c9.216-17.408 23.552-29.696 37.888-36.864s31.744-10.24 49.152-10.24c2.048 0 6.144 0 19.456 1.024v90.112c-5.12-2.048-18.432-9.216-40.96-9.216-12.288 0-29.696 1.024-44.032 14.336-19.456 17.408-21.504 46.080-21.504 60.416v113.664h-94.208v-266.24zM3075.072 587.776h-95.232v-29.696c-26.624 34.816-61.44 38.912-80.896 38.912-37.888 0-67.584-12.288-93.184-36.864-26.624-26.624-41.984-63.488-41.984-105.472 0-46.080 18.432-82.944 43.008-105.472 26.624-24.576 61.44-35.84 94.208-35.84 35.84 0 61.44 16.384 78.848 34.816v-193.536h95.232v433.152zM2962.432 499.712c12.288-11.264 19.456-28.672 19.456-45.056 0-14.336-8.192-32.768-17.408-43.008-10.24-10.24-25.6-17.408-43.008-17.408-20.48 0-33.792 9.216-43.008 17.408-10.24 10.24-17.408 27.648-17.408 45.056 0 14.336 5.12 29.696 17.408 41.984 13.312 13.312 28.672 17.408 43.008 17.408 15.36 0 30.72-7.168 40.96-16.384zM960.512 813.056h-57.344l-14.336 31.744h-21.504l65.536-141.312 63.488 141.312h-22.528l-13.312-31.744zM952.32 792.576l-20.48-45.056-20.48 45.056h40.96zM1029.12 699.392v145.408h-19.456v-145.408h19.456zM1073.152 699.392v145.408h-19.456v-145.408h19.456zM1165.312 778.24v66.56h-20.48v-66.56h-8.192v-17.408h8.192v-30.72h19.456v30.72h15.36v17.408h-14.336zM1192.96 699.392h19.456v68.608c8.192-9.216 17.408-9.216 22.528-9.216 15.36 0 22.528 7.168 24.576 11.264 6.144 7.168 6.144 17.408 6.144 23.552v51.2h-20.48v-50.176c0-5.12 0-10.24-3.072-14.336-3.072-2.048-7.168-4.096-11.264-4.096-7.168 0-12.288 3.072-14.336 6.144-3.072 4.096-4.096 10.24-4.096 21.504v40.96h-19.456v-145.408zM1299.456 712.704c7.168 0 12.288 6.144 12.288 13.312 0 6.144-5.12 12.288-12.288 12.288s-12.288-6.144-12.288-12.288c0-7.168 5.12-13.312 12.288-13.312zM1309.696 760.832v83.968h-19.456v-83.968h19.456zM1334.272 760.832h19.456v8.192c8.192-10.24 18.432-10.24 22.528-10.24 16.384 0 22.528 8.192 25.6 11.264 3.072 5.12 5.12 10.24 5.12 23.552v52.224h-19.456v-47.104c0-21.504-8.192-22.528-15.36-22.528-9.216 0-18.432 2.048-18.432 28.672v40.96h-19.456v-84.992zM1492.992 760.832h19.456v76.8c0 20.48-2.048 34.816-13.312 44.032-6.144 5.12-14.336 9.216-28.672 9.216-9.216 0-19.456-2.048-27.648-10.24-6.144-6.144-10.24-16.384-12.288-26.624h19.456c1.024 5.12 3.072 10.24 6.144 13.312 2.048 3.072 7.168 6.144 15.36 6.144s12.288-3.072 15.36-6.144c6.144-6.144 6.144-14.336 6.144-21.504v-10.24c-9.216 11.264-20.48 11.264-25.6 11.264-11.264 0-20.48-3.072-27.648-11.264-8.192-8.192-13.312-19.456-13.312-32.768 0-16.384 6.144-26.624 13.312-32.768 8.192-8.192 17.408-11.264 27.648-11.264 9.216 0 18.432 2.048 25.6 11.264v-9.216zM1456.128 781.312c-5.12 5.12-9.216 12.288-9.216 21.504 0 8.192 3.072 16.384 9.216 21.504 3.072 3.072 8.192 5.12 14.336 5.12s12.288-1.024 16.384-6.144c6.144-6.144 8.192-13.312 8.192-20.48 0-9.216-3.072-16.384-8.192-20.48-5.12-5.12-10.24-6.144-16.384-6.144-5.12 0-10.24 1.024-14.336 5.12zM1573.888 782.336c-1.024-3.072-5.12-6.144-11.264-6.144-3.072 0-5.12 0-6.144 2.048-1.024 1.024-2.048 2.048-2.048 4.096s1.024 4.096 2.048 5.12c2.048 1.024 3.072 1.024 7.168 3.072l9.216 5.12c5.12 2.048 9.216 4.096 12.288 8.192 5.12 4.096 6.144 9.216 6.144 15.36 0 7.168-2.048 14.336-7.168 19.456-7.168 7.168-14.336 9.216-23.552 9.216-5.12 0-12.288-1.024-18.432-5.12-5.12-4.096-9.216-10.24-10.24-16.384l15.36-7.168c1.024 3.072 3.072 6.144 5.12 8.192 1.024 1.024 4.096 3.072 8.192 3.072 3.072 0 6.144-1.024 8.192-3.072 1.024-1.024 2.048-4.096 2.048-6.144s-1.024-5.12-2.048-6.144c-2.048-2.048-5.12-4.096-9.216-6.144l-6.144-3.072c-4.096-2.048-9.216-4.096-12.288-7.168-4.096-4.096-5.12-9.216-5.12-14.336 0-6.144 2.048-13.312 7.168-17.408 3.072-4.096 10.24-8.192 20.48-8.192 6.144 0 10.24 1.024 15.36 4.096 2.048 2.048 6.144 5.12 9.216 10.24l-14.336 9.216zM1692.672 782.336c-2.048-3.072-6.144-6.144-12.288-6.144-3.072 0-5.12 0-6.144 2.048-1.024 1.024-2.048 2.048-2.048 4.096s1.024 4.096 3.072 5.12c1.024 1.024 2.048 1.024 6.144 3.072l10.24 5.12c4.096 2.048 8.192 4.096 12.288 8.192s6.144 9.216 6.144 15.36c0 7.168-3.072 14.336-8.192 19.456-6.144 7.168-14.336 9.216-23.552 9.216-5.12 0-11.264-1.024-18.432-5.12-4.096-4.096-8.192-10.24-10.24-16.384l16.384-7.168c1.024 3.072 2.048 6.144 4.096 8.192 1.024 1.024 4.096 3.072 8.192 3.072 3.072 0 6.144-1.024 8.192-3.072 2.048-1.024 3.072-4.096 3.072-6.144s-1.024-5.12-3.072-6.144c-2.048-2.048-5.12-4.096-8.192-6.144l-7.168-3.072c-4.096-2.048-8.192-4.096-11.264-7.168-5.12-4.096-6.144-9.216-6.144-14.336 0-6.144 3.072-13.312 7.168-17.408s10.24-8.192 20.48-8.192c6.144 0 10.24 1.024 15.36 4.096 3.072 2.048 7.168 5.12 10.24 10.24l-14.336 9.216zM1747.968 778.24v66.56h-19.456v-66.56h-8.192v-17.408h8.192v-30.72h19.456v30.72h15.36v17.408h-15.36zM1796.096 760.832v48.128c0 4.096 0 10.24 3.072 14.336s7.168 6.144 13.312 6.144 10.24-2.048 12.288-6.144c4.096-4.096 4.096-10.24 4.096-14.336v-48.128h19.456v48.128c0 11.264-1.024 20.48-9.216 27.648-7.168 8.192-17.408 10.24-27.648 10.24-8.192 0-18.432-2.048-26.624-10.24-7.168-7.168-8.192-16.384-8.192-27.648v-48.128h19.456zM1934.336 699.392h19.456v145.408h-19.456v-9.216c-8.192 10.24-19.456 11.264-25.6 11.264-25.6 0-40.96-21.504-40.96-44.032 0-27.648 19.456-44.032 40.96-44.032 6.144 0 17.408 1.024 25.6 11.264v-70.656zM1888.256 802.816c0 14.336 9.216 26.624 23.552 26.624 12.288 0 23.552-9.216 23.552-26.624 0-18.432-11.264-26.624-23.552-26.624-14.336 0-23.552 11.264-23.552 26.624zM2054.144 825.344c-4.096 6.144-9.216 12.288-14.336 15.36-7.168 5.12-16.384 6.144-24.576 6.144-11.264 0-20.48-2.048-28.672-10.24s-12.288-19.456-12.288-31.744c0-13.312 4.096-25.6 13.312-34.816 7.168-7.168 15.36-11.264 27.648-11.264 13.312 0 22.528 5.12 26.624 10.24 11.264 11.264 12.288 26.624 12.288 35.84v2.048h-60.416c1.024 6.144 3.072 13.312 7.168 17.408s10.24 5.12 15.36 5.12c5.12 0 9.216-1.024 13.312-4.096 3.072-2.048 5.12-6.144 8.192-9.216l16.384 9.216zM2034.688 791.552c-1.024-5.12-3.072-9.216-6.144-12.288-3.072-2.048-7.168-4.096-13.312-4.096-7.168 0-11.264 2.048-13.312 5.12-3.072 2.048-5.12 6.144-7.168 10.24h39.936zM2074.624 760.832h19.456v8.192c8.192-10.24 17.408-10.24 22.528-10.24 15.36 0 22.528 8.192 25.6 11.264 3.072 5.12 5.12 10.24 5.12 23.552v52.224h-19.456v-47.104c0-21.504-8.192-22.528-16.384-22.528s-17.408 2.048-17.408 28.672v40.96h-19.456v-84.992zM2192.384 778.24v66.56h-20.48v-66.56h-7.168v-17.408h7.168v-30.72h20.48v30.72h14.336v17.408h-14.336zM2276.352 712.704c7.168 0 13.312 6.144 13.312 13.312 0 6.144-6.144 12.288-13.312 12.288s-12.288-6.144-12.288-12.288c0-7.168 5.12-13.312 12.288-13.312zM2286.592 760.832v130.048h-19.456v-130.048h19.456zM2396.16 802.816c0 25.6-19.456 44.032-44.032 44.032s-45.056-18.432-45.056-44.032c0-26.624 19.456-44.032 45.056-44.032s44.032 17.408 44.032 44.032zM2376.704 802.816c0-19.456-12.288-26.624-24.576-26.624s-25.6 7.168-25.6 26.624c0 16.384 10.24 26.624 25.6 26.624s24.576-10.24 24.576-26.624zM2436.096 760.832v48.128c0 4.096 0 10.24 4.096 14.336 3.072 4.096 7.168 6.144 13.312 6.144s10.24-2.048 12.288-6.144c4.096-4.096 4.096-10.24 4.096-14.336v-48.128h19.456v48.128c0 11.264-2.048 20.48-9.216 27.648-7.168 8.192-17.408 10.24-27.648 10.24-8.192 0-19.456-2.048-26.624-10.24-8.192-7.168-9.216-16.384-9.216-27.648v-48.128h19.456zM2513.92 760.832h19.456v7.168c2.048-2.048 5.12-5.12 8.192-7.168 4.096-2.048 7.168-2.048 12.288-2.048 4.096 0 9.216 0 15.36 4.096l-8.192 17.408c-4.096-3.072-8.192-3.072-10.24-3.072-4.096 0-8.192 0-11.264 4.096-6.144 6.144-6.144 14.336-6.144 19.456v44.032h-19.456v-83.968zM2580.48 760.832h19.456v8.192c8.192-10.24 17.408-10.24 22.528-10.24 15.36 0 21.504 8.192 24.576 11.264 3.072 5.12 5.12 10.24 5.12 23.552v52.224h-19.456v-47.104c0-21.504-8.192-22.528-15.36-22.528-9.216 0-17.408 2.048-17.408 28.672v40.96h-19.456v-84.992zM2738.176 760.832h19.456v83.968h-19.456v-9.216c-8.192 10.24-18.432 11.264-24.576 11.264-25.6 0-40.96-21.504-40.96-44.032 0-27.648 18.432-44.032 40.96-44.032 6.144 0 16.384 1.024 24.576 11.264v-9.216zM2693.12 802.816c0 14.336 9.216 26.624 23.552 26.624 12.288 0 23.552-9.216 23.552-26.624 0-18.432-11.264-26.624-23.552-26.624-15.36 0-23.552 11.264-23.552 26.624zM2802.688 699.392v145.408h-19.456v-145.408h19.456zM2837.504 712.704c7.168 0 12.288 6.144 12.288 13.312 0 6.144-5.12 12.288-12.288 12.288s-12.288-6.144-12.288-12.288c0-7.168 5.12-13.312 12.288-13.312zM2846.72 760.832v83.968h-19.456v-83.968h19.456zM2908.16 782.336c-2.048-3.072-5.12-6.144-11.264-6.144-3.072 0-5.12 0-6.144 2.048-1.024 1.024-2.048 2.048-2.048 4.096s1.024 4.096 3.072 5.12c1.024 1.024 2.048 1.024 6.144 3.072l10.24 5.12c4.096 2.048 8.192 4.096 11.264 8.192 5.12 4.096 6.144 9.216 6.144 15.36 0 7.168-2.048 14.336-7.168 19.456-6.144 7.168-14.336 9.216-23.552 9.216-5.12 0-12.288-1.024-18.432-5.12-5.12-4.096-8.192-10.24-10.24-16.384l15.36-7.168c1.024 3.072 3.072 6.144 5.12 8.192 1.024 1.024 4.096 3.072 8.192 3.072 3.072 0 6.144-1.024 8.192-3.072 2.048-1.024 2.048-4.096 2.048-6.144s0-5.12-2.048-6.144c-2.048-2.048-5.12-4.096-8.192-6.144l-7.168-3.072c-4.096-2.048-9.216-4.096-12.288-7.168-4.096-4.096-6.144-9.216-6.144-14.336 0-6.144 3.072-13.312 7.168-17.408s10.24-8.192 20.48-8.192c6.144 0 11.264 1.024 15.36 4.096 3.072 2.048 7.168 5.12 10.24 10.24l-14.336 9.216zM2944 760.832h19.456v8.192c6.144-8.192 14.336-10.24 20.48-10.24 9.216 0 17.408 4.096 21.504 12.288 7.168-9.216 18.432-12.288 25.6-12.288 10.24 0 18.432 5.12 23.552 13.312 2.048 3.072 4.096 9.216 4.096 21.504v52.224h-19.456v-46.080c0-10.24 0-13.312-1.024-15.36-2.048-3.072-4.096-8.192-11.264-8.192-5.12 0-9.216 3.072-11.264 6.144-4.096 5.12-4.096 12.288-4.096 19.456v44.032h-19.456v-46.080c0-10.24-1.024-13.312-2.048-15.36-1.024-3.072-4.096-8.192-11.264-8.192-5.12 0-9.216 3.072-11.264 6.144-4.096 5.12-4.096 12.288-4.096 19.456v44.032h-19.456v-84.992z'
    ]
  ],
  prefix: 'fd',
  iconName: 'flyteboard'
};
export const nova = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M855.918 869.177c-97.12 96.59-228.614 150.673-365.587 150.366-152.531 0.368-297.429-66.686-395.873-183.197 202.411 166.824 503.907 156.389 693.933-31.303 128.064-125.849 128.064-332.249 0-458.098-128.013-126.486-335.599-126.486-463.654 0-54.861 53.935-54.861 142.368 0 196.303 55.153 54.201 143.568 54.201 198.721 0 18.381-18.049 47.831-18.049 66.212 0 18.289 17.983 18.289 47.465 0 65.449-91.92 90.326-239.268 90.326-331.188 0-91.462-89.892-91.462-237.308 0-327.2 164.618-162.625 431.545-162.625 596.163 0 164.125 161.308 164.698 425.663 1.272 587.68zM886.204 184.746c-202.454-166.824-503.907-156.389-693.933 31.303-128.064 125.849-128.064 332.249 0 458.098 128.013 126.486 335.599 126.486 463.654 0 54.861-53.935 54.861-142.368 0-196.303-55.153-54.201-143.568-54.201-198.721 0-18.381 18.049-47.831 18.049-66.212 0-18.289-17.983-18.289-47.465 0-65.449 91.92-90.326 239.268-90.326 331.188 0 91.462 89.892 91.462 237.308 0 327.2-164.618 162.625-432.404 163.49-596.163 0-163.741-163.471-162.061-434.222-0.636-588.316 95.026-90.71 222.347-149.73 364.951-149.73 159.062 0 301.369 71.26 395.873 183.197v-0z'
    ]
  ],
  prefix: 'fd',
  iconName: 'nova'
};
export const flytedesk = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M514.048 38.912l-323.584 748.544 159.744 197.632 166.912-174.080 160.768 171.008 155.648-196.608-319.488-746.496zM350.208 937.984l-119.808-151.552 283.648-693.248v674.816l-163.84 169.984z'
    ]
  ],
  prefix: 'fd',
  iconName: 'flytedesk'
};
export const paperPlane = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1007.616 6.144q19.456 13.312 15.36 36.864l-145.408 877.568q-3.072 16.384-18.432 25.6-8.192 5.12-18.432 5.12-6.144 0-13.312-3.072l-259.072-106.496-138.24 168.96q-10.24 13.312-27.648 13.312-7.168 0-12.288-2.048-11.264-4.096-17.408-13.312t-7.168-21.504v-199.68l493.568-604.16-610.304 528.384-226.304-93.184q-20.48-8.192-22.528-30.72-1.024-23.552 18.432-33.792l950.272-548.864q9.216-5.12 18.432-5.12 11.264 0 20.48 6.144z'
    ]
  ],
  prefix: 'fd',
  iconName: 'paper-plane'
};
export const paperPlaneEmpty = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1007.616 6.144q19.456 13.312 15.36 36.864l-145.408 877.568q-3.072 16.384-18.432 25.6-8.192 5.12-18.432 5.12-6.144 0-13.312-3.072l-301.056-122.88-169.984 186.368q-10.24 12.288-27.648 12.288-7.168 0-12.288-2.048-11.264-4.096-17.408-13.312t-6.144-21.504v-258.048l-270.336-110.592q-20.48-8.192-22.528-30.72t18.432-33.792l950.272-548.864q20.48-12.288 38.912 1.024zM813.056 863.232l125.952-756.736-819.2 473.088 191.488 77.824 493.568-364.544-273.408 454.656z'
    ]
  ],
  prefix: 'fd',
  iconName: 'paper-plane-empty'
};
export const print = {
  icon: [
    1169,
    1000,
    [],
    '',
    [
      'M584.704 292.864h-219.136v219.136h219.136v-219.136zM658.432 658.432v72.704h-365.568v-72.704h365.568zM658.432 219.136v365.568h-365.568v-365.568h365.568zM1024 658.432v72.704h-292.864v-72.704h292.864zM1024 512v72.704h-292.864v-72.704h292.864zM1024 365.568v73.728h-292.864v-73.728h292.864zM1024 219.136v73.728h-292.864v-73.728h292.864zM146.432 768v-548.864h-73.728v548.864q0 14.336 11.264 25.6t25.6 11.264 25.6-11.264 11.264-25.6zM1096.704 768v-621.568h-877.568v621.568q0 18.432-6.144 36.864h847.872q14.336 0 25.6-11.264t10.24-25.6zM1170.432 72.704v695.296q0 46.080-31.744 77.824t-77.824 31.744h-951.296q-45.056 0-77.824-31.744t-31.744-77.824v-621.568h146.432v-73.728h1024z'
    ]
  ],
  prefix: 'fd',
  iconName: 'print'
};
export const specialEdition = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M968.704 803.84c0 45.056-35.84 80.896-80.896 80.896h-704.512c-45.056 0-81.92-35.84-81.92-80.896v-460.8h108.544v-54.272h758.784v515.072zM209.92 397.312h-54.272v406.528c0 14.336 12.288 26.624 27.648 26.624s26.624-12.288 26.624-26.624v-406.528zM914.432 343.040h-650.24v460.8c0 9.216-2.048 18.432-4.096 26.624h627.712c14.336 0 26.624-12.288 26.624-26.624v-460.8zM589.824 668.672h-271.36v-271.36h271.36v271.36zM589.824 777.216h-271.36v-54.272h271.36v54.272zM372.736 451.584v162.816h162.816v-162.816h-162.816zM860.16 451.584h-216.064v-54.272h216.064v54.272zM860.16 560.128h-216.064v-54.272h216.064v54.272zM860.16 668.672h-216.064v-54.272h216.064v54.272zM860.16 777.216h-216.064v-54.272h216.064v54.272zM51.2 251.904l21.504-36.864-38.912-17.408 8.192-25.6 40.96 9.216 5.12-41.984h27.648l4.096 41.984 40.96-9.216 9.216 25.6-38.912 17.408 21.504 36.864-22.528 16.384-27.648-31.744-29.696 31.744-21.504-16.384z'
    ]
  ],
  prefix: 'fd',
  iconName: 'special-edition'
};
export const billboard = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M814.080 652.288l-18.432 35.84h-266.24v168.96h-86.016v-168.96h-268.288l-19.456-35.84h658.432zM153.6 200.704v364.544h663.552v-364.544h-663.552zM273.408 173.056h11.264v-25.6h39.936l-20.48-24.576h-49.152l-21.504 24.576h39.936v25.6zM479.232 173.056h12.288v-25.6h38.912l-20.48-24.576h-49.152l-20.48 24.576h38.912v25.6zM685.056 173.056h12.288v-25.6h38.912l-20.48-24.576h-49.152l-20.48 24.576h38.912v25.6z'
    ]
  ],
  prefix: 'fd',
  iconName: 'billboard'
};
export const brandedCoasters = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M976.896 274.432h-209.92l-1.024-112.64h-1.024c-2.048-20.48-15.36-35.84-26.624-46.080-14.336-13.312-35.84-25.6-62.464-34.816-51.2-20.48-119.808-30.72-191.488-30.72s-140.288 10.24-192.512 30.72c-25.6 9.216-47.104 21.504-61.44 34.816-12.288 11.264-27.648 29.696-27.648 53.248 0.269 2.39 0.629 4.481 1.098 6.529l-0.074-0.385v404.48c-89.088 40.96-144.384 100.352-144.384 165.888 0 122.88 193.536 223.232 431.104 223.232s431.104-100.352 431.104-223.232c0-31.744-12.288-61.44-35.84-89.088 8.708-6.448 16.399-13.165 23.517-20.444l0.035-0.036q52.224-52.224 52.224-125.952v-149.504l29.696-29.696zM841.728 390.144v119.808c0 32.801-26.591 59.392-59.392 59.392v0h-13.312l-1.024-179.2zM305.152 115.712c48.128-17.408 111.616-27.648 179.2-27.648s131.072 10.24 178.176 27.648c39.936 15.36 64.512 35.84 64.512 53.248s-24.576 36.864-64.512 52.224c-47.104 18.432-110.592 27.648-178.176 27.648s-131.072-9.216-179.2-27.648c-38.912-15.36-64.512-34.816-64.512-52.224s24.576-37.888 64.512-53.248zM854.016 804.864c-17.408 21.504-44.032 41.984-77.824 59.392-36.864 19.456-78.848 33.792-126.976 44.032-50.176 11.264-103.424 16.384-158.72 16.384s-108.544-5.12-158.72-16.384c-47.104-10.24-90.112-24.576-125.952-44.032-33.792-17.408-61.44-37.888-78.848-59.392-16.384-19.456-24.576-38.912-24.576-59.392s8.192-38.912 24.576-58.368c17.408-21.504 44.032-41.984 76.8-59.392v112.64c-0.058 0.766-0.092 1.659-0.092 2.56s0.033 1.794 0.099 2.678l-0.007-0.118c0 54.272 126.976 99.328 282.624 99.328s283.648-45.056 283.648-99.328c0.058-0.766 0.092-1.659 0.092-2.56s-0.033-1.794-0.099-2.678l0.007 0.118v-51.2h12.288c0.58 0.007 1.266 0.011 1.952 0.011 22.469 0 43.972-4.135 63.79-11.686l-1.23 0.412c2.048 3.072 5.12 6.144 7.168 9.216 16.384 19.456 24.576 38.912 24.576 58.368s-8.192 39.936-24.576 59.392z'
    ]
  ],
  prefix: 'fd',
  iconName: 'branded-coasters'
};
export const flyering = {
  icon: [
    973,
    1000,
    [],
    '',
    [
      'M744.448 755.712l-562.176 50.176-3.072-35.84 562.176-50.176zM186.368 850.944l3.072 35.84 563.2-50.176-4.096-35.84zM712.704 449.536l-188.416-157.696-189.44 227.328-75.776-63.488-94.208 112.64 9.216 104.448 553.984-49.152zM253.952 385.024c52.843-5.066 93.835-49.235 93.835-102.979 0-57.119-46.305-103.424-103.424-103.424s-103.424 46.305-103.424 103.424c0 3.087 0.135 6.143 0.4 9.162l-0.028-0.391c4.665 53.219 49.019 94.653 103.051 94.653 3.376 0 6.715-0.162 10.008-0.478l-0.419 0.033zM972.8 80.896l-45.056 860.16c-1.122 22.289-19.467 39.936-41.934 39.936-0.018 0-0.035 0-0.053 0h-2.045l-171.008-9.216-589.824 52.224c-0.054 0-0.118 0-0.182 0-24.007 0-43.727-18.359-45.884-41.803l-0.013-0.181-76.8-858.112c-0.073-0.971-0.114-2.103-0.114-3.244 0-24.048 18.421-43.793 41.921-45.895l0.177-0.013 53.248-5.12c3.87-18.998 20.162-33.187 39.872-33.79l42.048-1.026c3.529-19.917 20.707-34.848 41.373-34.848 0.575 0 1.147 0.012 1.717 0.034l-0.082-0.003 409.6 21.504 122.88-11.264c0.987-0.075 2.138-0.118 3.299-0.118 9.883 0 19.039 3.111 26.542 8.407l-0.145-0.097 65.536-2.048c0.32-0.009 0.697-0.014 1.075-0.014 14.402 0 27.11 7.251 34.672 18.302l0.093 0.144 49.152 3.072c22.295 1.115 39.95 19.463 39.95 41.935 0 0.377-0.005 0.754-0.015 1.129l0.001-0.055zM839.68 914.432l-76.8-858.112c0-2.828-2.292-5.12-5.12-5.12v0h-1.024l-710.656 63.488c-0.031-0.001-0.067-0.001-0.104-0.001-2.828 0-5.12 2.292-5.12 5.12 0 0.363 0.038 0.717 0.11 1.058l-0.006-0.033 76.8 858.112c0.493 2.354 2.551 4.097 5.017 4.097 0.036 0 0.073 0 0.109-0.001h-0.005l711.68-63.488c2.828 0 5.12-2.292 5.12-5.12v0zM882.688 918.528l-23.552-852.992-55.296-3.072 75.776 847.872c0.199 1.61 0.313 3.473 0.313 5.364 0 3.913-0.488 7.711-1.405 11.339l0.068-0.318c2.493-1.676 4.111-4.485 4.111-7.673 0-0.183-0.005-0.364-0.016-0.544l0.001 0.025zM941.056 78.848c-0.482-4.884-4.332-8.734-9.174-9.213l-0.042-0.003-39.936-3.072 16.384 627.712z'
    ]
  ],
  prefix: 'fd',
  iconName: 'flyering'
};
export const postering = {
  icon: [
    729,
    1000,
    [],
    '',
    [
      'M457.728 489.472l157.696 157.696v156.672h-502.784v-94.208l94.208-94.208 62.464 62.464zM615.424 321.536h-506.88v115.712h506.88zM375.808 35.84c-13.125 0.564-23.552 11.342-23.552 24.555 0 13.573 11.003 24.576 24.576 24.576 13.565 0 24.564-10.991 24.576-24.553v-0.001c0-0.006 0-0.014 0-0.021 0-13.573-11.003-24.576-24.576-24.576-0.36 0-0.718 0.008-1.075 0.023l0.051-0.002zM729.088 208.896v669.696l-145.408 145.408h-535.552c-0.003 0-0.007 0-0.011 0-26.22 0-47.543-20.968-48.116-47.051l-0.001-0.053v-768c0.574-26.136 21.897-47.104 48.117-47.104 0.004 0 0.008 0 0.011 0h144.383v-1.024c2.969-4.672 6.353-8.707 10.198-12.25l0.042-0.038 131.072-131.072c10.91-10.8 25.924-17.472 42.496-17.472s31.586 6.672 42.501 17.477l131.067 131.067c3.485 3.584 6.539 7.617 9.060 11.995l0.156 0.293 1.024 1.024h121.856c25.786 0.56 46.544 21.318 47.103 47.051l0.001 0.053zM238.592 153.6h274.432l-114.688-115.712c-5.587-5.737-13.386-9.295-22.016-9.295s-16.429 3.559-22.009 9.289l-0.007 0.007zM666.624 887.808h-74.752v74.752zM692.224 208.896c0-0.015 0-0.033 0-0.051 0-5.655-4.585-10.24-10.24-10.24-0.361 0-0.717 0.019-1.068 0.055l0.044-0.004h-632.832c-0.307-0.033-0.663-0.051-1.024-0.051-5.655 0-10.24 4.585-10.24 10.24 0 0.018 0 0.036 0 0.054v-0.003 768c0 0.015 0 0.033 0 0.051 0 5.655 4.585 10.24 10.24 10.24 0.361 0 0.717-0.019 1.068-0.055l-0.044 0.004h513.024v-130.048h131.072z'
    ]
  ],
  prefix: 'fd',
  iconName: 'postering'
};
export const fullPage = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM113.664 120.832h610.304v782.336h-610.304v-782.336z'
    ]
  ],
  prefix: 'fd',
  iconName: 'full-page'
};
export const juniorPage = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM113.664 120.832h610.304v608.256h-610.304v-608.256z'
    ]
  ],
  prefix: 'fd',
  iconName: 'junior-page'
};
export const halfPage = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM113.664 120.832h610.304v391.168h-610.304v-391.168z'
    ]
  ],
  prefix: 'fd',
  iconName: 'half-page'
};
export const quarterPage = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM113.664 120.832h305.152v391.168h-305.152v-391.168z'
    ]
  ],
  prefix: 'fd',
  iconName: 'quarter-page'
};
export const largeRectangle = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM372.736 120.832h351.232v355.328h-351.232v-355.328z'
    ]
  ],
  prefix: 'fd',
  iconName: 'large-rectangle'
};
export const wideSkyscraper = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM515.072 120.832h208.896v572.416h-208.896v-572.416z'
    ]
  ],
  prefix: 'fd',
  iconName: 'wide-skyscraper'
};
export const halfPageDigital = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM121.856 489.472h247.808v413.696h-247.808v-413.696z'
    ]
  ],
  prefix: 'fd',
  iconName: 'half-page-digital'
};
export const button1 = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM523.264 594.944h193.536v142.336h-193.536v-142.336z'
    ]
  ],
  prefix: 'fd',
  iconName: 'button-1'
};
export const squarePopup = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM121.856 489.472h247.808v247.808h-247.808v-247.808z'
    ]
  ],
  prefix: 'fd',
  iconName: 'square-popup'
};
export const squareButton = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM523.264 704.512h193.536v193.536h-193.536v-193.536z'
    ]
  ],
  prefix: 'fd',
  iconName: 'square_button'
};
export const eighthPage = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM113.664 120.832h305.152v198.656h-305.152v-198.656z'
    ]
  ],
  prefix: 'fd',
  iconName: 'eighth-page'
};
export const rectangle = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM438.272 120.832h285.696v173.056h-285.696v-173.056z'
    ]
  ],
  prefix: 'fd',
  iconName: 'rectangle'
};
export const mediumRectangle = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM438.272 120.832h285.696v244.736h-285.696v-244.736z'
    ]
  ],
  prefix: 'fd',
  iconName: 'medium-rectangle'
};
export const skyscraper = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM601.088 120.832h122.88v572.416h-122.88v-572.416z'
    ]
  ],
  prefix: 'fd',
  iconName: 'skyscraper'
};
export const verticalBanner = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM606.208 120.832h117.76v239.616h-117.76v-239.616z'
    ]
  ],
  prefix: 'fd',
  iconName: 'vertical-banner'
};
export const leaderboard = {
  icon: [
    838,
    1000,
    [],
    '',
    [
      'M798.72 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h757.76c22.528 0 39.936-17.408 39.936-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM778.24 959.488h-717.824v-894.976h717.824v894.976zM113.664 120.832h456.704v84.992h-456.704v-84.992z'
    ]
  ],
  prefix: 'fd',
  iconName: 'leaderboard'
};
export const ribbon = {
  icon: [
    840,
    1000,
    [],
    '',
    [
      'M800.768 0h-758.784c-21.504 0-39.936 17.408-39.936 39.936v944.128c0 22.528 18.432 39.936 39.936 39.936h758.784c21.504 0 38.912-17.408 38.912-39.936v-944.128c0-22.528-17.408-39.936-38.912-39.936zM780.288 959.488h-717.824v-894.976h717.824v894.976zM115.712 823.296h610.304v79.872h-610.304v-79.872z'
    ]
  ],
  prefix: 'fd',
  iconName: 'ribbon'
};
export const inserts = {
  icon: [
    855,
    1000,
    [],
    '',
    [
      'M855.040 994.304c0 16.384-14.336 29.696-30.72 29.696h-703.488c-17.408 0-30.72-13.312-30.72-29.696v-24.576h683.008c17.408 0 30.72-13.312 30.72-29.696h-1.024v-849.92h21.504c16.384 0 29.696 13.312 29.696 29.696v874.496h1.024zM763.904 904.192v0-874.496c0-16.384-13.312-29.696-29.696-29.696h-704.512c-16.384 0-29.696 13.312-29.696 29.696v874.496c0 16.384 13.312 29.696 29.696 29.696h704.512c16.384 0 29.696-13.312 29.696-29.696z'
    ]
  ],
  prefix: 'fd',
  iconName: 'inserts'
};
export const stickers = {
  icon: [
    862,
    1000,
    [],
    '',
    [
      'M862.208 611.328c0 4.096 0 7.168 0 10.24v346.112c0 17.408 8.192 56.32-57.344 56.32h-478.208c-55.296 0-70.656-29.696-70.656-56.32 0-29.696 0-60.416 0-91.136 0-25.6 0-52.224 0-77.824 0-22.528 4.096-52.224-9.216-70.656-7.168-10.24-20.48-13.312-32.768-14.336-38.912-1.024-76.8 1.024-115.712 1.024-49.152-1.024-98.304 1.024-98.304-57.344v-586.752c0-58.368 49.152-70.656 98.304-70.656h657.408c48.128 0 106.496 12.288 106.496 70.656v540.672zM217.088 999.424v-211.968c0-14.336-11.264-27.648-25.6-27.648h-151.552c-7.168 0-11.264 8.192-7.168 15.36 50.176 77.824 114.688 162.816 156.672 228.352 8.192 13.312 27.648 16.384 27.648-4.096z'
    ]
  ],
  prefix: 'fd',
  iconName: 'stickers'
};
export const brandedCoastersMug = {
  icon: [
    1163,
    1000,
    [],
    '',
    [
      'M1163.264 884.736v139.264h-837.632v-139.264l93.184-140.288h-93.184c-1.242 0.021-2.708 0.032-4.176 0.032-75.884 0-144.438-31.385-193.389-81.883l-0.067-0.070c-50.567-49.018-81.952-117.572-81.952-193.456 0-1.468 0.012-2.934 0.035-4.396l-0.003 0.221v-232.448l-46.080-46.080 23.552-93.184h349.184l22.528-93.184h698.368l23.552 139.264-47.104 23.552v581.632zM418.816 558.080v-278.528h-186.368v186.368c0 51.464 41.72 93.184 93.184 93.184v0zM625.664 641.024v-345.088c0.018-0.306 0.028-0.664 0.028-1.024 0-10.18-8.252-18.432-18.432-18.432-0.010 0-0.020 0-0.030 0h-15.358c-0.008 0-0.018 0-0.028 0-10.18 0-18.432 8.252-18.432 18.432 0 0.36 0.010 0.718 0.031 1.073l-0.002-0.049v345.088c-0.018 0.306-0.028 0.664-0.028 1.024 0 10.18 8.252 18.432 18.432 18.432 0.010 0 0.020 0 0.030 0h15.358c0.008 0 0.018 0 0.028 0 10.18 0 18.432-8.252 18.432-18.432 0-0.36-0.010-0.718-0.031-1.073l0.002 0.049zM780.288 641.024v-345.088c0.018-0.306 0.028-0.664 0.028-1.024 0-10.18-8.252-18.432-18.432-18.432-0.010 0-0.020 0-0.030 0h-14.334c-0.315-0.019-0.683-0.030-1.054-0.030-10.18 0-18.432 8.252-18.432 18.432 0 0.371 0.011 0.739 0.033 1.105l-0.002-0.050v345.088c-0.019 0.315-0.030 0.683-0.030 1.054 0 10.18 8.252 18.432 18.432 18.432 0.371 0 0.739-0.011 1.105-0.033l-0.050 0.002h14.336c0.008 0 0.018 0 0.028 0 10.18 0 18.432-8.252 18.432-18.432 0-0.36-0.010-0.718-0.031-1.073l0.002 0.049zM939.008 641.024v-345.088c0.018-0.306 0.028-0.664 0.028-1.024 0-10.18-8.252-18.432-18.432-18.432-0.010 0-0.020 0-0.030 0h-14.334c-0.008 0-0.018 0-0.028 0-10.18 0-18.432 8.252-18.432 18.432 0 0.36 0.010 0.718 0.031 1.073l-0.002-0.049v345.088c-0.018 0.306-0.028 0.664-0.028 1.024 0 10.18 8.252 18.432 18.432 18.432 0.010 0 0.020 0 0.030 0h14.334c0.315 0.019 0.683 0.030 1.054 0.030 10.18 0 18.432-8.252 18.432-18.432 0-0.371-0.011-0.739-0.033-1.105l0.002 0.050s0 0 0 0z'
    ]
  ],
  prefix: 'fd',
  iconName: 'branded-coasters-mug'
};
export const bank = {
  icon: [
    1169,
    1000,
    [],
    '',
    [
      'M548.864 0l547.84 219.136v73.728h-72.704q0 14.336-11.264 25.6t-27.648 10.24h-872.448q-16.384 0-27.648-10.24t-12.288-25.6h-72.704v-73.728zM146.432 365.568h146.432v439.296h72.704v-439.296h146.432v439.296h72.704v-439.296h146.432v439.296h73.728v-439.296h146.432v439.296h33.792q15.36 0 27.648 10.24t11.264 25.6v36.864h-951.296v-36.864q0-14.336 12.288-25.6t27.648-10.24h33.792v-439.296zM1057.792 914.432q16.384 0 27.648 11.264t11.264 25.6v72.704h-1096.704v-72.704q0-15.36 11.264-25.6t28.672-11.264h1017.856z'
    ]
  ],
  prefix: 'fd',
  iconName: 'bank'
};
export const productSampling = {
  icon: [
    767,
    1000,
    [],
    '',
    [
      'M88.064 662.528h-48.128v-459.776h48.128zM256 580.608h-121.856v90.112h121.856zM728.064 201.728h-47.104v493.568h47.104zM373.76 663.552v-105.472h19.456v105.472h155.648v-105.472h19.456v105.472h58.368v-124.928c0-32.236-26.132-58.368-58.368-58.368v0h-194.56c-0.305-0.006-0.664-0.009-1.024-0.009-32.236 0-58.368 26.132-58.368 58.368 0 0.003 0 0.006 0 0.010v-0.001s0 0 0 0v124.928zM471.040 471.040c0.229 0.003 0.5 0.004 0.772 0.004 37.891 0 68.608-30.717 68.608-68.608s-30.717-68.608-68.608-68.608c-37.891 0-68.608 30.717-68.608 68.608 0 18.753 7.524 35.748 19.717 48.132l-0.009-0.009c11.971 12.626 28.865 20.482 47.593 20.482 0.188 0 0.376-0.001 0.563-0.002h-0.029zM766.976 160.768v-118.784c0-23.187-18.797-41.984-41.984-41.984v0h-683.008c-23.187 0-41.984 18.797-41.984 41.984v0 118.784c0 23.187 18.797 41.984 41.984 41.984v0h681.984c0.305 0.008 0.664 0.012 1.024 0.012 23.187 0 41.984-18.797 41.984-41.984 0-0.004 0-0.009 0-0.013v0.001zM766.976 979.968v-272.384c0.008-0.305 0.012-0.664 0.012-1.024 0-24.318-19.714-44.032-44.032-44.032-0.004 0-0.008 0-0.013 0h-678.911c-0.004 0-0.008 0-0.012 0-24.318 0-44.032 19.714-44.032 44.032 0 0.36 0.004 0.719 0.013 1.077l-0.001-0.053v272.384c0 24.318 19.714 44.032 44.032 44.032v0h678.912c24.318 0 44.032-19.714 44.032-44.032v0 0z'
    ]
  ],
  prefix: 'fd',
  iconName: 'product-sampling'
};
export const mail = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M951.296 859.136v-438.272q-18.432 20.48-39.936 36.864-152.576 117.76-243.712 193.536-28.672 24.576-47.104 37.888t-49.152 28.672-58.368 13.312h-2.048q-26.624 0-58.368-13.312t-49.152-28.672-47.104-37.888q-90.112-75.776-243.712-193.536-21.504-16.384-39.936-36.864v438.272q0 7.168 6.144 13.312t12.288 5.12h841.728q7.168 0 12.288-5.12t6.144-13.312zM951.296 259.072v-14.336t-1.024-7.168-1.024-7.168-3.072-5.12-5.12-4.096-8.192-2.048h-841.728q-7.168 0-12.288 6.144t-6.144 12.288q0 96.256 84.992 162.816 109.568 86.016 228.352 180.224 4.096 3.072 20.48 17.408t25.6 21.504 25.6 17.408 28.672 16.384 24.576 5.12h2.048q11.264 0 24.576-5.12t28.672-16.384 25.6-17.408 25.6-21.504 20.48-17.408q118.784-94.208 229.376-180.224 30.72-24.576 57.344-66.56t26.624-74.752zM1024 237.568v621.568q0 37.888-26.624 64.512t-64.512 27.648h-841.728q-36.864 0-64.512-27.648t-26.624-64.512v-621.568q0-37.888 26.624-64.512t64.512-26.624h841.728q37.888 0 64.512 26.624t26.624 64.512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'mail'
};
export const mailAlt = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1024 405.504v453.632q0 37.888-26.624 64.512t-64.512 27.648h-841.728q-36.864 0-64.512-27.648t-26.624-64.512v-453.632q25.6 27.648 57.344 50.176 206.848 140.288 284.672 196.608 32.768 24.576 52.224 37.888t54.272 27.648 62.464 13.312h2.048q28.672 0 62.464-13.312t54.272-27.648 52.224-37.888q97.28-69.632 284.672-196.608 32.768-22.528 57.344-50.176zM1024 237.568q0 45.056-27.648 86.016t-69.632 70.656q-215.040 149.504-268.288 185.344-5.12 4.096-23.552 17.408t-30.72 22.528-29.696 18.432-32.768 15.36-28.672 5.12h-2.048q-12.288 0-27.648-5.12t-32.768-15.36-30.72-18.432-30.72-22.528-23.552-17.408q-52.224-35.84-150.528-103.424t-116.736-81.92q-35.84-23.552-66.56-65.536t-31.744-78.848q0-44.032 23.552-73.728t67.584-29.696h841.728q36.864 0 64.512 26.624t26.624 64.512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'mail-alt'
};
export const heartEmpty = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M951.296 340.992q0-47.104-12.288-81.92t-31.744-56.32-47.104-33.792-53.248-18.432-56.32-4.096-63.488 14.336-63.488 36.864-49.152 40.96-34.816 34.816q-10.24 13.312-27.648 13.312t-27.648-13.312q-14.336-15.36-34.816-34.816t-49.152-40.96-63.488-36.864-63.488-14.336-56.32 4.096-53.248 18.432-47.104 33.792-31.744 56.32-12.288 81.92q0 95.232 107.52 202.752l331.776 319.488 331.776-319.488q107.52-107.52 107.52-202.752zM1024 340.992q0 125.952-131.072 257.024l-355.328 343.040q-10.24 10.24-25.6 10.24t-25.6-10.24l-356.352-344.064q-5.12-5.12-15.36-15.36t-31.744-37.888-38.912-55.296-30.72-68.608-13.312-78.848q0-125.952 72.704-196.608t200.704-71.68q34.816 0 71.68 12.288t68.608 33.792 55.296 38.912 43.008 38.912q20.48-20.48 43.008-38.912t55.296-38.912 68.608-33.792 71.68-12.288q128 0 200.704 71.68t72.704 196.608z'
    ]
  ],
  prefix: 'fd',
  iconName: 'heart-empty'
};
export const heart = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 951.296q-14.336 0-25.6-10.24l-356.352-344.064q-5.12-5.12-15.36-15.36t-31.744-37.888-38.912-55.296-30.72-68.608-13.312-78.848q0-125.952 72.704-196.608t200.704-71.68q34.816 0 71.68 12.288t68.608 33.792 55.296 38.912 43.008 38.912q20.48-20.48 43.008-38.912t55.296-38.912 68.608-33.792 71.68-12.288q128 0 200.704 71.68t72.704 196.608q0 125.952-131.072 257.024l-355.328 343.040q-10.24 10.24-25.6 10.24z'
    ]
  ],
  prefix: 'fd',
  iconName: 'heart'
};
export const bellAlt = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M521.216 968.704q0-8.192-9.216-8.192-33.792 0-58.368-24.576t-23.552-58.368q0-9.216-9.216-9.216t-9.216 9.216q0 41.984 29.696 71.68t70.656 28.672q9.216 0 9.216-9.216zM987.136 804.864q0 29.696-21.504 51.2t-51.2 21.504h-256q0 60.416-43.008 103.424t-103.424 43.008-103.424-43.008-43.008-103.424h-256q-29.696 0-51.2-21.504t-21.504-51.2q28.672-24.576 52.224-50.176t48.128-68.608 43.008-91.136 27.648-117.76 11.264-148.48q0-86.016 67.584-160.768t175.104-91.136q-5.12-10.24-5.12-21.504 0-23.552 16.384-38.912t38.912-16.384 38.912 16.384 16.384 38.912q0 11.264-5.12 21.504 108.544 16.384 175.104 91.136t67.584 160.768q0 79.872 11.264 148.48t28.672 117.76 41.984 91.136 49.152 68.608 51.2 50.176z'
    ]
  ],
  prefix: 'fd',
  iconName: 'bell-alt'
};
export const trashEmpty = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M292.864 420.864v328.704q0 8.192-5.12 13.312t-13.312 5.12h-36.864q-8.192 0-13.312-5.12t-5.12-13.312v-328.704q0-8.192 5.12-13.312t13.312-5.12h36.864q8.192 0 13.312 5.12t5.12 13.312zM439.296 420.864v328.704q0 8.192-5.12 13.312t-13.312 5.12h-36.864q-8.192 0-13.312-5.12t-5.12-13.312v-328.704q0-8.192 5.12-13.312t13.312-5.12h36.864q8.192 0 13.312 5.12t5.12 13.312zM584.704 420.864v328.704q0 8.192-5.12 13.312t-12.288 5.12h-36.864q-8.192 0-13.312-5.12t-5.12-13.312v-328.704q0-8.192 5.12-13.312t13.312-5.12h36.864q7.168 0 12.288 5.12t5.12 13.312zM658.432 834.56v-541.696h-512v541.696q0 12.288 4.096 22.528t8.192 15.36 6.144 5.12h475.136q2.048 0 6.144-5.12t8.192-15.36 4.096-22.528zM274.432 219.136h256l-27.648-66.56q-4.096-5.12-9.216-6.144h-181.248q-6.144 1.024-10.24 6.144zM804.864 237.568v36.864q0 8.192-5.12 13.312t-13.312 5.12h-55.296v541.696q0 47.104-26.624 81.92t-64.512 34.816h-475.136q-37.888 0-64.512-33.792t-27.648-80.896v-543.744h-54.272q-8.192 0-13.312-5.12t-5.12-13.312v-36.864q0-8.192 5.12-13.312t13.312-5.12h176.128l39.936-95.232q9.216-21.504 31.744-35.84t45.056-15.36h182.272q23.552 0 45.056 15.36t30.72 35.84l39.936 95.232h177.152q8.192 0 13.312 5.12t5.12 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'trash-empty'
};
export const pencil = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M207.872 877.568l51.2-52.224-134.144-134.144-52.224 52.224v61.44h73.728v72.704h61.44zM505.856 347.136q0-12.288-12.288-12.288-5.12 0-9.216 4.096l-310.272 309.248q-4.096 4.096-4.096 10.24 0 12.288 13.312 12.288 5.12 0 9.216-4.096l310.272-309.248q3.072-4.096 3.072-10.24zM475.136 237.568l237.568 237.568-475.136 476.16h-237.568v-238.592zM865.28 292.864q0 29.696-20.48 51.2l-95.232 95.232-237.568-238.592 95.232-94.208q20.48-21.504 51.2-21.504 29.696 0 52.224 21.504l134.144 134.144q20.48 22.528 20.48 52.224z'
    ]
  ],
  prefix: 'fd',
  iconName: 'pencil'
};
export const printer = {
  icon: [
    950.8571428571428,
    1000,
    [],
    '',
    [
      'M219.429 877.714h512v-146.286h-512v146.286zM219.429 512h512v-219.429h-91.429c-30.286 0-54.857-24.571-54.857-54.857v-91.429h-365.714v365.714zM877.714 548.571c0-20-16.571-36.571-36.571-36.571s-36.571 16.571-36.571 36.571 16.571 36.571 36.571 36.571 36.571-16.571 36.571-36.571zM950.857 548.571v237.714c0 9.714-8.571 18.286-18.286 18.286h-128v91.429c0 30.286-24.571 54.857-54.857 54.857h-548.571c-30.286 0-54.857-24.571-54.857-54.857v-91.429h-128c-9.714 0-18.286-8.571-18.286-18.286v-237.714c0-60 49.714-109.714 109.714-109.714h36.571v-310.857c0-30.286 24.571-54.857 54.857-54.857h384c30.286 0 72 17.143 93.714 38.857l86.857 86.857c21.714 21.714 38.857 63.429 38.857 93.714v146.286h36.571c60 0 109.714 49.714 109.714 109.714z'
    ]
  ],
  prefix: 'fd',
  iconName: 'printer'
};
export const type = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M896 0h-768c-17.664 0-32 14.336-32 32v192c0 17.664 14.336 32 32 32h32c17.664 0 32-14.336 32-32l64-96h192v768l-160 64c-17.664 0-32 14.304-32 32s14.336 32 32 32h448c17.696 0 32-14.304 32-32s-14.304-32-32-32l-160-64v-768h192l64 96c0 17.664 14.304 32 32 32h32c17.696 0 32-14.336 32-32v-192c0-17.664-14.304-32-32-32z'
    ]
  ],
  prefix: 'fd',
  iconName: 'type'
};
export const ellipsis = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M219.136 420.864v109.568q0 22.528-15.36 38.912t-38.912 15.36h-109.568q-23.552 0-38.912-15.36t-16.384-38.912v-109.568q0-23.552 16.384-38.912t38.912-16.384h109.568q22.528 0 38.912 16.384t15.36 38.912zM512 420.864v109.568q0 22.528-16.384 38.912t-38.912 15.36h-109.568q-22.528 0-38.912-15.36t-15.36-38.912v-109.568q0-23.552 15.36-38.912t38.912-16.384h109.568q23.552 0 38.912 16.384t16.384 38.912zM804.864 420.864v109.568q0 22.528-16.384 38.912t-38.912 15.36h-109.568q-22.528 0-38.912-15.36t-16.384-38.912v-109.568q0-23.552 16.384-38.912t38.912-16.384h109.568q23.552 0 38.912 16.384t16.384 38.912z'
    ]
  ],
  prefix: 'fd',
  iconName: 'ellipsis'
};
export const ellipsisV = {
  icon: [
    219.42857142857142,
    1000,
    [],
    '',
    [
      'M219.429 713.143v109.714c0 30.286-24.571 54.857-54.857 54.857h-109.714c-30.286 0-54.857-24.571-54.857-54.857v-109.714c0-30.286 24.571-54.857 54.857-54.857h109.714c30.286 0 54.857 24.571 54.857 54.857zM219.429 420.571v109.714c0 30.286-24.571 54.857-54.857 54.857h-109.714c-30.286 0-54.857-24.571-54.857-54.857v-109.714c0-30.286 24.571-54.857 54.857-54.857h109.714c30.286 0 54.857 24.571 54.857 54.857zM219.429 128v109.714c0 30.286-24.571 54.857-54.857 54.857h-109.714c-30.286 0-54.857-24.571-54.857-54.857v-109.714c0-30.286 24.571-54.857 54.857-54.857h109.714c30.286 0 54.857 24.571 54.857 54.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'ellipsis-v'
};
export const sliders = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M200.704 804.864v72.704h-200.704v-72.704h200.704zM402.432 731.136q14.336 0 25.6 11.264t11.264 25.6v146.432q0 14.336-11.264 25.6t-25.6 11.264h-146.432q-14.336 0-25.6-11.264t-11.264-25.6v-146.432q0-15.36 11.264-25.6t25.6-11.264h146.432zM493.568 512v72.704h-493.568v-72.704h493.568zM128 219.136v73.728h-128v-73.728h128zM877.568 804.864v72.704h-420.864v-72.704h420.864zM328.704 146.432q15.36 0 26.624 10.24t10.24 26.624v145.408q0 15.36-10.24 25.6t-26.624 11.264h-145.408q-15.36 0-25.6-11.264t-11.264-25.6v-145.408q0-15.36 11.264-26.624t25.6-10.24h145.408zM695.296 439.296q14.336 0 25.6 10.24t10.24 25.6v146.432q0 15.36-10.24 25.6t-25.6 11.264h-146.432q-15.36 0-25.6-11.264t-11.264-25.6v-146.432q0-14.336 11.264-25.6t25.6-10.24h146.432zM877.568 512v72.704h-128v-72.704h128zM877.568 219.136v73.728h-493.568v-73.728h493.568z'
    ]
  ],
  prefix: 'fd',
  iconName: 'sliders'
};
export const music = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M960 0h64v736c0 88.366-100.29 160-224 160s-224-71.634-224-160c0-88.368 100.29-160 224-160 62.684 0 119.342 18.4 160 48.040v-368.040l-512 113.778v494.222c0 88.366-100.288 160-224 160s-224-71.634-224-160c0-88.368 100.288-160 224-160 62.684 0 119.342 18.4 160 48.040v-624.040l576-128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'music'
};
export const filter = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M801.792 168.96q9.216 22.528-8.192 39.936l-281.6 281.6v423.936q0 23.552-22.528 33.792-7.168 3.072-14.336 3.072-15.36 0-25.6-11.264l-146.432-146.432q-10.24-11.264-10.24-25.6v-277.504l-281.6-281.6q-18.432-17.408-8.192-39.936 9.216-22.528 33.792-22.528h731.136q23.552 0 33.792 22.528z'
    ]
  ],
  prefix: 'fd',
  iconName: 'filter'
};
export const sortAmountAsc = {
  icon: [
    1040.6034285714286,
    1000,
    [],
    '',
    [
      'M420.571 822.857c0 5.143-2.286 9.714-5.714 13.714l-182.286 182.286c-4 3.429-8.571 5.143-13.143 5.143s-9.143-1.714-13.143-5.143l-182.857-182.857c-5.143-5.714-6.857-13.143-4-20s9.714-11.429 17.143-11.429h109.714v-786.286c0-10.286 8-18.286 18.286-18.286h109.714c10.286 0 18.286 8 18.286 18.286v786.286h109.714c10.286 0 18.286 8 18.286 18.286zM1024 896v109.714c0 10.286-8 18.286-18.286 18.286h-475.429c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h475.429c10.286 0 18.286 8 18.286 18.286zM914.286 603.429v109.714c0 10.286-8 18.286-18.286 18.286h-365.714c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h365.714c10.286 0 18.286 8 18.286 18.286zM804.571 310.857v109.714c0 10.286-8 18.286-18.286 18.286h-256c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h256c10.286 0 18.286 8 18.286 18.286zM694.857 18.286v109.714c0 10.286-8 18.286-18.286 18.286h-146.286c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h146.286c10.286 0 18.286 8 18.286 18.286z'
    ]
  ],
  prefix: 'fd',
  iconName: 'sort-amount-asc'
};
export const sortAmountDesc = {
  icon: [
    1040.6034285714286,
    1000,
    [],
    '',
    [
      'M694.857 896v109.714c0 10.286-8 18.286-18.286 18.286h-146.286c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h146.286c10.286 0 18.286 8 18.286 18.286zM420.571 822.857c0 5.143-2.286 9.714-5.714 13.714l-182.286 182.286c-4 3.429-8.571 5.143-13.143 5.143s-9.143-1.714-13.143-5.143l-182.857-182.857c-5.143-5.714-6.857-13.143-4-20s9.714-11.429 17.143-11.429h109.714v-786.286c0-10.286 8-18.286 18.286-18.286h109.714c10.286 0 18.286 8 18.286 18.286v786.286h109.714c10.286 0 18.286 8 18.286 18.286zM804.571 603.429v109.714c0 10.286-8 18.286-18.286 18.286h-256c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h256c10.286 0 18.286 8 18.286 18.286zM914.286 310.857v109.714c0 10.286-8 18.286-18.286 18.286h-365.714c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h365.714c10.286 0 18.286 8 18.286 18.286zM1024 18.286v109.714c0 10.286-8 18.286-18.286 18.286h-475.429c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h475.429c10.286 0 18.286 8 18.286 18.286z'
    ]
  ],
  prefix: 'fd',
  iconName: 'sort-amount-desc'
};
export const percent = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M731.429 731.429c0-40-33.143-73.143-73.143-73.143s-73.143 33.143-73.143 73.143 33.143 73.143 73.143 73.143 73.143-33.143 73.143-73.143zM292.571 292.571c0-40-33.143-73.143-73.143-73.143s-73.143 33.143-73.143 73.143 33.143 73.143 73.143 73.143 73.143-33.143 73.143-73.143zM877.714 731.429c0 121.143-98.286 219.429-219.429 219.429s-219.429-98.286-219.429-219.429 98.286-219.429 219.429-219.429 219.429 98.286 219.429 219.429zM822.857 109.714c0 8-2.857 15.429-7.429 21.714l-603.429 804.571c-6.857 9.143-17.714 14.857-29.143 14.857h-91.429c-20 0-36.571-16.571-36.571-36.571 0-8 2.857-15.429 7.429-21.714l603.429-804.571c6.857-9.143 17.714-14.857 29.143-14.857h91.429c20 0 36.571 16.571 36.571 36.571zM438.857 292.571c0 121.143-98.286 219.429-219.429 219.429s-219.429-98.286-219.429-219.429 98.286-219.429 219.429-219.429 219.429 98.286 219.429 219.429z'
    ]
  ],
  prefix: 'fd',
  iconName: 'percent'
};
export const dashboard = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M219.136 658.432q0-30.72-21.504-52.224t-51.2-21.504-52.224 21.504-21.504 52.224 21.504 51.2 52.224 21.504 51.2-21.504 21.504-51.2zM328.704 402.432q0-30.72-20.48-52.224t-52.224-21.504-51.2 21.504-21.504 52.224 21.504 51.2 51.2 21.504 52.224-21.504 20.48-51.2zM573.44 676.864l58.368-218.112q3.072-14.336-5.12-27.648t-21.504-16.384-27.648 3.072-17.408 22.528l-57.344 218.112q-33.792 3.072-61.44 25.6t-35.84 56.32q-11.264 44.032 11.264 82.944t67.584 51.2 82.944-11.264 51.2-67.584q9.216-33.792-4.096-66.56t-40.96-52.224zM951.296 658.432q0-30.72-21.504-52.224t-52.224-21.504-51.2 21.504-21.504 52.224 21.504 51.2 51.2 21.504 52.224-21.504 21.504-51.2zM584.704 292.864q0-30.72-20.48-52.224t-52.224-21.504-51.2 21.504-21.504 52.224 21.504 51.2 51.2 21.504 52.224-21.504 20.48-51.2zM840.704 402.432q0-30.72-20.48-52.224t-52.224-21.504-51.2 21.504-21.504 52.224 21.504 51.2 51.2 21.504 52.224-21.504 20.48-51.2zM1024 658.432q0 148.48-80.896 275.456-10.24 17.408-30.72 17.408h-800.768q-20.48 0-30.72-17.408-80.896-125.952-80.896-275.456 0-104.448 40.96-198.656t108.544-163.84 163.84-109.568 198.656-39.936 198.656 39.936 163.84 109.568 108.544 163.84 40.96 198.656z'
    ]
  ],
  prefix: 'fd',
  iconName: 'dashboard'
};
export const chartPie = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M439.296 508.928l311.296 311.296q-60.416 62.464-141.312 96.256t-169.984 34.816q-119.808 0-221.184-59.392t-158.72-159.744-59.392-220.16 59.392-220.16 158.72-159.744 221.184-59.392v436.224zM545.792 512h441.344q0 90.112-33.792 171.008t-96.256 141.312zM951.296 439.296h-439.296v-439.296q119.808 0 220.16 58.368t159.744 159.744 59.392 221.184z'
    ]
  ],
  prefix: 'fd',
  iconName: 'chart-pie'
};
export const chartLine = {
  icon: [
    1169,
    1000,
    [],
    '',
    [
      'M1170.432 877.568v73.728h-1170.432v-878.592h72.704v804.864h1097.728zM1096.704 164.864v247.808q0 12.288-10.24 17.408t-20.48-4.096l-69.632-69.632-361.472 361.472q-6.144 6.144-13.312 6.144t-13.312-6.144l-133.12-133.12-237.568 238.592-109.568-110.592 334.848-333.824q5.12-6.144 12.288-6.144t13.312 6.144l133.12 133.12 265.216-265.216-68.608-69.632q-9.216-8.192-5.12-19.456t17.408-11.264h248.832q7.168 0 12.288 5.12t5.12 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'chart-line'
};
export const medium = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M340.992 240.64v670.72q0 14.336-7.168 23.552t-20.48 10.24q-10.24 0-19.456-4.096l-265.216-134.144q-12.288-5.12-20.48-18.432t-8.192-26.624v-651.264q0-12.288 6.144-19.456t16.384-8.192q8.192 0 24.576 8.192l292.864 146.432q1.024 2.048 1.024 3.072zM377.856 297.984l305.152 495.616-305.152-152.576v-343.040zM1024 308.224v603.136q0 14.336-8.192 22.528t-21.504 9.216-26.624-7.168l-251.904-125.952zM1021.952 239.616q0 2.048-146.432 239.616t-171.008 278.528l-223.232-361.472 185.344-301.056q9.216-16.384 29.696-16.384 8.192 0 14.336 3.072l309.248 154.624q2.048 1.024 2.048 3.072z'
    ]
  ],
  prefix: 'fd',
  iconName: 'medium'
};
export const link = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M832.512 695.296q0-23.552-16.384-38.912l-118.784-118.784q-16.384-16.384-38.912-16.384-24.576 0-40.96 18.432 1.024 1.024 10.24 10.24t12.288 12.288 9.216 11.264 7.168 14.336 2.048 15.36q0 23.552-16.384 38.912t-38.912 16.384q-8.192 0-15.36-2.048t-14.336-7.168-11.264-9.216-12.288-12.288-10.24-10.24q-19.456 17.408-19.456 40.96t16.384 38.912l117.76 118.784q15.36 15.36 38.912 15.36 22.528 0 38.912-15.36l83.968-82.944q16.384-16.384 16.384-37.888zM430.080 291.84q0-22.528-15.36-38.912l-117.76-117.76q-16.384-16.384-38.912-16.384t-38.912 15.36l-83.968 83.968q-16.384 15.36-16.384 37.888t16.384 38.912l118.784 118.784q15.36 15.36 38.912 15.36t40.96-17.408q-2.048-2.048-11.264-11.264t-12.288-12.288-8.192-10.24-7.168-14.336-2.048-16.384q0-22.528 15.36-38.912t38.912-15.36q9.216 0 16.384 2.048t14.336 7.168 11.264 8.192 12.288 12.288 10.24 11.264q18.432-17.408 18.432-41.984zM942.080 695.296q0 67.584-49.152 115.712l-83.968 82.944q-47.104 48.128-115.712 48.128-69.632 0-116.736-49.152l-117.76-117.76q-47.104-48.128-47.104-116.736 0-69.632 50.176-118.784l-50.176-50.176q-49.152 50.176-118.784 50.176-68.608 0-116.736-48.128l-118.784-118.784q-48.128-48.128-48.128-116.736t48.128-115.712l83.968-83.968q48.128-47.104 116.736-47.104t116.736 48.128l117.76 118.784q47.104 47.104 47.104 115.712 0 70.656-50.176 119.808l50.176 50.176q49.152-50.176 118.784-50.176 68.608 0 116.736 48.128l118.784 118.784q48.128 48.128 48.128 116.736z'
    ]
  ],
  prefix: 'fd',
  iconName: 'link'
};
export const infoCircled = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M584.704 786.432v-91.136q0-8.192-5.12-13.312t-12.288-5.12h-55.296v-292.864q0-8.192-5.12-13.312t-13.312-5.12h-182.272q-8.192 0-13.312 5.12t-5.12 13.312v91.136q0 8.192 5.12 13.312t13.312 5.12h54.272v183.296h-54.272q-8.192 0-13.312 5.12t-5.12 13.312v91.136q0 8.192 5.12 13.312t13.312 5.12h256q7.168 0 12.288-5.12t5.12-13.312zM512 274.432v-91.136q0-8.192-5.12-13.312t-13.312-5.12h-109.568q-8.192 0-13.312 5.12t-5.12 13.312v91.136q0 8.192 5.12 13.312t13.312 5.12h109.568q8.192 0 13.312-5.12t5.12-13.312zM877.568 512q0 119.808-58.368 220.16t-159.744 159.744-220.16 59.392-221.184-59.392-158.72-159.744-59.392-220.16 59.392-220.16 158.72-159.744 221.184-59.392 220.16 59.392 159.744 159.744 58.368 220.16z'
    ]
  ],
  prefix: 'fd',
  iconName: 'info-circled'
};
export const helpCircled = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M512 786.432v-109.568q0-8.192-5.12-13.312t-13.312-5.12h-109.568q-8.192 0-13.312 5.12t-5.12 13.312v109.568q0 8.192 5.12 13.312t13.312 5.12h109.568q8.192 0 13.312-5.12t5.12-13.312zM658.432 402.432q0-50.176-31.744-93.184t-78.848-66.56-97.28-23.552q-139.264 0-211.968 121.856-9.216 13.312 4.096 24.576l75.776 56.32q4.096 4.096 10.24 4.096 9.216 0 14.336-7.168 30.72-38.912 49.152-52.224 19.456-14.336 49.152-14.336 27.648 0 49.152 15.36t21.504 33.792q0 21.504-11.264 34.816t-38.912 25.6q-35.84 15.36-66.56 49.152t-29.696 71.68v20.48q0 8.192 5.12 13.312t13.312 5.12h109.568q8.192 0 13.312-5.12t5.12-13.312q0-10.24 12.288-27.648t30.72-28.672q18.432-10.24 28.672-16.384t25.6-19.456 25.6-27.648 16.384-34.816 7.168-46.080zM877.568 512q0 119.808-58.368 220.16t-159.744 159.744-220.16 59.392-221.184-59.392-158.72-159.744-59.392-220.16 59.392-220.16 158.72-159.744 221.184-59.392 220.16 59.392 159.744 159.744 58.368 220.16z'
    ]
  ],
  prefix: 'fd',
  iconName: 'help-circled'
};
export const exclamationCircle = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M438.857 73.143c242.286 0 438.857 196.571 438.857 438.857s-196.571 438.857-438.857 438.857-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857zM512 785.714v-108.571c0-10.286-8-18.857-17.714-18.857h-109.714c-10.286 0-18.857 8.571-18.857 18.857v108.571c0 10.286 8.571 18.857 18.857 18.857h109.714c9.714 0 17.714-8.571 17.714-18.857zM510.857 589.143l10.286-354.857c0-4-1.714-8-5.714-10.286-3.429-2.857-8.571-4.571-13.714-4.571h-125.714c-5.143 0-10.286 1.714-13.714 4.571-4 2.286-5.714 6.286-5.714 10.286l9.714 354.857c0 8 8.571 14.286 19.429 14.286h105.714c10.286 0 18.857-6.286 19.429-14.286z'
    ]
  ],
  prefix: 'fd',
  iconName: 'exclamation-circle'
};
export const attention = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M584.704 785.408v-108.544q0-8.192-5.12-13.312t-12.288-5.12h-110.592q-7.168 0-12.288 5.12t-5.12 13.312v108.544q0 8.192 5.12 13.312t12.288 6.144h110.592q7.168 0 12.288-6.144t5.12-13.312zM583.68 572.416l10.24-263.168q0-6.144-5.12-10.24-7.168-6.144-14.336-6.144h-124.928q-6.144 0-14.336 6.144-5.12 4.096-5.12 12.288l9.216 261.12q0 5.12 6.144 9.216t13.312 3.072h105.472q8.192 0 14.336-3.072t5.12-9.216zM576.512 37.888l438.272 804.864q20.48 35.84-1.024 71.68-9.216 17.408-26.624 26.624t-35.84 10.24h-878.592q-18.432 0-35.84-10.24t-26.624-26.624q-21.504-35.84-1.024-71.68l439.296-804.864q9.216-17.408 26.624-27.648t36.864-10.24 36.864 10.24 27.648 27.648z'
    ]
  ],
  prefix: 'fd',
  iconName: 'attention'
};
export const warning = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 92.774l429.102 855.226h-858.206l429.104-855.226zM512 0c-22.070 0-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.3 0 96.792-48.708 63.3-108.24h0.002l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648v0z',
      'M576 832c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z',
      'M512 704c-35.346 0-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192c0 35.346-28.654 64-64 64z'
    ]
  ],
  prefix: 'fd',
  iconName: 'warning'
};
export const calendarCheckO = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M744.448 550.912l-292.864 292.864q-5.12 5.12-12.288 5.12t-13.312-5.12l-164.864-164.864q-5.12-6.144-5.12-13.312t5.12-12.288l26.624-26.624q5.12-5.12 12.288-5.12t13.312 5.12l125.952 125.952 252.928-253.952q6.144-5.12 13.312-5.12t13.312 5.12l25.6 26.624q5.12 5.12 5.12 12.288t-5.12 13.312zM72.704 951.296h804.864v-585.728h-804.864v585.728zM292.864 256v-164.864q0-8.192-5.12-13.312t-13.312-5.12h-36.864q-8.192 0-13.312 5.12t-5.12 13.312v164.864q0 8.192 5.12 13.312t13.312 5.12h36.864q8.192 0 13.312-5.12t5.12-13.312zM731.136 256v-164.864q0-8.192-5.12-13.312t-13.312-5.12h-35.84q-8.192 0-13.312 5.12t-5.12 13.312v164.864q0 8.192 5.12 13.312t13.312 5.12h35.84q8.192 0 13.312-5.12t5.12-13.312zM951.296 219.136v732.16q0 29.696-22.528 51.2t-51.2 21.504h-804.864q-29.696 0-51.2-21.504t-21.504-51.2v-732.16q0-29.696 21.504-51.2t51.2-21.504h73.728v-55.296q0-37.888 26.624-64.512t64.512-26.624h36.864q37.888 0 64.512 26.624t26.624 64.512v55.296h219.136v-55.296q0-37.888 27.648-64.512t64.512-26.624h35.84q37.888 0 65.536 26.624t26.624 64.512v55.296h72.704q29.696 0 51.2 21.504t22.528 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'calendar-check-o'
};
export const calendarPlusO = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M877.568 146.432q29.696 0 51.2 21.504t22.528 51.2v732.16q0 29.696-22.528 51.2t-51.2 21.504h-804.864q-29.696 0-51.2-21.504t-21.504-51.2v-732.16q0-29.696 21.504-51.2t51.2-21.504h73.728v-55.296q0-37.888 26.624-64.512t64.512-26.624h36.864q37.888 0 64.512 26.624t26.624 64.512v55.296h219.136v-55.296q0-37.888 27.648-64.512t64.512-26.624h35.84q37.888 0 65.536 26.624t26.624 64.512v55.296h72.704zM658.432 91.136v164.864q0 8.192 5.12 13.312t13.312 5.12h35.84q8.192 0 13.312-5.12t5.12-13.312v-164.864q0-8.192-5.12-13.312t-13.312-5.12h-35.84q-8.192 0-13.312 5.12t-5.12 13.312zM219.136 91.136v164.864q0 8.192 5.12 13.312t13.312 5.12h36.864q8.192 0 13.312-5.12t5.12-13.312v-164.864q0-8.192-5.12-13.312t-13.312-5.12h-36.864q-8.192 0-13.312 5.12t-5.12 13.312zM877.568 951.296v-585.728h-804.864v585.728h804.864zM512 621.568h128q8.192 0 13.312 5.12t5.12 13.312v36.864q0 7.168-5.12 12.288t-13.312 6.144h-128v128q0 7.168-5.12 12.288t-13.312 5.12h-36.864q-7.168 0-12.288-5.12t-5.12-12.288v-128h-128q-8.192 0-13.312-6.144t-5.12-12.288v-36.864q0-8.192 5.12-13.312t13.312-5.12h128v-128q0-8.192 5.12-13.312t12.288-5.12h36.864q8.192 0 13.312 5.12t5.12 13.312v128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'calendar-plus-o'
};
export const calendar = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M72.704 951.296h164.864v-164.864h-164.864v164.864zM274.432 951.296h182.272v-164.864h-182.272v164.864zM72.704 749.568h164.864v-182.272h-164.864v182.272zM274.432 749.568h182.272v-182.272h-182.272v182.272zM72.704 530.432h164.864v-164.864h-164.864v164.864zM493.568 951.296h183.296v-164.864h-183.296v164.864zM274.432 530.432h182.272v-164.864h-182.272v164.864zM712.704 951.296h164.864v-164.864h-164.864v164.864zM493.568 749.568h183.296v-182.272h-183.296v182.272zM292.864 256v-164.864q0-7.168-6.144-12.288t-12.288-6.144h-36.864q-7.168 0-12.288 6.144t-6.144 12.288v164.864q0 7.168 6.144 13.312t12.288 5.12h36.864q7.168 0 12.288-5.12t6.144-13.312zM712.704 749.568h164.864v-182.272h-164.864v182.272zM493.568 530.432h183.296v-164.864h-183.296v164.864zM712.704 530.432h164.864v-164.864h-164.864v164.864zM731.136 256v-164.864q0-7.168-5.12-12.288t-13.312-6.144h-35.84q-7.168 0-13.312 6.144t-5.12 12.288v164.864q0 7.168 5.12 13.312t13.312 5.12h35.84q8.192 0 13.312-5.12t5.12-13.312zM951.296 219.136v732.16q0 29.696-22.528 51.2t-51.2 21.504h-804.864q-29.696 0-51.2-21.504t-21.504-51.2v-732.16q0-29.696 21.504-51.2t51.2-21.504h73.728v-55.296q0-37.888 26.624-64.512t64.512-26.624h36.864q37.888 0 64.512 26.624t26.624 64.512v55.296h219.136v-55.296q0-37.888 27.648-64.512t64.512-26.624h35.84q37.888 0 65.536 26.624t26.624 64.512v55.296h72.704q29.696 0 51.2 21.504t22.528 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'calendar'
};
export const clock = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M512 311.296v256q0 7.168-5.12 12.288t-13.312 5.12h-182.272q-8.192 0-13.312-5.12t-5.12-12.288v-36.864q0-8.192 5.12-13.312t13.312-5.12h128v-200.704q0-8.192 5.12-13.312t12.288-5.12h36.864q8.192 0 13.312 5.12t5.12 13.312zM749.568 512q0-84.992-41.984-155.648t-112.64-113.664-155.648-41.984-156.672 41.984-112.64 113.664-41.984 155.648 41.984 155.648 112.64 113.664 156.672 41.984 155.648-41.984 112.64-113.664 41.984-155.648zM877.568 512q0 119.808-58.368 220.16t-159.744 159.744-220.16 59.392-221.184-59.392-158.72-159.744-59.392-220.16 59.392-220.16 158.72-159.744 221.184-59.392 220.16 59.392 159.744 159.744 58.368 220.16z'
    ]
  ],
  prefix: 'fd',
  iconName: 'clock'
};
export const hourglass1 = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M804.864 72.704q0 149.504-61.44 264.192t-151.552 175.104q91.136 60.416 151.552 175.104t61.44 264.192h54.272q8.192 0 13.312 5.12t5.12 12.288v36.864q0 8.192-5.12 13.312t-13.312 5.12h-840.704q-8.192 0-13.312-5.12t-5.12-13.312v-36.864q0-7.168 5.12-12.288t13.312-5.12h54.272q0-149.504 61.44-264.192t152.576-175.104q-92.16-60.416-152.576-175.104t-61.44-264.192h-54.272q-8.192 0-13.312-5.12t-5.12-12.288v-36.864q0-8.192 5.12-13.312t13.312-5.12h840.704q8.192 0 13.312 5.12t5.12 13.312v36.864q0 7.168-5.12 12.288t-13.312 5.12h-54.272zM731.136 72.704h-584.704q0 37.888 5.12 73.728h574.464q5.12-34.816 5.12-73.728zM731.136 951.296q0-74.752-19.456-143.36t-51.2-118.784-72.704-87.040-82.944-53.248h-132.096q-43.008 17.408-82.944 53.248t-72.704 87.040-51.2 118.784-19.456 143.36h584.704z'
    ]
  ],
  prefix: 'fd',
  iconName: 'hourglass-1'
};
export const hourglass2 = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M804.864 72.704q0 149.504-61.44 264.192t-151.552 175.104q91.136 60.416 151.552 175.104t61.44 264.192h54.272q8.192 0 13.312 5.12t5.12 12.288v36.864q0 8.192-5.12 13.312t-13.312 5.12h-840.704q-8.192 0-13.312-5.12t-5.12-13.312v-36.864q0-7.168 5.12-12.288t13.312-5.12h54.272q0-149.504 61.44-264.192t152.576-175.104q-92.16-60.416-152.576-175.104t-61.44-264.192h-54.272q-8.192 0-13.312-5.12t-5.12-12.288v-36.864q0-8.192 5.12-13.312t13.312-5.12h840.704q8.192 0 13.312 5.12t5.12 13.312v36.864q0 7.168-5.12 12.288t-13.312 5.12h-54.272zM731.136 72.704h-584.704q0 117.76 48.128 220.16h488.448q48.128-102.4 48.128-220.16zM699.392 768q-31.744-80.896-83.968-138.24t-110.592-80.896h-132.096q-58.368 23.552-110.592 80.896t-82.944 138.24h520.192z'
    ]
  ],
  prefix: 'fd',
  iconName: 'hourglass-2'
};
export const hourglass3 = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M804.864 72.704q0 149.504-61.44 264.192t-151.552 175.104q91.136 60.416 151.552 175.104t61.44 264.192h54.272q8.192 0 13.312 5.12t5.12 12.288v36.864q0 8.192-5.12 13.312t-13.312 5.12h-840.704q-8.192 0-13.312-5.12t-5.12-13.312v-36.864q0-7.168 5.12-12.288t13.312-5.12h54.272q0-149.504 61.44-264.192t152.576-175.104q-92.16-60.416-152.576-175.104t-61.44-264.192h-54.272q-8.192 0-13.312-5.12t-5.12-12.288v-36.864q0-8.192 5.12-13.312t13.312-5.12h840.704q8.192 0 13.312 5.12t5.12 13.312v36.864q0 7.168-5.12 12.288t-13.312 5.12h-54.272zM499.712 477.184q44.032-16.384 84.992-52.224t73.728-87.040 53.248-119.808 19.456-145.408h-584.704q0 75.776 19.456 145.408t53.248 119.808 73.728 87.040 84.992 52.224q11.264 4.096 17.408 14.336t7.168 20.48-7.168 20.48-17.408 13.312q-77.824 29.696-139.264 112.64h400.384q-61.44-82.944-139.264-112.64-11.264-3.072-17.408-13.312t-7.168-20.48 7.168-20.48 17.408-14.336z'
    ]
  ],
  prefix: 'fd',
  iconName: 'hourglass-3'
};
export const infinite = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M783.988 752.012c-64.104 0-124.372-24.96-169.7-70.288l-102.288-102.282-102.276 102.27c-45.332 45.336-105.6 70.3-169.706 70.3-64.118 0-124.39-24.964-169.722-70.3-45.332-45.334-70.296-105.604-70.296-169.712s24.964-124.38 70.296-169.714c45.334-45.332 105.608-70.296 169.714-70.296 64.108 0 124.38 24.964 169.712 70.296l102.278 102.276 102.276-102.276c45.332-45.332 105.604-70.298 169.712-70.298 64.112 0 124.384 24.966 169.71 70.298 45.338 45.334 70.302 105.606 70.302 169.714 0 64.112-24.964 124.382-70.3 169.71-45.326 45.336-105.598 70.302-169.712 70.302zM681.72 614.288c27.322 27.31 63.64 42.354 102.268 42.352 38.634 0 74.958-15.044 102.276-42.362 27.316-27.322 42.364-63.644 42.364-102.278s-15.046-74.956-42.364-102.274c-27.32-27.318-63.64-42.364-102.276-42.364-38.632 0-74.956 15.044-102.278 42.364l-102.268 102.274 102.278 102.288zM240.012 367.362c-38.634 0-74.956 15.044-102.274 42.364-27.32 27.318-42.364 63.64-42.364 102.274 0 38.632 15.044 74.954 42.364 102.276 27.32 27.316 63.642 42.364 102.274 42.364 38.634 0 74.956-15.044 102.272-42.362l102.276-102.278-102.276-102.274c-27.318-27.32-63.64-42.366-102.272-42.364v0z'
    ]
  ],
  prefix: 'fd',
  iconName: 'infinite'
};
export const picture = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M365.568 328.704q0 46.080-31.744 77.824t-77.824 32.768-77.824-32.768-31.744-77.824 31.744-77.824 77.824-31.744 77.824 31.744 31.744 77.824zM951.296 548.864v256h-804.864v-109.568l182.272-183.296 92.16 91.136 291.84-291.84zM1005.568 146.432h-914.432q-7.168 0-12.288 5.12t-6.144 13.312v694.272q0 7.168 6.144 13.312t12.288 5.12h914.432q7.168 0 13.312-5.12t5.12-13.312v-694.272q0-8.192-5.12-13.312t-13.312-5.12zM1096.704 164.864v694.272q0 37.888-26.624 64.512t-64.512 27.648h-914.432q-36.864 0-64.512-27.648t-26.624-64.512v-694.272q0-37.888 26.624-64.512t64.512-27.648h914.432q37.888 0 64.512 27.648t26.624 64.512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'picture'
};
export const location = {
  icon: [
    585,
    1000,
    [],
    '',
    [
      'M439.296 365.568q0-60.416-43.008-103.424t-103.424-43.008-103.424 43.008-43.008 103.424 43.008 103.424 103.424 43.008 103.424-43.008 43.008-103.424zM584.704 365.568q0 62.464-18.432 102.4l-207.872 442.368q-9.216 18.432-27.648 29.696t-37.888 11.264-38.912-11.264-26.624-29.696l-208.896-442.368q-18.432-39.936-18.432-102.4 0-120.832 86.016-206.848t206.848-86.016 206.848 86.016 84.992 206.848z'
    ]
  ],
  prefix: 'fd',
  iconName: 'location'
};
export const phone = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1024 939.52v33.28c0 28.277-22.923 51.2-51.2 51.2v0h-102.4c-480.709 0-870.4-389.691-870.4-870.4v0-102.4c0-28.277 22.923-51.2 51.2-51.2v0h204.8c28.277 0 51.2 22.923 51.2 51.2v0 204.8c0 28.672-15.872 67.072-35.84 87.040l-109.568 109.568c77.824 184.32 225.28 331.776 409.6 409.6l108.544-108.544c20.48-20.48 58.88-36.352 87.040-36.352h205.824c28.056 0.29 50.688 23.1 50.688 51.197 0 0.001 0 0.002 0 0.003v0 171.52z'
    ]
  ],
  prefix: 'fd',
  iconName: 'phone'
};
export const basket = {
  icon: [
    922,
    1000,
    [],
    '',
    [
      'M153.6 870.4q0-40.96 30.72-71.68t71.68-30.72q43.008 0 72.704 30.72t29.696 71.68q0 43.008-29.696 72.704t-72.704 29.696q-40.96 0-71.68-29.696t-30.72-72.704zM665.6 870.4q0-40.96 30.72-71.68t71.68-30.72q43.008 0 72.704 30.72t29.696 71.68q0 43.008-29.696 72.704t-72.704 29.696q-40.96 0-71.68-29.696t-30.72-72.704zM335.872 628.736q-36.864 10.24-34.816 23.552t45.056 13.312h575.488v77.824q0 20.48-20.48 20.48h-669.696q-20.48 0-20.48-20.48v-77.824l-10.24-47.104-100.352-464.896h-100.352v-81.92q0-20.48 20.48-20.48h159.744q20.48 0 20.48 20.48v88.064h720.896v280.576q0 22.528-18.432 26.624z'
    ]
  ],
  prefix: 'fd',
  iconName: 'basket'
};
export const magic = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M679.936 331.776l167.936-166.912-61.44-61.44-167.936 166.912zM935.936 164.864q0 15.36-10.24 25.6l-735.232 735.232q-10.24 10.24-25.6 10.24t-25.6-10.24l-113.664-113.664q-10.24-10.24-10.24-25.6t10.24-25.6l735.232-735.232q10.24-10.24 25.6-10.24t25.6 10.24l113.664 113.664q10.24 10.24 10.24 25.6zM163.84 56.32l55.296 16.384-55.296 17.408-17.408 56.32-17.408-56.32-56.32-17.408 56.32-16.384 17.408-56.32zM363.52 148.48l111.616 34.816-111.616 33.792-34.816 111.616-33.792-111.616-111.616-33.792 111.616-34.816 33.792-111.616zM894.976 421.888l56.32 17.408-56.32 16.384-17.408 56.32-17.408-56.32-55.296-16.384 55.296-17.408 17.408-56.32zM529.408 56.32l55.296 16.384-55.296 17.408-17.408 56.32-17.408-56.32-55.296-17.408 55.296-16.384 17.408-56.32z'
    ]
  ],
  prefix: 'fd',
  iconName: 'magic'
};
export const thumbsUp = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M146.432 768q0-15.36-11.264-25.6t-25.6-11.264-25.6 11.264-11.264 25.6 11.264 25.6 25.6 11.264 25.6-11.264 11.264-25.6zM804.864 439.296q0-29.696-22.528-51.2t-51.2-22.528h-200.704q0-32.768 27.648-91.136t26.624-91.136q0-56.32-17.408-82.944t-73.728-27.648q-14.336 15.36-21.504 49.152t-17.408 71.68-33.792 62.464q-13.312 13.312-44.032 52.224-2.048 3.072-13.312 16.384t-18.432 23.552-19.456 24.576-22.528 25.6-22.528 19.456-22.528 15.36-20.48 6.144h-18.432v365.568h18.432q7.168 0 18.432 1.024t18.432 4.096 21.504 6.144 20.48 7.168 20.48 6.144 16.384 6.144q120.832 41.984 195.584 41.984h68.608q109.568 0 109.568-95.232 0-15.36-2.048-31.744 16.384-9.216 26.624-30.72t10.24-41.984-10.24-38.912q29.696-28.672 29.696-68.608 0-14.336-5.12-31.744t-14.336-26.624q18.432-1.024 30.72-26.624t12.288-46.080zM877.568 438.272q0 51.2-27.648 93.184 5.12 18.432 5.12 38.912 0 44.032-21.504 82.944 1.024 12.288 1.024 24.576 0 57.344-33.792 101.376 0 79.872-49.152 125.952t-129.024 46.080h-73.728q-55.296 0-108.544-13.312t-123.904-36.864q-66.56-23.552-78.848-23.552h-164.864q-29.696 0-51.2-21.504t-21.504-51.2v-365.568q0-30.72 21.504-52.224t51.2-21.504h156.672q20.48-13.312 78.848-88.064 32.768-43.008 61.44-73.728 13.312-14.336 19.456-49.152t17.408-71.68 35.84-61.44q22.528-21.504 51.2-21.504 48.128 0 86.016 18.432t58.368 58.368 20.48 106.496q0 52.224-27.648 109.568h100.352q59.392 0 103.424 43.008t43.008 102.4z'
    ]
  ],
  prefix: 'fd',
  iconName: 'thumbs-up'
};
export const lightbulb = {
  icon: [
    585,
    1000,
    [],
    '',
    [
      'M420.864 328.704q0 8.192-6.144 13.312t-12.288 5.12-13.312-5.12-5.12-13.312q0-25.6-30.72-39.936t-60.416-14.336q-7.168 0-13.312-5.12t-5.12-13.312 5.12-13.312 13.312-5.12q28.672 0 56.32 9.216t50.176 30.72 21.504 51.2zM512 328.704q0-40.96-19.456-75.776t-51.2-58.368-70.656-35.84-77.824-12.288-77.824 12.288-70.656 35.84-51.2 58.368-20.48 75.776q0 58.368 38.912 103.424 6.144 6.144 17.408 18.432t17.408 19.456q73.728 87.040 80.896 169.984h130.048q8.192-82.944 80.896-169.984 6.144-6.144 17.408-19.456t17.408-18.432q38.912-45.056 38.912-103.424zM584.704 328.704q0 89.088-58.368 153.6-25.6 27.648-43.008 49.152t-33.792 55.296-19.456 61.44q26.624 15.36 26.624 47.104 0 20.48-13.312 35.84 13.312 15.36 13.312 36.864 0 29.696-25.6 46.080 8.192 13.312 8.192 26.624 0 26.624-18.432 40.96t-44.032 14.336q-11.264 25.6-34.816 39.936t-49.152 15.36-50.176-15.36-33.792-39.936q-26.624 0-45.056-14.336t-17.408-40.96q0-13.312 7.168-26.624-25.6-16.384-25.6-46.080 0-21.504 14.336-36.864-14.336-15.36-14.336-35.84 0-31.744 26.624-47.104-2.048-28.672-19.456-61.44t-33.792-55.296-41.984-49.152q-59.392-64.512-59.392-153.6 0-56.32 25.6-105.472t66.56-80.896 94.208-50.176 106.496-19.456 106.496 19.456 93.184 50.176 67.584 80.896 24.576 105.472z'
    ]
  ],
  prefix: 'fd',
  iconName: 'lightbulb'
};
export const wrench = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M219.136 840.704q0-14.336-10.24-25.6t-25.6-10.24-25.6 10.24-11.264 25.6 11.264 25.6 25.6 11.264 25.6-11.264 10.24-25.6zM587.776 601.088l-390.144 390.144q-21.504 20.48-51.2 20.48t-52.224-20.48l-60.416-62.464q-21.504-20.48-21.504-51.2 0-29.696 21.504-52.224l389.12-389.12q22.528 56.32 65.536 99.328t99.328 65.536zM950.272 352.256q0 22.528-13.312 60.416-27.648 76.8-94.208 124.928t-147.456 47.104q-106.496 0-181.248-74.752t-74.752-181.248 74.752-180.224 181.248-75.776q32.768 0 68.608 10.24t61.44 26.624q9.216 6.144 9.216 15.36t-9.216 16.384l-166.912 96.256v128l110.592 61.44q2.048-2.048 45.056-27.648t76.8-46.080 40.96-20.48q8.192 0 13.312 5.12t5.12 14.336z'
    ]
  ],
  prefix: 'fd',
  iconName: 'wrench'
};
export const camera = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 409.6q65.536 0 109.568 45.056t44.032 108.544-45.056 108.544-108.544 45.056-108.544-45.056-45.056-108.544 45.056-108.544 108.544-45.056zM921.6 256q43.008 0 72.704 29.696t29.696 72.704v460.8q0 40.96-29.696 71.68t-72.704 30.72h-819.2q-40.96 0-71.68-30.72t-30.72-71.68v-460.8q0-43.008 30.72-72.704t71.68-29.696h122.88q28.672 0 40.96-30.72l30.72-94.208q10.24-28.672 40.96-28.672h348.16q30.72 0 40.96 28.672l30.72 94.208q12.288 30.72 40.96 30.72h122.88zM512 819.2q106.496 0 181.248-74.752t74.752-181.248-74.752-181.248-181.248-74.752-181.248 74.752-74.752 181.248 74.752 181.248 181.248 74.752zM886.784 430.080q14.336 0 24.576-11.264t10.24-25.6-10.24-24.576-24.576-10.24q-36.864 0-36.864 34.816 0 16.384 11.264 26.624t25.6 10.24z'
    ]
  ],
  prefix: 'fd',
  iconName: 'camera'
};
export const attach = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M802.816 791.552q0 66.56-46.080 111.616t-111.616 45.056q-76.8 0-134.144-56.32l-444.416-444.416q-64.512-65.536-64.512-154.624 0-91.136 63.488-153.6t153.6-63.488q90.112 0 155.648 64.512l346.112 346.112q5.12 5.12 5.12 12.288 0 9.216-17.408 26.624t-26.624 17.408q-7.168 0-12.288-5.12l-347.136-347.136q-45.056-44.032-103.424-44.032-60.416 0-102.4 43.008t-40.96 103.424q0 59.392 43.008 103.424l443.392 443.392q35.84 36.864 82.944 36.864 36.864 0 60.416-24.576t24.576-60.416q0-47.104-35.84-82.944l-332.8-331.776q-14.336-14.336-33.792-14.336-16.384 0-27.648 11.264t-11.264 27.648q0 18.432 14.336 33.792l234.496 233.472q6.144 6.144 6.144 13.312 0 9.216-18.432 26.624t-26.624 17.408q-6.144 0-12.288-5.12l-234.496-234.496q-35.84-34.816-35.84-84.992 0-47.104 32.768-79.872t78.848-32.768q50.176 0 86.016 35.84l331.776 332.8q57.344 55.296 57.344 134.144z'
    ]
  ],
  prefix: 'fd',
  iconName: 'attach'
};
export const cogAlt = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M512 512q0-60.416-43.008-103.424t-103.424-43.008-103.424 43.008-43.008 103.424 43.008 103.424 103.424 43.008 103.424-43.008 43.008-103.424zM951.296 804.864q0-29.696-22.528-52.224t-51.2-21.504-51.2 21.504-21.504 52.224q0 29.696 21.504 51.2t51.2 21.504 52.224-21.504 21.504-51.2zM951.296 219.136q0-29.696-22.528-51.2t-51.2-21.504-51.2 21.504-21.504 51.2q0 30.72 21.504 52.224t51.2 21.504 52.224-21.504 21.504-52.224zM731.136 459.776v105.472q0 6.144-4.096 11.264t-8.192 6.144l-89.088 14.336q-6.144 19.456-18.432 43.008 19.456 27.648 51.2 65.536 4.096 6.144 4.096 11.264 0 7.168-4.096 11.264-12.288 17.408-47.104 51.2t-44.032 33.792q-7.168 0-12.288-4.096l-65.536-51.2q-21.504 11.264-44.032 17.408-6.144 61.44-13.312 89.088-4.096 13.312-17.408 13.312h-106.496q-6.144 0-11.264-4.096t-5.12-10.24l-13.312-87.040q-19.456-6.144-43.008-18.432l-67.584 51.2q-4.096 4.096-11.264 4.096-6.144 0-12.288-4.096-81.92-76.8-81.92-92.16 0-5.12 4.096-10.24 5.12-8.192 23.552-30.72t26.624-34.816q-13.312-24.576-20.48-47.104l-87.040-13.312q-5.12-1.024-9.216-5.12t-4.096-11.264v-106.496q0-5.12 4.096-10.24t9.216-6.144l88.064-14.336q7.168-19.456 18.432-43.008-19.456-27.648-51.2-65.536-4.096-6.144-4.096-11.264 0-7.168 4.096-12.288 12.288-16.384 47.104-50.176t45.056-33.792q6.144 0 12.288 4.096l65.536 51.2q19.456-10.24 44.032-18.432 6.144-61.44 13.312-88.064 3.072-13.312 16.384-13.312h106.496q6.144 0 11.264 4.096t6.144 10.24l13.312 87.040q19.456 6.144 43.008 17.408l66.56-50.176q5.12-4.096 12.288-4.096 6.144 0 11.264 4.096 82.944 76.8 82.944 92.16 0 4.096-4.096 10.24-7.168 9.216-24.576 30.72t-25.6 34.816q13.312 27.648 19.456 47.104l87.040 12.288q6.144 2.048 9.216 6.144t4.096 11.264zM1096.704 764.928v79.872q0 9.216-84.992 17.408-6.144 15.36-16.384 29.696 28.672 64.512 28.672 78.848 0 2.048-2.048 4.096-69.632 40.96-70.656 40.96-5.12 0-26.624-27.648t-29.696-37.888q-11.264 1.024-17.408 1.024t-17.408-1.024q-7.168 11.264-29.696 37.888t-25.6 27.648q-1.024 0-70.656-40.96-3.072-2.048-3.072-4.096 0-14.336 29.696-78.848-10.24-14.336-17.408-29.696-84.992-8.192-84.992-17.408v-79.872q0-9.216 84.992-18.432 7.168-16.384 17.408-29.696-29.696-64.512-29.696-78.848 0-2.048 3.072-4.096 2.048-1.024 19.456-11.264t33.792-19.456 17.408-9.216q4.096 0 25.6 26.624t29.696 38.912q12.288-1.024 17.408-1.024t17.408 1.024q28.672-40.96 52.224-64.512l4.096-1.024q2.048 0 70.656 39.936 2.048 2.048 2.048 4.096 0 14.336-28.672 78.848 9.216 13.312 16.384 29.696 84.992 9.216 84.992 18.432zM1096.704 179.2v79.872q0 9.216-84.992 18.432-6.144 15.36-16.384 29.696 28.672 64.512 28.672 78.848 0 2.048-2.048 4.096-69.632 39.936-70.656 39.936-5.12 0-26.624-26.624t-29.696-38.912q-11.264 1.024-17.408 1.024t-17.408-1.024q-7.168 12.288-29.696 38.912t-25.6 26.624q-1.024 0-70.656-39.936-3.072-2.048-3.072-4.096 0-14.336 29.696-78.848-10.24-14.336-17.408-29.696-84.992-9.216-84.992-18.432v-79.872q0-9.216 84.992-17.408 7.168-16.384 17.408-29.696-29.696-64.512-29.696-78.848 0-2.048 3.072-4.096 2.048-1.024 19.456-11.264t33.792-19.456 17.408-9.216q4.096 0 25.6 26.624t29.696 37.888q12.288-1.024 17.408-1.024t17.408 1.024q28.672-39.936 52.224-63.488l4.096-1.024q2.048 0 70.656 39.936 2.048 2.048 2.048 4.096 0 14.336-28.672 78.848 9.216 13.312 16.384 29.696 84.992 8.192 84.992 17.408z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cog-alt'
};
export const cog1 = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M584.704 512q0-60.416-41.984-103.424t-103.424-43.008-103.424 43.008-43.008 103.424 43.008 103.424 103.424 43.008 103.424-43.008 41.984-103.424zM877.568 449.536v126.976q0 7.168-4.096 13.312t-11.264 7.168l-106.496 16.384q-10.24 30.72-21.504 52.224 19.456 27.648 60.416 78.848 6.144 6.144 6.144 13.312t-5.12 13.312q-15.36 21.504-56.32 62.464t-54.272 39.936q-7.168 0-14.336-5.12l-78.848-61.44q-25.6 13.312-52.224 21.504-9.216 77.824-16.384 106.496-4.096 16.384-20.48 16.384h-126.976q-8.192 0-14.336-5.12t-6.144-12.288l-16.384-105.472q-27.648-9.216-51.2-21.504l-80.896 61.44q-6.144 5.12-14.336 5.12t-14.336-6.144q-71.68-65.536-94.208-96.256-4.096-5.12-4.096-13.312 0-6.144 5.12-12.288 8.192-12.288 28.672-37.888t30.72-40.96q-15.36-28.672-23.552-56.32l-104.448-15.36q-7.168-1.024-11.264-7.168t-5.12-13.312v-126.976q0-7.168 5.12-13.312t10.24-7.168l106.496-16.384q8.192-25.6 22.528-52.224-23.552-32.768-61.44-78.848-6.144-7.168-6.144-14.336 0-5.12 5.12-12.288 15.36-20.48 56.32-61.44t54.272-40.96q7.168 0 15.36 5.12l78.848 61.44q24.576-13.312 51.2-21.504 9.216-77.824 17.408-106.496 3.072-16.384 20.48-16.384h126.976q7.168 0 13.312 5.12t7.168 12.288l15.36 105.472q28.672 9.216 52.224 20.48l80.896-60.416q5.12-5.12 13.312-5.12 7.168 0 14.336 5.12 73.728 68.608 94.208 97.28 4.096 5.12 4.096 12.288t-4.096 13.312q-9.216 12.288-29.696 37.888t-30.72 40.96q15.36 28.672 23.552 55.296l104.448 16.384q7.168 1.024 12.288 7.168t4.096 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cog-1'
};
export const cog = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M932.864 568.32l-136.192 57.344q-8.192 22.528-12.288 31.744l56.32 136.192-80.896 80.896-138.24-54.272q-9.216 4.096-31.744 12.288l-56.32 137.216h-114.688l-57.344-136.192q-11.264-4.096-33.792-13.312l-135.168 56.32-79.872-80.896 54.272-137.216q-1.024-3.072-4.096-9.216t-6.144-12.288-4.096-11.264l-134.144-56.32v-114.688l134.144-57.344 14.336-33.792-55.296-135.168 79.872-80.896 136.192 55.296q22.528-9.216 33.792-13.312l56.32-135.168h114.688l57.344 135.168q14.336 5.12 31.744 13.312l136.192-56.32 81.92 80.896-55.296 138.24q6.144 12.288 12.288 30.72l136.192 57.344v114.688zM475.136 681.984q70.656 0 120.832-49.152t50.176-120.832-50.176-121.856-120.832-51.2-121.856 51.2-50.176 121.856 50.176 120.832 121.856 49.152z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cog'
};
export const chat = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M804.864 439.296q0 78.848-54.272 146.432t-146.432 106.496-201.728 38.912q-49.152 0-100.352-9.216-71.68 50.176-158.72 73.728-21.504 5.12-49.152 9.216h-2.048q-6.144 0-12.288-5.12t-6.144-12.288q-1.024-1.024-1.024-3.072t1.024-4.096 1.024-3.072l1.024-3.072t2.048-3.072 2.048-3.072 3.072-3.072 2.048-2.048q3.072-3.072 13.312-14.336t15.36-16.384 12.288-17.408 14.336-21.504 11.264-25.6q-70.656-40.96-110.592-100.352t-40.96-128q0-79.872 54.272-147.456t146.432-106.496 201.728-38.912 201.728 38.912 146.432 106.496 54.272 147.456zM1024 584.704q0 68.608-40.96 129.024t-110.592 100.352q5.12 14.336 11.264 25.6t14.336 21.504 13.312 16.384 14.336 17.408 13.312 14.336q0 0 2.048 2.048t3.072 3.072 2.048 3.072 2.048 3.072l1.024 3.072t1.024 3.072 1.024 4.096-1.024 3.072q-2.048 8.192-7.168 13.312t-12.288 4.096q-28.672-4.096-49.152-9.216-88.064-23.552-159.744-73.728-51.2 9.216-100.352 9.216-154.624 0-269.312-75.776 32.768 3.072 50.176 3.072 92.16 0 176.128-25.6t151.552-73.728q70.656-53.248 109.568-121.856t37.888-144.384q0-44.032-13.312-87.040 73.728 39.936 116.736 101.376t43.008 131.072z'
    ]
  ],
  prefix: 'fd',
  iconName: 'chat'
};
export const chatEmpty = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M402.432 219.136q-87.040 0-163.84 29.696t-120.832 80.896-45.056 109.568q0 46.080 30.72 90.112t84.992 74.752l55.296 32.768-19.456 47.104q19.456-11.264 34.816-21.504l25.6-18.432 30.72 6.144q44.032 8.192 87.040 8.192 87.040 0 163.84-29.696t120.832-80.896 44.032-108.544-44.032-109.568-120.832-80.896-163.84-29.696zM402.432 146.432q108.544 0 201.728 38.912t146.432 106.496 54.272 147.456-54.272 146.432-146.432 106.496-201.728 38.912q-49.152 0-100.352-9.216-71.68 50.176-158.72 73.728-21.504 5.12-49.152 9.216h-2.048q-6.144 0-12.288-5.12t-6.144-12.288q-1.024-1.024-1.024-3.072t1.024-4.096 1.024-3.072l1.024-3.072t2.048-3.072 2.048-3.072 3.072-3.072 2.048-2.048q3.072-3.072 13.312-14.336t15.36-16.384 12.288-17.408 14.336-21.504 11.264-25.6q-70.656-40.96-110.592-100.352t-40.96-128q0-79.872 54.272-147.456t146.432-106.496 201.728-38.912zM872.448 814.080q5.12 14.336 11.264 25.6t14.336 21.504 13.312 16.384 14.336 17.408 13.312 14.336q0 0 2.048 2.048t3.072 3.072 2.048 3.072 2.048 3.072l1.024 3.072t1.024 3.072 1.024 4.096-1.024 3.072q-2.048 8.192-7.168 13.312t-12.288 4.096q-28.672-4.096-49.152-9.216-88.064-23.552-159.744-73.728-51.2 9.216-100.352 9.216-154.624 0-269.312-75.776 32.768 3.072 50.176 3.072 92.16 0 176.128-25.6t151.552-73.728q70.656-53.248 109.568-121.856t37.888-144.384q0-44.032-13.312-87.040 73.728 39.936 116.736 101.376t43.008 131.072q0 68.608-40.96 129.024t-110.592 100.352z'
    ]
  ],
  prefix: 'fd',
  iconName: 'chat-empty'
};
export const bubble = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 64c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z'
    ]
  ],
  prefix: 'fd',
  iconName: 'bubble'
};
export const commentEmpty = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 219.136q-116.736 0-218.112 39.936t-160.768 107.52-60.416 145.408q0 63.488 40.96 121.856t115.712 100.352l49.152 28.672-15.36 54.272q-13.312 52.224-39.936 99.328 87.040-36.864 157.696-98.304l24.576-21.504 32.768 3.072q38.912 5.12 73.728 5.12 116.736 0 218.112-39.936t160.768-107.52 60.416-145.408-60.416-145.408-160.768-107.52-218.112-39.936zM1024 512q0 99.328-68.608 183.296t-186.368 133.12-257.024 49.152q-39.936 0-82.944-4.096-112.64 99.328-263.168 138.24-27.648 8.192-64.512 12.288h-3.072q-8.192 0-15.36-6.144t-9.216-15.36v-1.024q-2.048-2.048 0-6.144t1.024-6.144 2.048-5.12l4.096-5.12t4.096-5.12 4.096-5.12q4.096-5.12 17.408-19.456t20.48-22.528 17.408-22.528 18.432-28.672 15.36-33.792 15.36-43.008q-90.112-51.2-141.312-125.952t-52.224-160.768q0-99.328 68.608-183.296t186.368-133.12 257.024-49.152 257.024 49.152 186.368 133.12 68.608 183.296z'
    ]
  ],
  prefix: 'fd',
  iconName: 'comment-empty'
};
export const social = {
  icon: [
    1207,
    1000,
    [],
    '',
    [
      'M1207.296 476.16q0 129.024-80.896 238.592t-220.16 174.080-303.104 63.488q-124.928 0-239.616-39.936l2.048 3.072-365.568 109.568q45.056-60.416 72.704-129.024t31.744-108.544l4.096-38.912q-108.544-122.88-108.544-272.384 0-129.024 80.896-238.592t220.16-173.056 302.080-63.488 303.104 63.488 220.16 173.056 80.896 238.592zM951.296 476.16q0-29.696-21.504-51.2t-52.224-21.504q-29.696 0-51.2 21.504t-21.504 51.2q0 30.72 21.504 52.224t51.2 21.504q30.72 0 52.224-21.504t21.504-52.224zM695.296 476.16q0-29.696-21.504-51.2t-52.224-21.504q-29.696 0-51.2 21.504t-21.504 51.2q0 30.72 21.504 52.224t51.2 21.504q30.72 0 52.224-21.504t21.504-52.224zM439.296 476.16q0-29.696-21.504-51.2t-52.224-21.504q-29.696 0-51.2 21.504t-21.504 51.2q0 30.72 21.504 52.224t51.2 21.504q30.72 0 52.224-21.504t21.504-52.224z'
    ]
  ],
  prefix: 'fd',
  iconName: 'social'
};
export const commenting = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M365.568 512q0-30.72-21.504-52.224t-51.2-20.48-52.224 20.48-21.504 52.224 21.504 51.2 52.224 21.504 51.2-21.504 21.504-51.2zM584.704 512q0-30.72-20.48-52.224t-52.224-20.48-51.2 20.48-21.504 52.224 21.504 51.2 51.2 21.504 52.224-21.504 20.48-51.2zM804.864 512q0-30.72-21.504-52.224t-52.224-20.48-51.2 20.48-21.504 52.224 21.504 51.2 51.2 21.504 52.224-21.504 21.504-51.2zM1024 512q0 99.328-68.608 183.296t-186.368 133.12-257.024 49.152q-62.464 0-120.832-10.24-98.304 99.328-247.808 131.072-29.696 6.144-49.152 7.168-7.168 1.024-13.312-3.072t-7.168-10.24q-2.048-9.216 11.264-21.504 3.072-3.072 13.312-12.288t15.36-13.312 13.312-14.336 13.312-18.432 11.264-20.48 12.288-27.648 8.192-32.768 7.168-41.984q-83.968-51.2-131.072-123.904t-48.128-153.6q0-99.328 68.608-183.296t186.368-133.12 257.024-49.152 257.024 49.152 186.368 133.12 68.608 183.296z'
    ]
  ],
  prefix: 'fd',
  iconName: 'commenting'
};
export const commentingO = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M365.568 512q0 30.72-21.504 51.2t-51.2 21.504-52.224-21.504-21.504-51.2 21.504-52.224 52.224-20.48 51.2 20.48 21.504 52.224zM584.704 512q0 30.72-20.48 51.2t-52.224 21.504-51.2-21.504-21.504-51.2 21.504-52.224 51.2-20.48 52.224 20.48 20.48 52.224zM804.864 512q0 30.72-21.504 51.2t-52.224 21.504-51.2-21.504-21.504-51.2 21.504-52.224 51.2-20.48 52.224 20.48 21.504 52.224zM512 219.136q-116.736 0-218.112 39.936t-160.768 107.52-60.416 145.408q0 63.488 40.96 121.856t115.712 100.352l49.152 28.672-15.36 54.272q-13.312 52.224-39.936 99.328 87.040-36.864 157.696-98.304l24.576-21.504 32.768 3.072q38.912 5.12 73.728 5.12 116.736 0 218.112-39.936t160.768-107.52 60.416-145.408-60.416-145.408-160.768-107.52-218.112-39.936zM1024 512q0 99.328-68.608 183.296t-186.368 133.12-257.024 49.152q-39.936 0-82.944-4.096-112.64 99.328-263.168 138.24-27.648 8.192-64.512 12.288h-3.072q-8.192 0-15.36-6.144t-9.216-15.36v-1.024q-2.048-2.048 0-6.144t1.024-6.144 2.048-5.12l4.096-5.12t4.096-5.12 4.096-5.12q4.096-5.12 17.408-19.456t20.48-22.528 17.408-22.528 18.432-28.672 15.36-33.792 15.36-43.008q-90.112-51.2-141.312-125.952t-52.224-160.768q0-74.752 40.96-142.336t108.544-116.736 163.84-77.824 198.656-28.672 198.656 28.672 163.84 77.824 108.544 116.736 40.96 142.336z'
    ]
  ],
  prefix: 'fd',
  iconName: 'commenting-o'
};
export const tags = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M256 256q0-30.72-21.504-52.224t-51.2-20.48-52.224 20.48-21.504 52.224 21.504 51.2 52.224 21.504 51.2-21.504 21.504-51.2zM865.28 584.704q0 30.72-20.48 52.224l-280.576 280.576q-22.528 21.504-52.224 21.504-30.72 0-51.2-21.504l-408.576-408.576q-21.504-21.504-36.864-58.368t-15.36-66.56v-237.568q0-29.696 21.504-51.2t51.2-22.528h238.592q29.696 0 66.56 15.36t58.368 36.864l408.576 408.576q20.48 21.504 20.48 51.2zM1085.44 584.704q0 30.72-21.504 52.224l-280.576 280.576q-22.528 21.504-52.224 21.504-20.48 0-33.792-8.192t-29.696-25.6l268.288-268.288q21.504-21.504 21.504-52.224 0-29.696-21.504-51.2l-408.576-408.576q-21.504-21.504-58.368-36.864t-66.56-15.36h128q29.696 0 66.56 15.36t58.368 36.864l408.576 408.576q21.504 21.504 21.504 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'tags'
};
export const tag = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M256 256q0-30.72-21.504-52.224t-51.2-20.48-52.224 20.48-21.504 52.224 21.504 51.2 52.224 21.504 51.2-21.504 21.504-51.2zM865.28 584.704q0 30.72-20.48 52.224l-280.576 280.576q-22.528 21.504-52.224 21.504-30.72 0-51.2-21.504l-408.576-408.576q-21.504-21.504-36.864-58.368t-15.36-66.56v-237.568q0-29.696 21.504-51.2t51.2-22.528h238.592q29.696 0 66.56 15.36t58.368 36.864l408.576 408.576q20.48 21.504 20.48 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'tag'
};
export const dollar = {
  icon: [
    585,
    1000,
    [],
    '',
    [
      'M559.104 676.864q0 88.064-57.344 150.528t-147.456 78.848v99.328q0 8.192-5.12 13.312t-13.312 5.12h-76.8q-7.168 0-13.312-5.12t-5.12-13.312v-99.328q-37.888-5.12-72.704-18.432t-58.368-25.6-41.984-26.624-26.624-21.504-10.24-10.24q-9.216-12.288-1.024-23.552l59.392-77.824q3.072-5.12 12.288-6.144t14.336 5.12l1.024 1.024q64.512 56.32 138.24 71.68 21.504 4.096 43.008 4.096 46.080 0 80.896-24.576t35.84-69.632q0-16.384-9.216-30.72t-18.432-23.552-33.792-21.504-37.888-18.432-46.080-18.432q-21.504-9.216-34.816-14.336t-34.816-15.36-35.84-17.408-32.768-20.48-29.696-24.576-25.6-27.648-20.48-32.768-11.264-37.888-5.12-45.056q0-78.848 56.32-138.24t145.408-76.8v-102.4q0-7.168 5.12-13.312t13.312-5.12h76.8q8.192 0 13.312 5.12t5.12 13.312v100.352q32.768 3.072 63.488 13.312t49.152 19.456 36.864 20.48 21.504 17.408 9.216 7.168q9.216 11.264 3.072 22.528l-47.104 82.944q-4.096 9.216-12.288 9.216-8.192 2.048-15.36-4.096-2.048-2.048-9.216-7.168t-21.504-14.336-33.792-18.432-43.008-15.36-48.128-6.144q-54.272 0-89.088 24.576t-33.792 63.488q0 14.336 4.096 27.648t17.408 23.552 22.528 18.432 31.744 18.432 34.816 15.36 39.936 15.36q30.72 11.264 46.080 17.408t44.032 20.48 43.008 24.576 34.816 28.672 30.72 35.84 18.432 44.032 7.168 53.248z'
    ]
  ],
  prefix: 'fd',
  iconName: 'dollar'
};
export const money = {
  icon: [
    1097.142857142857,
    1000,
    [],
    '',
    [
      'M438.857 658.286h219.429v-54.857h-73.143v-256h-65.143l-84.571 78.286 44 45.714c13.714-12 22.286-18.286 31.429-32.571h1.143v164.571h-73.143v54.857zM731.429 512c0 104-62.857 237.714-182.857 237.714s-182.857-133.714-182.857-237.714 62.857-237.714 182.857-237.714 182.857 133.714 182.857 237.714zM1024 658.286v-292.571c-80.571 0-146.286-65.714-146.286-146.286h-658.286c0 80.571-65.714 146.286-146.286 146.286v292.571c80.571 0 146.286 65.714 146.286 146.286h658.286c0-80.571 65.714-146.286 146.286-146.286zM1097.143 182.857v658.286c0 20-16.571 36.571-36.571 36.571h-1024c-20 0-36.571-16.571-36.571-36.571v-658.286c0-20 16.571-36.571 36.571-36.571h1024c20 0 36.571 16.571 36.571 36.571z'
    ]
  ],
  prefix: 'fd',
  iconName: 'money'
};
export const userCircle = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M870.4 764.928q-12.288-88.064-50.176-147.456t-105.472-67.584q-37.888 43.008-91.136 66.56t-111.616 23.552-111.616-23.552-91.136-66.56q-67.584 9.216-105.472 67.584t-50.176 147.456q60.416 86.016 154.624 136.192t203.776 50.176 203.776-50.176 154.624-136.192zM731.136 365.568q0-91.136-63.488-154.624t-155.648-64.512-154.624 64.512-64.512 154.624 64.512 155.648 154.624 63.488 155.648-63.488 63.488-155.648zM1024 512q0 104.448-40.96 198.656t-108.544 163.84-162.816 108.544-199.68 40.96q-104.448 0-198.656-40.96t-163.84-108.544-108.544-163.84-40.96-198.656 40.96-198.656 108.544-163.84 163.84-108.544 198.656-40.96 198.656 40.96 163.84 108.544 108.544 163.84 40.96 198.656z'
    ]
  ],
  prefix: 'fd',
  iconName: 'user-circle'
};
export const userCircleO = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 0q104.448 0 198.656 40.96t163.84 108.544 108.544 163.84 40.96 198.656q0 103.424-39.936 198.656t-109.568 162.816-162.816 109.568-199.68 40.96-199.68-40.96-162.816-108.544-108.544-163.84-40.96-198.656 40.96-198.656 108.544-163.84 163.84-108.544 198.656-40.96zM865.28 772.096q86.016-117.76 86.016-260.096 0-89.088-34.816-169.984t-94.208-140.288-140.288-94.208-169.984-34.816-169.984 34.816-140.288 94.208-93.184 140.288-35.84 169.984q0 142.336 86.016 260.096 36.864-187.392 174.080-187.392 74.752 73.728 179.2 73.728t179.2-73.728q137.216 0 174.080 187.392zM731.136 402.432q0-91.136-63.488-155.648t-155.648-63.488-154.624 63.488-64.512 155.648 64.512 154.624 154.624 64.512 155.648-64.512 63.488-154.624z'
    ]
  ],
  prefix: 'fd',
  iconName: 'user-circle-o'
};
export const users = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M338.944 512q-92.16 3.072-151.552 72.704h-76.8q-46.080 0-78.848-22.528t-31.744-67.584q0-201.728 70.656-201.728 4.096 0 25.6 11.264t55.296 24.576 67.584 12.288q38.912 0 76.8-13.312-3.072 21.504-3.072 37.888 0 79.872 46.080 146.432zM951.296 876.544q0 67.584-41.984 107.52t-110.592 39.936h-499.712q-69.632 0-110.592-39.936t-41.984-107.52q0-30.72 2.048-59.392t8.192-62.464 14.336-62.464 24.576-55.296 35.84-46.080 49.152-30.72 63.488-11.264q6.144 0 24.576 12.288t41.984 26.624 60.416 27.648 77.824 12.288 76.8-12.288 61.44-27.648 41.984-26.624 24.576-12.288q34.816 0 63.488 11.264t48.128 30.72 35.84 46.080 24.576 55.296 15.36 62.464 8.192 62.464 2.048 59.392zM365.568 146.432q0 60.416-43.008 103.424t-103.424 43.008-103.424-43.008-43.008-103.424 43.008-103.424 103.424-43.008 103.424 43.008 43.008 103.424zM768 365.568q0 91.136-64.512 155.648t-154.624 63.488-155.648-63.488-64.512-155.648 64.512-154.624 155.648-64.512 154.624 64.512 64.512 154.624zM1096.704 494.592q0 44.032-31.744 67.584t-78.848 22.528h-76.8q-58.368-69.632-150.528-72.704 46.080-66.56 46.080-146.432 0-16.384-3.072-37.888 37.888 13.312 75.776 13.312 33.792 0 68.608-12.288t55.296-24.576 24.576-11.264q70.656 0 70.656 201.728zM1024 146.432q0 60.416-43.008 103.424t-103.424 43.008-103.424-43.008-43.008-103.424 43.008-103.424 103.424-43.008 103.424 43.008 43.008 103.424z'
    ]
  ],
  prefix: 'fd',
  iconName: 'users'
};
export const user = {
  icon: [
    731,
    1000,
    [],
    '',
    [
      'M731.136 799.744q0 61.44-35.84 106.496t-86.016 45.056h-487.424q-50.176 0-86.016-45.056t-35.84-106.496q0-49.152 5.12-92.16t17.408-87.040 33.792-74.752 53.248-51.2 77.824-19.456q74.752 73.728 178.176 73.728t179.2-73.728q43.008 0 76.8 19.456t53.248 51.2 33.792 74.752 18.432 87.040 4.096 92.16zM584.704 292.864q0 90.112-63.488 154.624t-155.648 64.512-154.624-64.512-64.512-154.624 64.512-155.648 154.624-64.512 155.648 64.512 63.488 155.648z'
    ]
  ],
  prefix: 'fd',
  iconName: 'user'
};
export const male = {
  icon: [
    585,
    1000,
    [],
    '',
    [
      'M584.704 402.432v237.568q0 22.528-15.36 38.912t-38.912 16.384-38.912-16.384-16.384-38.912v-200.704h-35.84v521.216q0 25.6-19.456 45.056t-45.056 18.432-45.056-18.432-18.432-45.056v-265.216h-36.864v265.216q0 25.6-19.456 45.056t-45.056 18.432-45.056-18.432-18.432-45.056v-521.216h-36.864v200.704q0 22.528-15.36 38.912t-38.912 16.384-38.912-16.384-16.384-38.912v-237.568q0-46.080 31.744-77.824t77.824-31.744h365.568q46.080 0 77.824 31.744t31.744 77.824zM420.864 146.432q0 53.248-37.888 90.112t-90.112 37.888-91.136-37.888-36.864-90.112 36.864-91.136 91.136-36.864 90.112 36.864 37.888 91.136z'
    ]
  ],
  prefix: 'fd',
  iconName: 'male'
};
export const userPlus = {
  icon: [
    1169,
    1000,
    [],
    '',
    [
      'M402.432 512q-91.136 0-155.648-64.512t-63.488-154.624 63.488-155.648 155.648-64.512 154.624 64.512 64.512 155.648-64.512 154.624-154.624 64.512zM951.296 584.704h200.704q7.168 0 13.312 6.144t5.12 12.288v109.568q0 8.192-5.12 13.312t-13.312 5.12h-200.704v201.728q0 7.168-6.144 12.288t-12.288 6.144h-109.568q-8.192 0-13.312-6.144t-5.12-12.288v-201.728h-201.728q-7.168 0-12.288-5.12t-6.144-13.312v-109.568q0-7.168 6.144-12.288t12.288-6.144h201.728v-200.704q0-7.168 5.12-13.312t13.312-5.12h109.568q7.168 0 12.288 5.12t6.144 13.312v200.704zM530.432 712.704q0 29.696 21.504 52.224t51.2 21.504h146.432v136.192q-38.912 28.672-97.28 28.672h-499.712q-68.608 0-110.592-39.936t-41.984-108.544q0-30.72 2.048-59.392t8.192-62.464 15.36-61.44 24.576-56.32 34.816-46.080 49.152-30.72 63.488-11.264q11.264 0 22.528 10.24 45.056 34.816 88.064 52.224t94.208 17.408 94.208-17.408 88.064-52.224q11.264-10.24 22.528-10.24 74.752 0 123.904 55.296h-128q-29.696 0-51.2 21.504t-21.504 51.2v109.568z'
    ]
  ],
  prefix: 'fd',
  iconName: 'user-plus'
};
export const addressBookO = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M587.776 367.616q0 61.44-44.032 104.448t-104.448 44.032-105.472-44.032-43.008-104.448q0-61.44 43.008-104.448t105.472-44.032 104.448 44.032 44.032 104.448zM560.128 493.568q26.624 0 47.104 10.24t33.792 26.624 22.528 37.888 14.336 47.104 6.144 47.104 2.048 45.056q0 37.888-22.528 67.584t-60.416 29.696h-328.704q-37.888 0-60.416-29.696t-22.528-67.584q0-27.648 3.072-53.248t10.24-56.32 20.48-52.224 35.84-36.864 54.272-15.36h2.048q4.096 2.048 18.432 11.264t20.48 12.288 18.432 9.216 21.504 9.216 20.48 5.12 22.528 3.072 22.528-3.072 19.456-5.12 21.504-9.216 18.432-9.216 20.48-12.288 18.432-11.264zM951.296 347.136q0 7.168-6.144 13.312t-12.288 5.12h-55.296v73.728h55.296q7.168 0 12.288 5.12t6.144 12.288v110.592q0 7.168-6.144 12.288t-12.288 5.12h-55.296v73.728h55.296q7.168 0 12.288 5.12t6.144 13.312v109.568q0 7.168-6.144 12.288t-12.288 6.144h-55.296v128q0 37.888-26.624 64.512t-64.512 26.624h-695.296q-36.864 0-64.512-26.624t-26.624-64.512v-841.728q0-37.888 26.624-64.512t64.512-26.624h695.296q37.888 0 64.512 26.624t26.624 64.512v128h55.296q7.168 0 12.288 6.144t6.144 12.288v109.568zM804.864 932.864v-841.728q0-7.168-6.144-12.288t-12.288-6.144h-695.296q-7.168 0-12.288 6.144t-6.144 12.288v841.728q0 7.168 6.144 12.288t12.288 6.144h695.296q7.168 0 12.288-6.144t6.144-12.288z'
    ]
  ],
  prefix: 'fd',
  iconName: 'address-book-o'
};
export const edit = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M507.904 676.864l65.536-66.56-87.040-87.040-65.536 66.56v31.744h54.272v55.296h32.768zM758.784 265.216q-9.216-9.216-18.432 0l-200.704 200.704q-9.216 9.216 0 18.432t18.432 0l200.704-200.704q9.216-9.216 0-18.432zM804.864 604.16v108.544q0 68.608-48.128 116.736t-116.736 48.128h-475.136q-68.608 0-116.736-48.128t-48.128-116.736v-475.136q0-67.584 48.128-115.712t116.736-49.152h475.136q35.84 0 66.56 14.336 9.216 4.096 10.24 13.312 2.048 10.24-5.12 16.384l-27.648 28.672q-8.192 8.192-18.432 4.096-13.312-3.072-25.6-3.072h-475.136q-37.888 0-64.512 26.624t-27.648 64.512v475.136q0 37.888 27.648 64.512t64.512 27.648h475.136q37.888 0 64.512-27.648t26.624-64.512v-71.68q0-7.168 5.12-12.288l36.864-36.864q8.192-8.192 20.48-4.096t11.264 16.384zM749.568 183.296l164.864 163.84-384 384h-164.864v-163.84zM1003.52 258.048l-52.224 53.248-164.864-164.864 52.224-53.248q16.384-15.36 38.912-15.36t38.912 15.36l87.040 87.040q16.384 16.384 16.384 38.912t-16.384 38.912z'
    ]
  ],
  prefix: 'fd',
  iconName: 'edit'
};
export const linkExt = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M804.864 530.432v182.272q0 68.608-48.128 116.736t-116.736 48.128h-475.136q-68.608 0-116.736-48.128t-48.128-116.736v-475.136q0-67.584 48.128-115.712t116.736-49.152h402.432q7.168 0 12.288 5.12t5.12 13.312v36.864q0 8.192-5.12 13.312t-12.288 5.12h-402.432q-37.888 0-64.512 26.624t-27.648 64.512v475.136q0 37.888 27.648 64.512t64.512 27.648h475.136q37.888 0 64.512-27.648t26.624-64.512v-182.272q0-8.192 5.12-13.312t13.312-5.12h36.864q8.192 0 13.312 5.12t5.12 13.312zM1024 36.864v291.84q0 15.36-11.264 25.6t-25.6 11.264-25.6-11.264l-100.352-100.352-372.736 372.736q-5.12 6.144-13.312 6.144t-12.288-6.144l-65.536-65.536q-6.144-5.12-6.144-12.288t6.144-13.312l372.736-372.736-100.352-100.352q-11.264-11.264-11.264-25.6t11.264-25.6 25.6-11.264h291.84q15.36 0 25.6 11.264t11.264 25.6z'
    ]
  ],
  prefix: 'fd',
  iconName: 'link-ext'
};
export const shareSquareO = {
  icon: [
    954.2948571428572,
    1000,
    [],
    '',
    [
      'M804.571 565.143v148c0 90.857-73.714 164.571-164.571 164.571h-475.429c-90.857 0-164.571-73.714-164.571-164.571v-475.429c0-90.857 73.714-164.571 164.571-164.571h145.714c9.714 0 18.286 8 18.286 18.286 0 9.143-6.286 16.571-14.857 18.286-28.571 9.714-54.286 21.143-76 34.286-2.857 1.143-5.714 2.286-9.143 2.286h-64c-50.286 0-91.429 41.143-91.429 91.429v475.429c0 50.286 41.143 91.429 91.429 91.429h475.429c50.286 0 91.429-41.143 91.429-91.429v-122.286c0-6.857 4-13.143 10.286-16.571 11.429-5.143 21.714-12.571 30.857-21.143 5.143-5.143 13.143-7.429 20-4.571s12 9.143 12 16.571zM940 281.714l-219.429 219.429c-6.857 7.429-16 10.857-25.714 10.857-4.571 0-9.714-1.143-14.286-2.857-13.143-5.714-22.286-18.857-22.286-33.714v-109.714h-91.429c-125.714 0-205.714 24-250.286 74.857-46.286 53.143-60 138.857-42.286 270.286 1.143 8-4 16-11.429 19.429-2.286 0.571-4.571 1.143-6.857 1.143-5.714 0-11.429-2.857-14.857-7.429-4-5.714-94.857-134.286-94.857-248.571 0-153.143 48-329.143 420.571-329.143h91.429v-109.714c0-14.857 9.143-28 22.286-33.714 4.571-1.714 9.714-2.857 14.286-2.857 9.714 0 18.857 4 25.714 10.857l219.429 219.429c14.286 14.286 14.286 37.143 0 51.429z'
    ]
  ],
  prefix: 'fd',
  iconName: 'share-square-o'
};
export const checkEmpty = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M640 146.432h-475.136q-37.888 0-64.512 26.624t-27.648 64.512v475.136q0 37.888 27.648 64.512t64.512 27.648h475.136q37.888 0 64.512-27.648t26.624-64.512v-475.136q0-37.888-26.624-64.512t-64.512-26.624zM804.864 237.568v475.136q0 68.608-48.128 116.736t-116.736 48.128h-475.136q-68.608 0-116.736-48.128t-48.128-116.736v-475.136q0-67.584 48.128-115.712t116.736-49.152h475.136q67.584 0 116.736 49.152t48.128 115.712z'
    ]
  ],
  prefix: 'fd',
  iconName: 'check-empty'
};
export const check = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M804.864 531.456v181.248q0 68.608-48.128 116.736t-116.736 48.128h-475.136q-68.608 0-116.736-48.128t-48.128-116.736v-475.136q0-67.584 48.128-115.712t116.736-49.152h475.136q35.84 0 66.56 14.336 9.216 4.096 10.24 13.312 2.048 10.24-5.12 16.384l-27.648 28.672q-6.144 5.12-13.312 5.12-1.024 0-5.12-1.024-13.312-3.072-25.6-3.072h-475.136q-37.888 0-64.512 26.624t-27.648 64.512v475.136q0 37.888 27.648 64.512t64.512 27.648h475.136q37.888 0 64.512-27.648t26.624-64.512v-144.384q0-8.192 5.12-13.312l36.864-35.84q6.144-6.144 13.312-6.144 3.072 0 7.168 2.048 11.264 4.096 11.264 16.384zM936.96 251.904l-465.92 464.896q-13.312 14.336-31.744 14.336t-32.768-14.336l-245.76-245.76q-14.336-13.312-14.336-31.744t14.336-32.768l62.464-63.488q14.336-13.312 32.768-13.312t32.768 13.312l150.528 150.528 369.664-369.664q13.312-13.312 31.744-13.312t32.768 13.312l63.488 62.464q13.312 14.336 13.312 32.768t-13.312 32.768z'
    ]
  ],
  prefix: 'fd',
  iconName: 'check'
};
export const cancel = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M0 797.696l285.696-285.696-285.696-285.696 226.304-226.304 285.696 285.696 285.696-285.696 226.304 226.304-285.696 285.696 285.696 285.696-226.304 226.304-285.696-285.696-285.696 285.696z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cancel'
};
export const stop = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M877.568 109.568v804.864q0 14.336-10.24 25.6t-26.624 11.264h-803.84q-15.36 0-25.6-11.264t-11.264-25.6v-804.864q0-14.336 11.264-25.6t25.6-11.264h803.84q15.36 0 26.624 11.264t10.24 25.6z'
    ]
  ],
  prefix: 'fd',
  iconName: 'stop'
};
export const pause1 = {
  icon: [
    768,
    1000,
    [],
    '',
    ['M0 896v-768h320.512v768h-320.512zM448.512 896v-768h319.488v768h-319.488z']
  ],
  prefix: 'fd',
  iconName: 'pause-1'
};
export const plus = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M804.864 420.864v109.568q0 22.528-16.384 38.912t-38.912 15.36h-237.568v238.592q0 22.528-16.384 37.888t-38.912 16.384h-109.568q-22.528 0-38.912-16.384t-15.36-37.888v-238.592h-237.568q-23.552 0-38.912-15.36t-16.384-38.912v-109.568q0-23.552 16.384-38.912t38.912-16.384h237.568v-237.568q0-22.528 15.36-38.912t38.912-16.384h109.568q23.552 0 38.912 16.384t16.384 38.912v237.568h237.568q23.552 0 38.912 16.384t16.384 38.912z'
    ]
  ],
  prefix: 'fd',
  iconName: 'plus'
};
export const minus = {
  icon: [
    804,
    1000,
    [],
    '',
    [
      'M804.864 420.864v109.568q0 22.528-16.384 38.912t-38.912 15.36h-694.272q-23.552 0-38.912-15.36t-16.384-38.912v-109.568q0-23.552 16.384-38.912t38.912-16.384h694.272q23.552 0 38.912 16.384t16.384 38.912z'
    ]
  ],
  prefix: 'fd',
  iconName: 'minus'
};
export const download = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M731.136 768q0-15.36-10.24-25.6t-25.6-11.264-25.6 11.264-11.264 25.6 11.264 25.6 25.6 11.264 25.6-11.264 10.24-25.6zM877.568 768q0-15.36-10.24-25.6t-26.624-11.264-25.6 11.264-10.24 25.6 10.24 25.6 25.6 11.264 26.624-11.264 10.24-25.6zM951.296 640v183.296q0 22.528-16.384 37.888t-38.912 16.384h-840.704q-23.552 0-38.912-16.384t-16.384-37.888v-183.296q0-22.528 16.384-38.912t38.912-16.384h265.216l76.8 77.824q33.792 32.768 77.824 32.768t77.824-32.768l77.824-77.824h265.216q22.528 0 38.912 16.384t16.384 38.912zM764.928 314.368q10.24 23.552-8.192 39.936l-256 256q-10.24 11.264-25.6 11.264t-25.6-11.264l-256-256q-17.408-16.384-8.192-39.936 10.24-21.504 33.792-21.504h146.432v-256q0-15.36 11.264-25.6t25.6-11.264h146.432q14.336 0 25.6 11.264t10.24 25.6v256h146.432q24.576 0 33.792 21.504z'
    ]
  ],
  prefix: 'fd',
  iconName: 'download'
};
export const upload = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M731.136 840.704q0-14.336-10.24-25.6t-25.6-10.24-25.6 10.24-11.264 25.6 11.264 25.6 25.6 11.264 25.6-11.264 10.24-25.6zM877.568 840.704q0-14.336-10.24-25.6t-26.624-10.24-25.6 10.24-10.24 25.6 10.24 25.6 25.6 11.264 26.624-11.264 10.24-25.6zM951.296 712.704v183.296q0 22.528-16.384 38.912t-38.912 16.384h-840.704q-23.552 0-38.912-16.384t-16.384-38.912v-183.296q0-22.528 16.384-38.912t38.912-15.36h243.712q12.288 31.744 39.936 52.224t63.488 20.48h146.432q34.816 0 62.464-20.48t40.96-52.224h243.712q22.528 0 38.912 15.36t16.384 38.912zM764.928 343.040q-9.216 22.528-33.792 22.528h-146.432v256q0 15.36-10.24 25.6t-25.6 11.264h-146.432q-15.36 0-25.6-11.264t-11.264-25.6v-256h-146.432q-23.552 0-33.792-22.528-9.216-22.528 8.192-39.936l256-256q10.24-10.24 25.6-10.24t25.6 10.24l256 256q18.432 17.408 8.192 39.936z'
    ]
  ],
  prefix: 'fd',
  iconName: 'upload'
};
export const arrowsCw = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M863.232 603.136q0 3.072 0 4.096-36.864 153.6-153.6 248.832t-273.408 95.232q-82.944 0-160.768-31.744t-139.264-90.112l-73.728 73.728q-11.264 11.264-25.6 11.264t-25.6-11.264-11.264-25.6v-256q0-14.336 11.264-25.6t25.6-11.264h256q14.336 0 25.6 11.264t10.24 25.6-10.24 25.6l-78.848 78.848q40.96 36.864 92.16 58.368t107.52 20.48q75.776 0 142.336-37.888t106.496-101.376q6.144-10.24 30.72-67.584 4.096-13.312 16.384-13.312h109.568q8.192 0 13.312 6.144t5.12 12.288zM877.568 146.432v256q0 14.336-10.24 25.6t-26.624 11.264h-256q-14.336 0-25.6-11.264t-10.24-25.6 10.24-25.6l78.848-78.848q-83.968-78.848-198.656-78.848-76.8 0-143.36 37.888t-106.496 101.376q-6.144 10.24-29.696 67.584-5.12 13.312-17.408 13.312h-113.664q-7.168 0-13.312-6.144t-5.12-12.288v-4.096q36.864-153.6 154.624-248.832t274.432-95.232q82.944 0 161.792 31.744t140.288 90.112l73.728-73.728q11.264-11.264 25.6-11.264t26.624 11.264 10.24 25.6z'
    ]
  ],
  prefix: 'fd',
  iconName: 'arrows-cw'
};
export const rotateDoc = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M349.6 23.4l-245.6 0.6v976h816v-749l-229-229-48 0.4c-26.4 0.4-158.4 0.8-293.4 1zM593.6 227.4l0.4 122.6h244l-0.4 284.4-0.6 284.6h-650l-0.6-405c-0.2-222.8 0-406.2 0.6-407.6 0.6-2 42.4-2.4 203.4-2l202.6 0.6 0.6 122.4zM749.6 267.6c-38.8 0.2-71.8 0-73-0.6-2-0.6-2.6-17-2.6-73.4v-72.6l146 146-70.4 0.6z',
      'M413.6 397.6l-73.4 73.4 72.8 74 72.6 74 58.4-58-24.6-24.6-24.4-24.8 22.2 1c36.8 1.8 69 16 88.8 39 17.4 20.4 28 51.8 28 82.8-0.2 57.2-29.2 98.6-82 116.8-8.8 3-16.8 3.8-40 3.8-31.6 0-39.2-1.6-63-13.6-17.4-8.6-37.2-29.4-46-47.8-7.4-15.6-13-37.2-13-51.2v-8.4h-82.4l1.4 15.4c7.8 84.2 73.2 160.2 157 183 14.2 3.8 22 4.6 46 4.4 29.8 0 40.8-1.8 65.6-10.8 63.2-23.4 114.6-80.4 132.8-147.6 6-22.6 6-63 0-87.2-14.4-57.6-56.6-110.2-110.4-138-28.6-14.8-63-23.2-95-23.2h-10l49-49-57-57-73.4 73.6z'
    ]
  ],
  prefix: 'fd',
  iconName: 'rotate-doc'
};
export const loop = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M588.8 683.008l172.032-228.352 172.032 228.352h-114.688v58.368q0 70.656-49.152 120.832t-121.856 50.176h-342.016q-71.68 0-121.856-50.176t-50.176-120.832v-58.368h113.664v58.368q0 22.528 17.408 39.936t40.96 16.384h342.016q23.552 0 40.96-15.36t16.384-40.96v-58.368h-115.712zM362.496 339.968l-171.008 229.376-173.056-229.376h114.688v-56.32q0-70.656 50.176-120.832t121.856-51.2h342.016q71.68 0 121.856 51.2t49.152 120.832v56.32h-113.664v-56.32q0-24.576-16.384-40.96t-40.96-16.384h-342.016q-24.576 0-40.96 16.384t-17.408 40.96v56.32h115.712z'
    ]
  ],
  prefix: 'fd',
  iconName: 'loop'
};
export const retweet = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M731.136 859.136q0 7.168-5.12 13.312t-13.312 5.12h-547.84q-5.12 0-8.192-1.024t-5.12-4.096-3.072-4.096-2.048-7.168 0-6.144v-343.040h-109.568q-15.36 0-25.6-11.264t-11.264-25.6q0-13.312 8.192-23.552l183.296-219.136q11.264-12.288 27.648-12.288t28.672 12.288l182.272 219.136q9.216 10.24 9.216 23.552 0 15.36-11.264 25.6t-25.6 11.264h-109.568v219.136h328.704q9.216 0 14.336 6.144l91.136 110.592q4.096 5.12 4.096 11.264zM1096.704 621.568q0 13.312-8.192 23.552l-182.272 219.136q-12.288 13.312-28.672 13.312t-27.648-13.312l-183.296-219.136q-8.192-10.24-8.192-23.552 0-14.336 11.264-25.6t25.6-11.264h109.568v-219.136h-329.728q-9.216 0-14.336-7.168l-91.136-109.568q-4.096-5.12-4.096-11.264 0-7.168 5.12-12.288t13.312-6.144h548.864q4.096 0 7.168 1.024t5.12 4.096 3.072 5.12 2.048 6.144 1.024 7.168v342.016h109.568q14.336 0 25.6 11.264t10.24 25.6z'
    ]
  ],
  prefix: 'fd',
  iconName: 'retweet'
};
export const share = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M0 994.304q0-146.432 24.576-262.144t61.44-190.464 97.28-126.976 109.568-77.824 124.928-38.912 116.736-15.36 109.568-2.048v-250.88l379.904 380.928-379.904 379.904v-274.432q-104.448 0-154.624 1.024t-129.024 10.24-116.736 26.624-88.064 52.224-75.776 84.992-48.128 126.976-31.744 176.128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'share'
};
export const angleDoubleLeft = {
  icon: [
    585,
    1000,
    [],
    '',
    [
      'M358.4 786.432q0 7.168-6.144 13.312l-28.672 28.672q-5.12 5.12-12.288 5.12t-13.312-5.12l-266.24-267.264q-6.144-5.12-6.144-12.288t6.144-13.312l266.24-266.24q5.12-6.144 13.312-6.144t12.288 6.144l28.672 28.672q6.144 5.12 6.144 13.312t-6.144 12.288l-224.256 225.28 224.256 224.256q6.144 6.144 6.144 13.312zM577.536 786.432q0 7.168-5.12 13.312l-28.672 28.672q-6.144 5.12-13.312 5.12t-13.312-5.12l-266.24-267.264q-6.144-5.12-6.144-12.288t6.144-13.312l266.24-266.24q6.144-6.144 13.312-6.144t13.312 6.144l28.672 28.672q5.12 5.12 5.12 13.312t-5.12 12.288l-225.28 225.28 225.28 224.256q5.12 6.144 5.12 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'angle-double-left'
};
export const angleDoubleRight = {
  icon: [
    585,
    1000,
    [],
    '',
    [
      'M339.968 548.864q0 7.168-5.12 12.288l-267.264 267.264q-5.12 5.12-12.288 5.12t-13.312-5.12l-28.672-28.672q-6.144-6.144-6.144-13.312t6.144-13.312l224.256-224.256-224.256-225.28q-6.144-5.12-6.144-12.288t6.144-13.312l28.672-28.672q5.12-6.144 13.312-6.144t12.288 6.144l267.264 266.24q5.12 5.12 5.12 13.312zM559.104 548.864q0 7.168-5.12 12.288l-266.24 267.264q-6.144 5.12-13.312 5.12t-13.312-5.12l-28.672-28.672q-5.12-6.144-5.12-13.312t5.12-13.312l224.256-224.256-224.256-225.28q-5.12-5.12-5.12-12.288t5.12-13.312l28.672-28.672q6.144-6.144 13.312-6.144t13.312 6.144l266.24 266.24q5.12 5.12 5.12 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'angle-double-right'
};
export const angleLeft = {
  icon: [
    366,
    1000,
    [],
    '',
    [
      'M358.4 311.296q0 7.168-6.144 12.288l-224.256 225.28 224.256 224.256q6.144 6.144 6.144 13.312t-6.144 13.312l-28.672 28.672q-5.12 5.12-12.288 5.12t-13.312-5.12l-266.24-267.264q-6.144-5.12-6.144-12.288t6.144-13.312l266.24-266.24q5.12-6.144 13.312-6.144t12.288 6.144l28.672 28.672q6.144 5.12 6.144 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'angle-left'
};
export const angleRight = {
  icon: [
    366,
    1000,
    [],
    '',
    [
      'M339.968 548.864q0 7.168-5.12 12.288l-267.264 267.264q-5.12 5.12-12.288 5.12t-13.312-5.12l-28.672-28.672q-6.144-6.144-6.144-13.312t6.144-13.312l224.256-224.256-224.256-225.28q-6.144-5.12-6.144-12.288t6.144-13.312l28.672-28.672q5.12-6.144 13.312-6.144t12.288 6.144l267.264 266.24q5.12 5.12 5.12 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'angle-right'
};
export const angleUp = {
  icon: [
    657,
    1000,
    [],
    '',
    [
      'M614.4 676.864q0 7.168-6.144 12.288l-28.672 28.672q-5.12 6.144-12.288 6.144t-13.312-6.144l-225.28-224.256-224.256 224.256q-5.12 6.144-13.312 6.144t-12.288-6.144l-28.672-28.672q-6.144-5.12-6.144-12.288t6.144-13.312l266.24-266.24q5.12-6.144 12.288-6.144t13.312 6.144l266.24 266.24q6.144 5.12 6.144 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'angle-up'
};
export const angleDown = {
  icon: [
    657,
    1000,
    [],
    '',
    [
      'M614.4 420.864q0 7.168-6.144 12.288l-266.24 267.264q-5.12 5.12-13.312 5.12t-12.288-5.12l-266.24-267.264q-6.144-5.12-6.144-12.288t6.144-13.312l28.672-28.672q5.12-6.144 12.288-6.144t13.312 6.144l224.256 224.256 225.28-224.256q5.12-6.144 13.312-6.144t12.288 6.144l28.672 28.672q6.144 5.12 6.144 13.312z'
    ]
  ],
  prefix: 'fd',
  iconName: 'angle-down'
};
export const folderEmpty = {
  icon: [
    950,
    1000,
    [],
    '',
    [
      'M877.568 749.568v-402.432q0-22.528-15.36-38.912t-38.912-15.36h-402.432q-23.552 0-38.912-16.384t-16.384-38.912v-36.864q0-22.528-15.36-38.912t-38.912-15.36h-183.296q-22.528 0-38.912 15.36t-16.384 38.912v548.864q0 22.528 16.384 38.912t38.912 16.384h695.296q22.528 0 38.912-16.384t15.36-38.912zM951.296 347.136v402.432q0 52.224-37.888 90.112t-90.112 37.888h-695.296q-52.224 0-90.112-37.888t-37.888-90.112v-548.864q0-52.224 37.888-90.112t90.112-37.888h183.296q52.224 0 90.112 37.888t37.888 90.112v18.432h384q52.224 0 90.112 37.888t37.888 90.112z'
    ]
  ],
  prefix: 'fd',
  iconName: 'folder-empty'
};
export const archive = {
  icon: [
    1246,
    1000,
    [],
    '',
    [
      'M1246.208 45.056v134.144q0 18.432-12.288 30.72t-31.744 13.312h-1158.144q-17.408 0-30.72-13.312t-13.312-30.72v-134.144q0-17.408 13.312-30.72t30.72-13.312h1158.144q18.432 0 31.744 13.312t12.288 30.72zM1202.176 357.376v623.616q0 17.408-13.312 30.72t-31.744 13.312h-1068.032q-18.432 0-31.744-13.312t-13.312-30.72v-623.616q0-18.432 13.312-31.744t31.744-13.312h1068.032q18.432 0 31.744 13.312t13.312 31.744zM890.88 513.024q0-27.648-19.456-47.104t-48.128-19.456h-400.384q-27.648 0-47.104 19.456t-19.456 47.104 19.456 47.104 47.104 19.456h400.384q27.648 0 48.128-19.456t19.456-47.104z'
    ]
  ],
  prefix: 'fd',
  iconName: 'archive'
};
export const inbox = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M584.704 548.864h180.224q0-2.048-1.024-5.12t-2.048-4.096l-120.832-283.648h-404.48l-120.832 283.648q-1.024 1.024-2.048 4.096t-1.024 5.12h180.224l54.272 109.568h183.296zM877.568 565.248v275.456q0 15.36-10.24 25.6t-26.624 11.264h-803.84q-15.36 0-25.6-11.264t-11.264-25.6v-275.456q0-34.816 14.336-69.632l136.192-315.392q5.12-14.336 20.48-24.576t29.696-9.216h476.16q14.336 0 29.696 9.216t20.48 24.576l136.192 315.392q14.336 34.816 14.336 69.632z'
    ]
  ],
  prefix: 'fd',
  iconName: 'inbox'
};
export const signup = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M833.536 98.304h-642.048c-0.306-0.016-0.664-0.026-1.024-0.026-11.311 0-20.48 9.169-20.48 20.48 0 0.009 0 0.018 0 0.027v-0.001 774.144c-0.017 0.314-0.027 0.681-0.027 1.051 0 11.311 9.169 20.48 20.48 20.48 0.37 0 0.737-0.010 1.102-0.029l-0.051 0.002h642.048c0.314 0.017 0.681 0.027 1.051 0.027 11.311 0 20.48-9.169 20.48-20.48 0-0.37-0.010-0.737-0.029-1.102l0.002 0.051v-774.144c0-0.008 0-0.017 0-0.026 0-11.311-9.169-20.48-20.48-20.48-0.36 0-0.718 0.009-1.074 0.028l0.050-0.002zM668.672 626.688c0 8.483-6.877 15.36-15.36 15.36v0h-281.6c-8.483 0-15.36-6.877-15.36-15.36v0-37.888c0.553-8.031 7.203-14.336 15.326-14.336 0.012 0 0.024 0 0.036 0h281.598c0.010 0 0.022 0 0.034 0 8.123 0 14.773 6.305 15.323 14.288l0.003 0.048zM788.48 489.472c0 8.483-6.877 15.36-15.36 15.36v0h-521.216c-8.483 0-15.36-6.877-15.36-15.36v0-67.584c0-8.483 6.877-15.36 15.36-15.36v0h521.216c8.483 0 15.36 6.877 15.36 15.36v0zM788.48 362.496c0 8.483-6.877 15.36-15.36 15.36v0h-521.216c-8.483 0-15.36-6.877-15.36-15.36v0-68.608c0.553-8.031 7.203-14.336 15.326-14.336 0.012 0 0.024 0 0.036 0h521.214c0.010 0 0.022 0 0.034 0 8.123 0 14.773 6.305 15.323 14.288l0.003 0.048z'
    ]
  ],
  prefix: 'fd',
  iconName: 'signup'
};
export const docs = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M968.704 219.136q23.552 0 38.912 16.384t16.384 38.912v694.272q0 23.552-16.384 38.912t-38.912 16.384h-547.84q-23.552 0-38.912-16.384t-16.384-38.912v-163.84h-310.272q-23.552 0-38.912-16.384t-16.384-38.912v-384q0-22.528 11.264-50.176t27.648-43.008l233.472-233.472q15.36-16.384 43.008-27.648t50.176-11.264h237.568q23.552 0 38.912 16.384t16.384 38.912v187.392q38.912-23.552 72.704-23.552h237.568zM658.432 340.992l-171.008 171.008h171.008v-171.008zM292.864 121.856l-171.008 171.008h171.008v-171.008zM404.48 491.52l180.224-180.224v-238.592h-219.136v238.592q0 22.528-15.36 37.888t-38.912 16.384h-238.592v365.568h292.864v-146.432q0-22.528 11.264-50.176t27.648-43.008zM951.296 951.296v-658.432h-220.16v237.568q0 22.528-15.36 38.912t-38.912 15.36h-237.568v366.592h512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'docs'
};
export const docText = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M838.656 217.088q16.384 16.384 27.648 43.008t11.264 51.2v657.408q0 23.552-15.36 38.912t-38.912 16.384h-768q-23.552 0-38.912-16.384t-16.384-38.912v-913.408q0-23.552 16.384-38.912t38.912-16.384h512q22.528 0 50.176 11.264t43.008 27.648zM584.704 77.824v215.040h215.040q-5.12-17.408-12.288-23.552l-179.2-179.2q-6.144-7.168-23.552-12.288zM804.864 951.296v-585.728h-237.568q-23.552 0-38.912-16.384t-16.384-37.888v-238.592h-439.296v878.592h732.16zM219.136 456.704q0-7.168 5.12-12.288t13.312-5.12h402.432q8.192 0 13.312 5.12t5.12 12.288v36.864q0 8.192-5.12 13.312t-13.312 5.12h-402.432q-8.192 0-13.312-5.12t-5.12-13.312v-36.864zM640 584.704q8.192 0 13.312 5.12t5.12 13.312v36.864q0 8.192-5.12 13.312t-13.312 5.12h-402.432q-8.192 0-13.312-5.12t-5.12-13.312v-36.864q0-8.192 5.12-13.312t13.312-5.12h402.432zM640 731.136q8.192 0 13.312 5.12t5.12 13.312v36.864q0 8.192-5.12 13.312t-13.312 5.12h-402.432q-8.192 0-13.312-5.12t-5.12-13.312v-36.864q0-8.192 5.12-13.312t13.312-5.12h402.432z'
    ]
  ],
  prefix: 'fd',
  iconName: 'doc-text'
};
export const fileArchive = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M365.568 219.136v-72.704h-72.704v72.704h72.704zM439.296 292.864v-73.728h-73.728v73.728h73.728zM365.568 365.568v-72.704h-72.704v72.704h72.704zM439.296 439.296v-73.728h-73.728v73.728h73.728zM838.656 217.088q16.384 16.384 27.648 43.008t11.264 51.2v657.408q0 23.552-15.36 38.912t-38.912 16.384h-768q-23.552 0-38.912-16.384t-16.384-38.912v-913.408q0-23.552 16.384-38.912t38.912-16.384h512q22.528 0 50.176 11.264t43.008 27.648zM584.704 77.824v215.040h215.040q-5.12-17.408-12.288-23.552l-179.2-179.2q-6.144-7.168-23.552-12.288zM804.864 951.296v-585.728h-237.568q-23.552 0-38.912-16.384t-16.384-37.888v-238.592h-72.704v73.728h-73.728v-73.728h-292.864v878.592h732.16zM446.464 538.624l61.44 199.68q4.096 15.36 4.096 29.696 0 47.104-40.96 78.848t-105.472 30.72-104.448-30.72-41.984-78.848q0-14.336 5.12-29.696 12.288-35.84 68.608-226.304v-72.704h72.704v72.704h45.056q13.312 0 22.528 7.168t13.312 19.456zM365.568 804.864q30.72 0 52.224-11.264t21.504-25.6-21.504-25.6-52.224-11.264-51.2 11.264-21.504 25.6 21.504 25.6 51.2 11.264z'
    ]
  ],
  prefix: 'fd',
  iconName: 'file-archive'
};
export const fileImage = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M838.656 217.088q16.384 16.384 27.648 43.008t11.264 51.2v657.408q0 23.552-15.36 38.912t-38.912 16.384h-768q-23.552 0-38.912-16.384t-16.384-38.912v-913.408q0-23.552 16.384-38.912t38.912-16.384h512q22.528 0 50.176 11.264t43.008 27.648zM584.704 77.824v215.040h215.040q-5.12-17.408-12.288-23.552l-179.2-179.2q-6.144-7.168-23.552-12.288zM804.864 951.296v-585.728h-237.568q-23.552 0-38.912-16.384t-16.384-37.888v-238.592h-439.296v878.592h732.16zM731.136 695.296v182.272h-584.704v-109.568l109.568-109.568 72.704 72.704 220.16-219.136zM256 584.704q-46.080 0-77.824-31.744t-31.744-77.824 31.744-77.824 77.824-31.744 77.824 31.744 31.744 77.824-31.744 77.824-77.824 31.744z'
    ]
  ],
  prefix: 'fd',
  iconName: 'file-image'
};
export const filePdf = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M838.656 217.088q16.384 16.384 27.648 43.008t11.264 51.2v657.408q0 23.552-15.36 38.912t-38.912 16.384h-768q-23.552 0-38.912-16.384t-16.384-38.912v-913.408q0-23.552 16.384-38.912t38.912-16.384h512q22.528 0 50.176 11.264t43.008 27.648zM584.704 77.824v215.040h215.040q-5.12-17.408-12.288-23.552l-179.2-179.2q-6.144-7.168-23.552-12.288zM804.864 951.296v-585.728h-237.568q-23.552 0-38.912-16.384t-16.384-37.888v-238.592h-439.296v878.592h732.16zM510.976 612.352q18.432 14.336 48.128 31.744 33.792-4.096 66.56-4.096 83.968 0 101.376 27.648 9.216 13.312 1.024 29.696 0 1.024-1.024 1.024l-1.024 2.048q-3.072 21.504-39.936 21.504-27.648 0-65.536-11.264t-74.752-29.696q-125.952 13.312-224.256 47.104-87.040 149.504-138.24 149.504-8.192 0-15.36-4.096l-14.336-7.168q0 0-3.072-2.048-6.144-6.144-4.096-20.48 5.12-23.552 32.768-52.224t74.752-55.296q8.192-5.12 13.312 3.072 1.024 1.024 1.024 2.048 29.696-48.128 61.44-112.64 38.912-77.824 59.392-149.504-13.312-47.104-17.408-91.136t4.096-72.704q6.144-22.528 23.552-22.528h12.288q13.312 0 20.48 8.192 10.24 12.288 5.12 38.912-1.024 3.072-2.048 4.096 0 2.048 0 5.12v17.408q-1.024 69.632-8.192 109.568 31.744 93.184 83.968 136.192zM182.272 846.848q29.696-13.312 77.824-90.112-29.696 22.528-50.176 48.128t-27.648 41.984zM409.6 321.536q-9.216 23.552-2.048 74.752 1.024-4.096 4.096-24.576 0-2.048 4.096-24.576 1.024-3.072 3.072-5.12-1.024 0-1.024-1.024-1.024-1.024-1.024-2.048 0-12.288-7.168-20.48 0 1.024 0 1.024v2.048zM337.92 698.368q77.824-30.72 162.816-46.080-1.024 0-7.168-5.12t-9.216-8.192q-44.032-37.888-72.704-100.352-15.36 49.152-47.104 112.64-17.408 31.744-26.624 47.104zM707.584 689.152q-13.312-13.312-79.872-13.312 43.008 16.384 70.656 16.384 8.192 0 10.24-1.024 0 0-1.024-2.048z'
    ]
  ],
  prefix: 'fd',
  iconName: 'file-pdf'
};
export const desktop = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M1024 567.296v-476.16q0-7.168-5.12-12.288t-13.312-6.144h-914.432q-7.168 0-12.288 6.144t-6.144 12.288v476.16q0 7.168 6.144 12.288t12.288 5.12h914.432q7.168 0 13.312-5.12t5.12-12.288zM1096.704 91.136v621.568q0 37.888-26.624 64.512t-64.512 27.648h-310.272q0 20.48 9.216 44.032t17.408 40.96 9.216 24.576q0 14.336-10.24 25.6t-25.6 11.264h-292.864q-15.36 0-25.6-11.264t-11.264-25.6q0-8.192 9.216-25.6t18.432-39.936 9.216-44.032h-311.296q-36.864 0-64.512-27.648t-26.624-64.512v-621.568q0-37.888 26.624-64.512t64.512-26.624h914.432q37.888 0 64.512 26.624t26.624 64.512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'desktop'
};
export const digital = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M900.096 489.472h-13.312v-280.576c0-36.864-29.696-67.584-66.56-67.584h-668.672c-36.864 0-66.56 30.72-66.56 67.584v454.656c0 35.84 29.696 66.56 66.56 66.56h227.328c0 35.84-26.624 64.512-26.624 79.872 0 14.336 12.288 26.624 26.624 26.624h214.016c14.336 0 26.624-12.288 26.624-26.624s-26.624-44.032-26.624-79.872h109.568v115.712c0 21.504 17.408 38.912 38.912 38.912h158.72c21.504 0 38.912-17.408 38.912-38.912v-317.44c0-21.504-17.408-38.912-38.912-38.912zM845.824 528.384c2.048 0 4.096 3.072 4.096 5.12 0 3.072-2.048 5.12-4.096 5.12h-50.176c-2.048 0-5.12-2.048-5.12-5.12 0-2.048 3.072-5.12 5.12-5.12h50.176c0 0 0 0 0 0zM702.464 528.384v40.96h-550.912c-7.168 0-13.312-6.144-13.312-13.312v-347.136c0-7.168 6.144-13.312 13.312-13.312h668.672c7.168 0 13.312 6.144 13.312 13.312v280.576h-92.16c-21.504 0-38.912 17.408-38.912 38.912zM820.224 870.4c-13.312 0-24.576-11.264-24.576-24.576 0-14.336 11.264-25.6 24.576-25.6s25.6 11.264 25.6 25.6-11.264 24.576-25.6 24.576zM909.312 795.648c0 5.12-4.096 10.24-9.216 10.24h-158.72c-5.12 0-9.216-5.12-9.216-10.24v-217.088c0-5.12 4.096-10.24 9.216-10.24h158.72c5.12 0 9.216 5.12 9.216 10.24v217.088z'
    ]
  ],
  prefix: 'fd',
  iconName: 'digital'
};
export const laptop = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M237.568 731.136q-37.888 0-64.512-26.624t-26.624-64.512v-402.432q0-37.888 26.624-64.512t64.512-26.624h621.568q37.888 0 64.512 26.624t27.648 64.512v402.432q0 37.888-27.648 64.512t-64.512 26.624h-621.568zM219.136 237.568v402.432q0 7.168 6.144 13.312t12.288 5.12h621.568q8.192 0 13.312-5.12t5.12-13.312v-402.432q0-7.168-5.12-12.288t-13.312-6.144h-621.568q-7.168 0-12.288 6.144t-6.144 12.288zM1005.568 768h91.136v55.296q0 22.528-26.624 37.888t-64.512 16.384h-914.432q-36.864 0-64.512-16.384t-26.624-37.888v-55.296h1005.568zM593.92 823.296q9.216 0 9.216-9.216t-9.216-9.216h-91.136q-9.216 0-9.216 9.216t9.216 9.216h91.136z'
    ]
  ],
  prefix: 'fd',
  iconName: 'laptop'
};
export const tablet = {
  icon: [
    657,
    1000,
    [],
    '',
    [
      'M365.568 804.864q0-15.36-10.24-25.6t-26.624-11.264-25.6 11.264-10.24 25.6 10.24 25.6 25.6 10.24 26.624-10.24 10.24-25.6zM584.704 712.704v-547.84q0-8.192-5.12-13.312t-12.288-5.12h-476.16q-7.168 0-12.288 5.12t-6.144 13.312v547.84q0 8.192 6.144 13.312t12.288 5.12h476.16q7.168 0 12.288-5.12t5.12-13.312zM658.432 164.864v621.568q0 37.888-26.624 64.512t-64.512 26.624h-476.16q-36.864 0-64.512-26.624t-26.624-64.512v-621.568q0-37.888 26.624-64.512t64.512-27.648h476.16q36.864 0 64.512 27.648t26.624 64.512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'tablet'
};
export const outdoor = {
  icon: [
    731,
    1000,
    [],
    '',
    [
      'M584.704 718.848q0 36.864-20.48 61.44t-52.224 24.576h-292.864q-30.72 0-51.2-24.576t-21.504-61.44 5.12-67.584 16.384-59.392 34.816-45.056 55.296-16.384q46.080 43.008 107.52 43.008t107.52-43.008q31.744 0 55.296 16.384t34.816 45.056 16.384 59.392 5.12 67.584zM497.664 421.888q0 54.272-38.912 92.16t-93.184 37.888-92.16-37.888-38.912-92.16 38.912-91.136 92.16-37.888 93.184 37.888 38.912 91.136zM658.432 932.864v-786.432h-585.728v786.432q0 7.168 6.144 12.288t12.288 6.144h548.864q7.168 0 13.312-6.144t5.12-12.288zM731.136 91.136v841.728q0 37.888-26.624 64.512t-64.512 26.624h-548.864q-36.864 0-64.512-26.624t-26.624-64.512v-841.728q0-37.888 26.624-64.512t64.512-26.624h201.728v55.296q0 7.168 5.12 12.288t13.312 5.12h109.568q8.192 0 13.312-5.12t5.12-12.288v-55.296h200.704q37.888 0 64.512 26.624t26.624 64.512z'
    ]
  ],
  prefix: 'fd',
  iconName: 'outdoor'
};
export const mobile1 = {
  icon: [
    438,
    1000,
    [],
    '',
    [
      'M265.216 804.864q0-19.456-13.312-32.768t-32.768-13.312-31.744 13.312-13.312 32.768 13.312 31.744 31.744 13.312 32.768-13.312 13.312-31.744zM384 712.704v-401.408q0-8.192-5.12-13.312t-13.312-5.12h-292.864q-7.168 0-12.288 5.12t-5.12 13.312v401.408q0 8.192 5.12 13.312t12.288 5.12h292.864q7.168 0 13.312-5.12t5.12-13.312zM274.432 228.352q0-9.216-9.216-9.216h-91.136q-9.216 0-9.216 9.216t9.216 9.216h91.136q9.216 0 9.216-9.216zM439.296 219.136v585.728q0 29.696-22.528 51.2t-51.2 21.504h-292.864q-29.696 0-51.2-21.504t-21.504-51.2v-585.728q0-29.696 21.504-51.2t51.2-21.504h292.864q29.696 0 51.2 21.504t22.528 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'mobile-1'
};
export const mobile = {
  icon: [
    486,
    1000,
    [],
    '',
    [
      'M243.712 902.144c27.648 0 48.128-23.552 48.128-49.152 0-27.648-20.48-48.128-48.128-48.128s-49.152 20.48-49.152 48.128c0 25.6 20.48 49.152 49.152 49.152zM86.016 89.088h314.368c51.2 0 86.016 34.816 86.016 82.944v686.080c0 43.008-34.816 76.8-76.8 76.8h-332.8c-41.984 0-76.8-33.792-76.8-76.8v-686.080c0-48.128 34.816-82.944 86.016-82.944zM179.2 144.384c-9.216 0-15.36 7.168-15.36 16.384s6.144 16.384 15.36 16.384h128c9.216 0 15.36-7.168 15.36-16.384s-6.144-16.384-15.36-16.384h-128zM440.32 765.952v-507.904h-394.24v507.904h394.24z'
    ]
  ],
  prefix: 'fd',
  iconName: 'mobile'
};
export const creditCard = {
  icon: [
    1097,
    1000,
    [],
    '',
    [
      'M1005.568 72.704q37.888 0 64.512 27.648t26.624 64.512v694.272q0 37.888-26.624 64.512t-64.512 27.648h-914.432q-36.864 0-64.512-27.648t-26.624-64.512v-694.272q0-37.888 26.624-64.512t64.512-27.648h914.432zM91.136 146.432q-7.168 0-12.288 5.12t-6.144 13.312v128h951.296v-128q0-8.192-5.12-13.312t-13.312-5.12h-914.432zM1005.568 877.568q7.168 0 13.312-5.12t5.12-13.312v-347.136h-951.296v347.136q0 7.168 6.144 13.312t12.288 5.12h914.432zM146.432 804.864v-73.728h146.432v73.728h-146.432zM365.568 804.864v-73.728h219.136v73.728h-219.136z'
    ]
  ],
  prefix: 'fd',
  iconName: 'credit-card'
};
export const creditCardAlt = {
  icon: [
    1316,
    1000,
    [],
    '',
    [
      'M0 859.136v-347.136h1316.864v347.136q0 37.888-26.624 64.512t-65.536 27.648h-1133.568q-36.864 0-64.512-27.648t-26.624-64.512zM365.568 731.136v73.728h219.136v-73.728h-219.136zM146.432 731.136v73.728h146.432v-73.728h-146.432zM1224.704 72.704q37.888 0 65.536 27.648t26.624 64.512v128h-1316.864v-128q0-37.888 26.624-64.512t64.512-27.648h1133.568z'
    ]
  ],
  prefix: 'fd',
  iconName: 'credit-card-alt'
};
export const ccVisa = {
  icon: [
    1316,
    1000,
    [],
    '',
    [
      'M1128.448 565.248h-78.848q8.192-20.48 37.888-101.376l2.048-6.144q2.048-5.12 5.12-14.336t5.12-15.36l7.168 31.744zM303.104 528.384l-32.768-167.936q-6.144-31.744-43.008-31.744h-152.576l-2.048 8.192q178.176 45.056 230.4 191.488zM405.504 328.704l-92.16 250.88-10.24-51.2q-14.336-39.936-48.128-73.728t-74.752-51.2l76.8 291.84h100.352l148.48-366.592h-100.352zM485.376 696.32h94.208l59.392-367.616h-94.208zM923.648 337.92q-38.912-15.36-84.992-15.36-69.632 0-114.688 33.792t-45.056 88.064q-1.024 57.344 82.944 99.328 27.648 12.288 37.888 23.552t11.264 21.504q0 17.408-17.408 26.624t-38.912 9.216q-49.152 0-89.088-19.456l-13.312-6.144-13.312 82.944q43.008 19.456 106.496 19.456 73.728 0 118.784-33.792t46.080-92.16q0-60.416-79.872-99.328-27.648-14.336-40.96-23.552t-12.288-21.504q0-13.312 14.336-22.528t39.936-9.216q39.936-1.024 70.656 13.312l9.216 5.12zM1167.36 328.704h-73.728q-36.864 0-49.152 31.744l-141.312 335.872h99.328l20.48-55.296h120.832q3.072 12.288 11.264 55.296h88.064zM1316.864 146.432v731.136q0 29.696-21.504 51.2t-52.224 22.528h-1170.432q-29.696 0-51.2-22.528t-21.504-51.2v-731.136q0-29.696 21.504-51.2t51.2-22.528h1170.432q29.696 0 52.224 22.528t21.504 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cc-visa'
};
export const ccMastercard = {
  icon: [
    1316,
    1000,
    [],
    '',
    [
      'M638.976 194.56q-72.704-48.128-159.744-48.128-59.392 0-113.664 22.528t-92.16 62.464-62.464 92.16-22.528 112.64q0 59.392 22.528 113.664t62.464 92.16 92.16 62.464 113.664 22.528q87.040 0 159.744-48.128-74.752-61.44-101.376-151.552t0-181.248 101.376-151.552zM658.432 208.896q-71.68 56.32-98.304 142.336t0 172.032 98.304 142.336q72.704-57.344 98.304-142.336t0-172.032-98.304-142.336zM676.864 194.56q74.752 61.44 101.376 151.552t1.024 181.248-102.4 151.552q73.728 48.128 160.768 48.128 59.392 0 113.664-22.528t92.16-62.464 62.464-92.16 22.528-113.664q0-58.368-22.528-112.64t-62.464-92.16-93.184-62.464-112.64-22.528q-87.040 0-160.768 48.128zM1100.8 607.232h4.096v-2.048h-10.24v2.048h4.096v10.24h2.048v-10.24zM1117.184 617.472h2.048v-12.288h-3.072l-3.072 8.192-3.072-8.192h-3.072v12.288h2.048v-9.216l3.072 8.192h2.048l3.072-8.192v9.216zM1113.088 868.352v1.024h-3.072v-1.024h3.072zM1113.088 873.472h1.024l-2.048-3.072h2.048q0-1.024 0-2.048t0-2.048h-6.144v7.168h2.048v-3.072zM391.168 834.56q0-10.24 6.144-17.408t17.408-7.168q10.24 0 16.384 7.168t7.168 17.408q0 11.264-7.168 18.432t-16.384 6.144q-10.24 0-17.408-6.144t-6.144-18.432zM661.504 809.984q17.408 0 20.48 18.432h-39.936q3.072-18.432 19.456-18.432zM865.28 834.56q0-10.24 6.144-17.408t16.384-7.168 17.408 7.168 6.144 17.408q0 11.264-6.144 18.432t-17.408 6.144q-10.24 0-16.384-6.144t-6.144-18.432zM1020.928 834.56q0-10.24 6.144-17.408t17.408-7.168 16.384 7.168 6.144 17.408q0 11.264-6.144 18.432t-16.384 6.144-17.408-7.168-6.144-17.408zM1111.040 876.544q-1.024 0-2.048-1.024-1.024 0-2.048-1.024t-1.024-2.048q-1.024-1.024-1.024-2.048 0-2.048 1.024-2.048 0-2.048 1.024-3.072h1.024q1.024 0 1.024-1.024 1.024 0 2.048 0 2.048 0 2.048 0l2.048 1.024 1.024 3.072q1.024 1.024 1.024 2.048h-1.024v2.048t0 1.024l-1.024 1.024q-1.024 1.024-2.048 1.024 0 1.024-2.048 1.024zM342.016 873.472h17.408v-48.128q0-14.336-8.192-22.528t-22.528-8.192q-18.432 0-26.624 13.312-8.192-13.312-25.6-13.312-14.336 0-22.528 11.264v-9.216h-17.408v76.8h17.408v-43.008q0-20.48 18.432-20.48 17.408 0 17.408 20.48v43.008h16.384v-43.008q0-20.48 19.456-20.48 16.384 0 16.384 20.48v43.008zM437.248 873.472h16.384v-76.8h-16.384v9.216q-10.24-11.264-24.576-11.264-16.384 0-27.648 11.264t-10.24 28.672 10.24 29.696 27.648 11.264q16.384 0 24.576-11.264v9.216zM538.624 849.92q0-19.456-26.624-22.528l-8.192-1.024q-13.312-2.048-13.312-8.192 0-8.192 14.336-8.192 13.312 0 24.576 6.144l7.168-14.336q-12.288-7.168-31.744-7.168-14.336 0-23.552 6.144t-8.192 18.432q0 19.456 26.624 22.528l8.192 1.024q13.312 2.048 13.312 8.192 0 9.216-17.408 9.216-14.336 0-25.6-7.168l-8.192 12.288q14.336 10.24 33.792 10.24 16.384 0 25.6-7.168t9.216-18.432zM613.376 869.376l-5.12-14.336q-7.168 4.096-14.336 4.096-11.264 0-11.264-12.288v-34.816h27.648v-15.36h-27.648v-23.552h-16.384v23.552h-16.384v15.36h16.384v34.816q0 28.672 26.624 28.672 11.264 0 20.48-6.144zM662.528 794.624q-16.384 0-27.648 11.264t-11.264 28.672q0 18.432 11.264 29.696t28.672 11.264q18.432 0 31.744-11.264l-8.192-12.288q-10.24 8.192-22.528 8.192-19.456 0-23.552-18.432h58.368v-7.168q0-18.432-11.264-28.672t-25.6-11.264zM753.664 794.624q-13.312 0-20.48 11.264v-9.216h-17.408v76.8h17.408v-43.008q0-20.48 16.384-20.48 6.144 0 10.24 2.048l5.12-15.36q-5.12-2.048-11.264-2.048zM770.048 834.56q0 18.432 11.264 29.696t29.696 11.264q17.408 0 27.648-9.216l-8.192-13.312q-10.24 7.168-19.456 6.144-10.24 0-17.408-6.144t-6.144-18.432 6.144-17.408 17.408-7.168q11.264 0 19.456 7.168l8.192-13.312q-11.264-9.216-27.648-9.216-18.432 0-29.696 11.264t-11.264 28.672zM910.336 873.472h17.408v-76.8h-17.408v9.216q-8.192-11.264-23.552-11.264-17.408 0-28.672 11.264t-10.24 28.672 10.24 29.696 28.672 11.264q15.36 0 23.552-11.264v9.216zM986.112 794.624q-13.312 0-19.456 11.264v-9.216h-16.384v76.8h16.384v-43.008q0-20.48 16.384-20.48 5.12 0 10.24 2.048l5.12-15.36q-5.12-2.048-12.288-2.048zM1065.984 873.472h17.408v-108.544h-17.408v40.96q-8.192-11.264-24.576-11.264t-26.624 11.264-11.264 28.672 11.264 28.672 26.624 12.288q17.408 0 24.576-11.264v9.216zM1111.040 862.208l-1.024 1.024h-2.048q-1.024 0-2.048 1.024-2.048 1.024-2.048 2.048 0 2.048 0 4.096t0 3.072 2.048 2.048q1.024 1.024 2.048 2.048t3.072 0q2.048 0 3.072 0 0-1.024 1.024-1.024l1.024-1.024q1.024-1.024 2.048-2.048t1.024-3.072-1.024-4.096q0 0-2.048-2.048 0 0-1.024-1.024h-1.024q0 0-1.024-1.024t-2.048 0zM1316.864 146.432v731.136q0 29.696-21.504 51.2t-52.224 22.528h-1170.432q-29.696 0-51.2-22.528t-21.504-51.2v-731.136q0-29.696 21.504-51.2t51.2-22.528h1170.432q29.696 0 52.224 22.528t21.504 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cc-mastercard'
};
export const ccDiscover = {
  icon: [
    1316,
    1000,
    [],
    '',
    [
      'M179.2 444.416q0 28.672-20.48 47.104-17.408 15.36-51.2 15.36h-10.24v-125.952h10.24q34.816 0 51.2 15.36 20.48 18.432 20.48 48.128zM1193.984 406.528q0 29.696-36.864 29.696h-11.264v-57.344h12.288q35.84 0 35.84 27.648zM217.088 444.416q0-43.008-28.672-69.632t-73.728-26.624h-54.272v190.464h54.272q43.008 0 68.608-21.504 33.792-28.672 33.792-72.704zM234.496 538.624h36.864v-190.464h-36.864v190.464zM416.768 481.28q0-23.552-11.264-35.84t-43.008-23.552q-16.384-6.144-22.528-11.264t-6.144-13.312q0-9.216 7.168-14.336t20.48-6.144q16.384 0 29.696 15.36l19.456-25.6q-23.552-20.48-55.296-20.48-25.6 0-43.008 15.36t-16.384 38.912q0 19.456 10.24 31.744t35.84 20.48q21.504 7.168 25.6 11.264 11.264 6.144 11.264 18.432t-8.192 19.456-20.48 8.192q-27.648 0-39.936-25.6l-24.576 22.528q25.6 36.864 65.536 36.864 29.696 0 48.128-17.408t17.408-45.056zM576.512 532.48v-44.032q-21.504 21.504-45.056 21.504-27.648 0-46.080-18.432t-17.408-47.104q0-27.648 17.408-47.104t44.032-19.456q24.576 0 47.104 22.528v-44.032q-23.552-12.288-46.080-12.288-41.984 0-71.68 29.696t-29.696 70.656 29.696 69.632 70.656 29.696q24.576 0 47.104-11.264zM1280 877.568v-301.056q-36.864 22.528-82.944 48.128t-135.168 66.56-188.416 78.848-238.592 76.8-287.744 67.584h896q15.36 0 25.6-11.264t11.264-25.6zM793.6 445.44q0-43.008-29.696-73.728t-73.728-29.696-72.704 29.696-30.72 73.728 30.72 72.704 72.704 30.72 73.728-30.72 29.696-72.704zM880.64 543.744l81.92-195.584h-39.936l-52.224 128-50.176-128h-40.96l80.896 195.584h20.48zM979.968 538.624h104.448v-31.744h-67.584v-51.2h65.536v-32.768h-65.536v-41.984h67.584v-32.768h-104.448v190.464zM1203.2 538.624h45.056l-59.392-79.872q43.008-9.216 43.008-53.248 0-27.648-17.408-41.984t-50.176-15.36h-55.296v190.464h36.864v-75.776h5.12zM1316.864 149.504v724.992q0 31.744-22.528 54.272t-53.248 22.528h-1165.312q-31.744 0-53.248-22.528t-22.528-54.272v-724.992q0-31.744 22.528-54.272t53.248-22.528h1165.312q31.744 0 53.248 22.528t22.528 54.272z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cc-discover'
};
export const ccAmex = {
  icon: [
    1316,
    1000,
    [],
    '',
    [
      'M67.584 390.144h51.2l-25.6-62.464zM422.912 690.176l41.984-45.056-39.936-45.056h-93.184v27.648h81.92v31.744h-81.92v30.72h91.136zM513.024 646.144l56.32 62.464v-123.904zM677.888 618.496q0-18.432-22.528-18.432h-48.128v38.912h47.104q23.552 0 23.552-20.48zM842.752 616.448q0-16.384-23.552-16.384h-47.104v34.816h46.080q24.576 0 24.576-18.432zM684.032 350.208q0-16.384-23.552-16.384h-47.104v33.792h46.080q24.576 0 24.576-17.408zM946.176 390.144h51.2l-25.6-62.464zM399.36 301.056v154.624h-37.888v-120.832l-53.248 120.832h-32.768l-53.248-120.832v120.832h-75.776l-14.336-33.792h-76.8l-14.336 33.792h-39.936l65.536-154.624h55.296l62.464 146.432v-146.432h60.416l49.152 105.472 44.032-105.472h61.44zM716.8 618.496q0 11.264-3.072 20.48t-7.168 14.336-13.312 9.216-15.36 6.144-17.408 2.048-18.432 1.024-18.432-1.024-16.384 0v52.224h-72.704l-45.056-51.2-48.128 51.2h-145.408v-154.624h148.48l45.056 50.176 47.104-50.176h118.784q61.44 0 61.44 50.176zM550.912 423.936v31.744h-123.904v-154.624h123.904v32.768h-87.040v27.648h84.992v31.744h-84.992v30.72h87.040zM1316.864 743.424v131.072q0 31.744-22.528 54.272t-53.248 22.528h-1165.312q-31.744 0-53.248-22.528t-22.528-54.272v-388.096h63.488l14.336-34.816h31.744l14.336 34.816h123.904v-25.6l11.264 25.6h64.512l11.264-26.624v26.624h309.248v-56.32h6.144q5.12 0 5.12 7.168v49.152h159.744v-12.288q13.312 6.144 31.744 10.24t29.696 3.072 35.84 0 29.696-1.024l14.336-34.816h31.744l14.336 34.816h130.048v-32.768l18.432 32.768h104.448v-216.064h-102.4v25.6l-14.336-25.6h-106.496v25.6l-12.288-25.6h-142.336q-39.936 0-62.464 13.312v-13.312h-98.304v13.312q-14.336-13.312-41.984-13.312h-358.4l-24.576 56.32-24.576-56.32h-113.664v25.6l-12.288-25.6h-96.256l-45.056 102.4v-223.232q0-31.744 22.528-54.272t53.248-22.528h1165.312q31.744 0 53.248 22.528t22.528 54.272v388.096h-68.608q-29.696 0-46.080 12.288v-12.288h-101.376q-31.744 0-45.056 12.288v-12.288h-180.224v12.288q-17.408-12.288-50.176-12.288h-118.784v12.288q-13.312-12.288-52.224-12.288h-134.144l-30.72 32.768-28.672-32.768h-198.656v215.040h195.584l31.744-32.768 29.696 32.768h119.808v-50.176h12.288q33.792 0 51.2-7.168v57.344h100.352v-56.32h4.096q4.096 0 6.144 1.024t1.024 6.144v49.152h302.080q32.768 0 50.176-13.312v13.312h96.256q33.792 0 54.272-9.216zM883.712 609.28q0 13.312-7.168 24.576t-19.456 17.408q14.336 5.12 19.456 14.336t5.12 26.624v30.72h-36.864v-25.6q0-19.456-7.168-25.6t-26.624-5.12h-38.912v56.32h-36.864v-154.624h88.064q26.624 0 44.032 8.192t16.384 32.768zM724.992 343.040q0 13.312-7.168 24.576t-18.432 17.408q14.336 5.12 19.456 14.336t5.12 26.624v29.696h-37.888q0-5.12 1.024-15.36t0-13.312-2.048-11.264-5.12-9.216-10.24-4.096-16.384-2.048h-39.936v55.296h-36.864v-154.624l87.040 1.024q28.672 0 45.056 8.192t16.384 32.768zM1027.072 691.2v31.744h-122.88v-154.624h122.88v31.744h-86.016v27.648h84.992v31.744h-84.992v30.72zM784.384 301.056v154.624h-37.888v-154.624h37.888zM1179.648 673.792q0 49.152-58.368 49.152h-71.68v-33.792h71.68q19.456 0 19.456-13.312 0-9.216-9.216-12.288t-23.552-3.072-28.672-2.048-23.552-12.288-10.24-31.744q0-22.528 15.36-34.816t37.888-11.264h73.728v31.744h-67.584q-20.48 0-20.48 14.336 0 9.216 9.216 12.288t24.576 2.048 27.648 1.024 24.576 12.288 9.216 31.744zM1316.864 645.12v57.344q-14.336 20.48-50.176 20.48h-71.68v-33.792h71.68q18.432 0 18.432-13.312 0-8.192-7.168-11.264t-17.408-3.072-23.552-1.024-22.528-5.12-17.408-13.312-7.168-27.648q0-22.528 15.36-34.816t37.888-11.264h73.728v31.744h-67.584q-20.48 0-20.48 14.336 0 12.288 16.384 13.312t38.912 2.048 32.768 15.36zM1222.656 302.080v153.6h-53.248l-69.632-115.712v115.712h-74.752l-15.36-33.792h-76.8l-14.336 33.792h-41.984q-73.728 0-73.728-75.776 0-78.848 75.776-78.848h35.84v33.792q-4.096 0-16.384-1.024t-16.384 0-12.288 1.024-12.288 4.096-9.216 7.168-6.144 13.312-2.048 19.456q0 21.504 8.192 32.768t28.672 11.264h16.384l52.224-120.832h55.296l62.464 145.408v-145.408h56.32l65.536 107.52v-107.52h37.888z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cc-amex'
};
export const ccStripe = {
  icon: [
    1316,
    1000,
    [],
    '',
    [
      'M912.384 516.096q0 38.912-11.264 60.416-11.264 20.48-30.72 20.48-12.288 0-22.528-5.12v-128q16.384-17.408 31.744-17.408 32.768 0 32.768 69.632zM1163.264 495.616h-63.488q4.096-56.32 32.768-56.32t30.72 56.32zM272.384 572.416q0-33.792-19.456-52.224t-57.344-32.768q-20.48-7.168-29.696-13.312t-9.216-14.336q0-15.36 21.504-15.36 33.792 0 70.656 19.456l10.24-64.512q-37.888-18.432-84.992-18.432-44.032 0-69.632 21.504-27.648 22.528-27.648 62.464 0 33.792 18.432 52.224t56.32 31.744q22.528 8.192 31.744 14.336t9.216 16.384q0 17.408-27.648 17.408-16.384 0-39.936-7.168t-40.96-17.408l-11.264 64.512q41.984 23.552 96.256 23.552 46.080 0 73.728-21.504 29.696-22.528 29.696-66.56zM440.32 449.536l11.264-63.488h-55.296v-76.8l-73.728 12.288-10.24 64.512-25.6 5.12-10.24 58.368h35.84v124.928q0 48.128 24.576 68.608 21.504 17.408 63.488 17.408 18.432 0 45.056-6.144v-67.584q-18.432 4.096-24.576 4.096-24.576 0-24.576-28.672v-112.64h44.032zM621.568 463.872v-78.848q-9.216-2.048-16.384-2.048-18.432 0-31.744 9.216t-19.456 25.6l-5.12-31.744h-74.752v269.312h84.992v-175.104q15.36-17.408 47.104-17.408 9.216 0 15.36 1.024zM642.048 655.36h86.016v-269.312h-86.016v269.312zM997.376 513.024q0-69.632-25.6-102.4-22.528-29.696-63.488-29.696-35.84 0-66.56 31.744l-4.096-26.624h-75.776v368.64l86.016-14.336v-86.016q20.48 6.144 38.912 6.144 47.104 0 75.776-31.744 34.816-36.864 34.816-115.712zM730.112 314.368q0-19.456-13.312-31.744t-31.744-13.312-31.744 13.312-13.312 31.744 13.312 31.744 31.744 14.336 31.744-14.336 13.312-31.744zM1243.136 518.144q0-64.512-26.624-100.352-28.672-36.864-82.944-36.864t-86.016 37.888-31.744 102.4q0 73.728 35.84 107.52 31.744 31.744 92.16 31.744 57.344 0 91.136-22.528l-9.216-59.392q-32.768 18.432-72.704 18.432-24.576 0-36.864-11.264t-15.36-37.888h141.312q1.024-8.192 1.024-29.696zM1316.864 146.432v731.136q0 29.696-21.504 51.2t-52.224 22.528h-1170.432q-29.696 0-51.2-22.528t-21.504-51.2v-731.136q0-29.696 21.504-51.2t51.2-22.528h1170.432q29.696 0 52.224 22.528t21.504 51.2z'
    ]
  ],
  prefix: 'fd',
  iconName: 'cc-stripe'
};
export const twitter = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M731.136 348.16q-31.744 14.336-68.608 19.456 38.912-22.528 53.248-66.56-37.888 21.504-76.8 28.672-34.816-36.864-87.040-36.864-50.176 0-84.992 34.816t-35.84 84.992q0 16.384 3.072 27.648-73.728-4.096-138.24-37.888t-109.568-88.064q-16.384 28.672-16.384 60.416 0 65.536 52.224 100.352-27.648-1.024-57.344-15.36v1.024q0 43.008 28.672 76.8t69.632 40.96q-16.384 5.12-28.672 5.12-7.168 0-22.528-3.072 12.288 36.864 43.008 60.416t68.608 23.552q-65.536 51.2-148.48 51.2-15.36 0-28.672-2.048 83.968 54.272 184.32 54.272 63.488 0 119.808-20.48t96.256-54.272 68.608-77.824 43.008-93.184 13.312-96.256q0-10.24 0-15.36 35.84-25.6 59.392-62.464zM877.568 237.568v548.864q0 67.584-48.128 115.712t-116.736 49.152h-547.84q-68.608 0-116.736-49.152t-48.128-115.712v-548.864q0-67.584 48.128-115.712t116.736-49.152h547.84q68.608 0 116.736 49.152t48.128 115.712z'
    ]
  ],
  prefix: 'fd',
  iconName: 'twitter'
};
export const facebook = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M712.704 72.704q68.608 0 116.736 49.152t48.128 115.712v548.864q0 67.584-48.128 115.712t-116.736 49.152h-106.496v-340.992h113.664l16.384-132.096h-130.048v-84.992q0-31.744 13.312-47.104t52.224-16.384l69.632-1.024v-117.76q-35.84-5.12-102.4-5.12-76.8 0-123.904 45.056t-46.080 130.048v97.28h-114.688v132.096h114.688v340.992h-304.128q-68.608 0-116.736-49.152t-48.128-115.712v-548.864q0-67.584 48.128-115.712t116.736-49.152h547.84z'
    ]
  ],
  prefix: 'fd',
  iconName: 'facebook'
};
export const linkedinSquared = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M135.168 807.936h132.096v-396.288h-132.096v396.288zM276.48 288.768q-1.024-29.696-21.504-49.152t-52.224-19.456-54.272 19.456-21.504 49.152q0 29.696 20.48 49.152t53.248 19.456v0q33.792 0 54.272-19.456t21.504-49.152zM610.304 807.936h132.096v-227.328q0-88.064-41.984-133.12t-109.568-45.056q-77.824 0-119.808 66.56h1.024v-57.344h-132.096q2.048 37.888 0 396.288h132.096v-222.208q0-21.504 4.096-31.744 8.192-19.456 25.6-33.792t41.984-14.336q66.56 0 66.56 90.112v211.968zM877.568 237.568v548.864q0 67.584-48.128 115.712t-116.736 49.152h-547.84q-68.608 0-116.736-49.152t-48.128-115.712v-548.864q0-67.584 48.128-115.712t116.736-49.152h547.84q68.608 0 116.736 49.152t48.128 115.712z'
    ]
  ],
  prefix: 'fd',
  iconName: 'linkedin-squared'
};
export const instagram = {
  icon: [
    881,
    1000,
    [],
    '',
    [
      'M706.56 512q0-26.624-6.144-51.2h180.224v352.256q0 57.344-39.936 98.304t-97.28 40.96h-606.208q-57.344 0-97.28-40.96t-39.936-98.304v-352.256h178.176q-4.096 32.768-4.096 51.2 0 108.544 77.824 187.392t188.416 78.848q108.544 0 187.392-78.848t78.848-187.392zM743.424 71.68q57.344 0 97.28 39.936t39.936 97.28v149.504h-223.232q-79.872-112.64-217.088-112.64-141.312 0-217.088 112.64h-223.232v-149.504q0-57.344 39.936-97.28t97.28-39.936h606.208zM808.96 241.664v-73.728q0-24.576-24.576-24.576h-73.728q-24.576 0-24.576 24.576v73.728q0 8.192 7.168 16.384t17.408 8.192h73.728q24.576 0 24.576-24.576zM604.16 512q0 67.584-48.128 115.712t-115.712 48.128-115.712-48.128-48.128-115.712q0-69.632 48.128-116.736t115.712-47.104 115.712 47.104 48.128 116.736z'
    ]
  ],
  prefix: 'fd',
  iconName: 'instagram'
};
export const tailwind = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M296 433.6c28.8-115.2 100.8-172.8 216-172.8 172.8 0 194.4 129.6 280.8 151.2 57.6 14.4 108-7.2 151.2-64.8-28.8 115.2-100.8 172.8-216 172.8-172.8 0-194.4-129.6-280.8-151.2-57.6-14.4-108 7.2-151.2 64.8zM80 692.8c28.8-115.2 100.8-172.8 216-172.8 172.8 0 194.4 129.6 280.8 151.2 57.6 14.4 108-7.2 151.2-64.8-28.8 115.2-100.8 172.8-216 172.8-172.8 0-194.4-129.6-280.8-151.2-57.6-14.4-108 7.2-151.2 64.8z'
    ]
  ],
  prefix: 'fd',
  iconName: 'tailwind'
};
export const earth = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960.002c-62.958 0-122.872-13.012-177.23-36.452l233.148-262.29c5.206-5.858 8.082-13.422 8.082-21.26v-96c0-17.674-14.326-32-32-32-112.99 0-232.204-117.462-233.374-118.626-6-6.002-14.14-9.374-22.626-9.374h-128c-17.672 0-32 14.328-32 32v192c0 12.122 6.848 23.202 17.69 28.622l110.31 55.156v187.886c-116.052-80.956-192-215.432-192-367.664 0-68.714 15.49-133.806 43.138-192h116.862c8.488 0 16.626-3.372 22.628-9.372l128-128c6-6.002 9.372-14.14 9.372-22.628v-77.412c40.562-12.074 83.518-18.588 128-18.588 70.406 0 137.004 16.26 196.282 45.2-4.144 3.502-8.176 7.164-12.046 11.036-36.266 36.264-56.236 84.478-56.236 135.764s19.97 99.5 56.236 135.764c36.434 36.432 85.218 56.264 135.634 56.26 3.166 0 6.342-0.080 9.518-0.236 13.814 51.802 38.752 186.656-8.404 372.334-0.444 1.744-0.696 3.488-0.842 5.224-81.324 83.080-194.7 134.656-320.142 134.656z'
    ]
  ],
  prefix: 'fd',
  iconName: 'earth'
};
export const home3 = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1024 608l-192-192v-288h-128v160l-192-192-512 512v32h128v320h320v-192h128v192h320v-320h128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'home3'
};
export const search = {
  icon: [
    950.8571428571428,
    1000,
    [],
    '',
    [
      'M658.286 475.429c0-141.143-114.857-256-256-256s-256 114.857-256 256 114.857 256 256 256 256-114.857 256-256zM950.857 950.857c0 40-33.143 73.143-73.143 73.143-19.429 0-38.286-8-51.429-21.714l-196-195.429c-66.857 46.286-146.857 70.857-228 70.857-222.286 0-402.286-180-402.286-402.286s180-402.286 402.286-402.286 402.286 180 402.286 402.286c0 81.143-24.571 161.143-70.857 228l196 196c13.143 13.143 21.143 32 21.143 51.429z'
    ]
  ],
  prefix: 'fd',
  iconName: 'search'
};
export const zoomIn = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256zM448 192h-128v128h-128v128h128v128h128v-128h128v-128h-128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'zoom-in'
};
export const zoomOut = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256zM192 320h384v128h-384z'
    ]
  ],
  prefix: 'fd',
  iconName: 'zoom-out'
};
export const sortUnsorted = {
  icon: [
    585.1428571428571,
    1000,
    [],
    '',
    [
      'M585.143 621.714c0 9.714-4 18.857-10.857 25.714l-256 256c-6.857 6.857-16 10.857-25.714 10.857s-18.857-4-25.714-10.857l-256-256c-6.857-6.857-10.857-16-10.857-25.714 0-20 16.571-36.571 36.571-36.571h512c20 0 36.571 16.571 36.571 36.571zM585.143 402.286c0 20-16.571 36.571-36.571 36.571h-512c-20 0-36.571-16.571-36.571-36.571 0-9.714 4-18.857 10.857-25.714l256-256c6.857-6.857 16-10.857 25.714-10.857s18.857 4 25.714 10.857l256 256c6.857 6.857 10.857 16 10.857 25.714z'
    ]
  ],
  prefix: 'fd',
  iconName: 'sort, unsorted'
};
export const bullhorn = {
  icon: [
    1024,
    1000,
    [],
    '',
    [
      'M950.857 365.714c40.571 0 73.143 32.571 73.143 73.143s-32.571 73.143-73.143 73.143v219.429c0 40-33.143 73.143-73.143 73.143-101.714-84.571-265.714-200.571-464-217.143-68 22.857-91.429 102.286-46.857 148-40 65.714 11.429 112 72 159.429-35.429 69.714-182.857 70.857-235.429 22.286-33.143-101.714-82.286-203.429-42.286-332h-69.714c-50.286 0-91.429-41.143-91.429-91.429v-109.714c0-50.286 41.143-91.429 91.429-91.429h274.286c219.429 0 402.286-128 512-219.429 40 0 73.143 33.143 73.143 73.143v219.429zM877.714 710.857v-545.143c-149.143 114.286-293.714 180-438.857 196v154.286c145.143 16 289.714 80.571 438.857 194.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'bullhorn'
};
export const okCircled = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M734.208 419.84q0-16.384-10.24-26.624l-52.224-51.2q-11.264-11.264-25.6-11.264t-25.6 11.264l-233.472 232.448-129.024-129.024q-11.264-11.264-25.6-11.264t-25.6 11.264l-52.224 51.2q-10.24 10.24-10.24 26.624 0 15.36 10.24 25.6l206.848 206.848q10.24 10.24 25.6 10.24t26.624-10.24l310.272-310.272q10.24-10.24 10.24-25.6zM877.568 512q0 119.808-58.368 220.16t-159.744 159.744-220.16 59.392-221.184-59.392-158.72-159.744-59.392-220.16 59.392-220.16 158.72-159.744 221.184-59.392 220.16 59.392 159.744 159.744 58.368 220.16z'
    ]
  ],
  prefix: 'fd',
  iconName: 'ok-circled'
};
export const checkCircleO = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M669.143 464.571l-241.143 241.143c-14.286 14.286-37.143 14.286-51.429 0l-168-168c-14.286-14.286-14.286-37.143 0-51.429l58.286-58.286c14.286-14.286 37.143-14.286 51.429 0l84 84 157.143-157.143c14.286-14.286 37.143-14.286 51.429 0l58.286 58.286c14.286 14.286 14.286 37.143 0 51.429zM749.714 512c0-171.429-139.429-310.857-310.857-310.857s-310.857 139.429-310.857 310.857 139.429 310.857 310.857 310.857 310.857-139.429 310.857-310.857zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'check-circle-o'
};
export const ok = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M955.392 323.584q0 22.528-16.384 38.912l-491.52 491.52q-16.384 15.36-38.912 15.36t-38.912-15.36l-284.672-284.672q-15.36-16.384-15.36-38.912t15.36-38.912l77.824-77.824q16.384-16.384 38.912-16.384t38.912 16.384l167.936 168.96 374.784-375.808q16.384-16.384 38.912-16.384t38.912 16.384l77.824 77.824q16.384 15.36 16.384 38.912z'
    ]
  ],
  prefix: 'fd',
  iconName: 'ok'
};
export const disable = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M749.568 509.952q0-92.16-49.152-167.936l-431.104 430.080q77.824 51.2 169.984 51.2 63.488 0 120.832-25.6t98.304-66.56 66.56-99.328 24.576-121.856zM179.2 680.96l431.104-431.104q-76.8-51.2-171.008-51.2-84.992 0-156.672 40.96t-112.64 113.664-41.984 156.672q0 93.184 51.2 171.008zM877.568 509.952q0 90.112-34.816 172.032t-93.184 140.288-140.288 94.208-169.984 34.816-171.008-34.816-140.288-94.208-93.184-140.288-34.816-172.032 34.816-171.008 93.184-140.288 140.288-93.184 171.008-34.816 169.984 34.816 140.288 93.184 93.184 140.288 34.816 171.008z'
    ]
  ],
  prefix: 'fd',
  iconName: 'disable'
};
export const plusCircle = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M694.857 548.571v-73.143c0-20-16.571-36.571-36.571-36.571h-146.286v-146.286c0-20-16.571-36.571-36.571-36.571h-73.143c-20 0-36.571 16.571-36.571 36.571v146.286h-146.286c-20 0-36.571 16.571-36.571 36.571v73.143c0 20 16.571 36.571 36.571 36.571h146.286v146.286c0 20 16.571 36.571 36.571 36.571h73.143c20 0 36.571-16.571 36.571-36.571v-146.286h146.286c20 0 36.571-16.571 36.571-36.571zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'plus-circle'
};
export const arrowCircleODown = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M640 530.286c0 5.143-2.286 9.714-5.714 13.714l-182.286 182.286c-4 3.429-8.571 5.143-13.143 5.143s-9.143-1.714-13.143-5.143l-182.857-182.857c-5.143-5.714-6.857-13.143-4-20s9.714-11.429 17.143-11.429h109.714v-201.143c0-10.286 8-18.286 18.286-18.286h109.714c10.286 0 18.286 8 18.286 18.286v201.143h109.714c10.286 0 18.286 8 18.286 18.286zM438.857 201.143c-171.429 0-310.857 139.429-310.857 310.857s139.429 310.857 310.857 310.857 310.857-139.429 310.857-310.857-139.429-310.857-310.857-310.857zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857v0c242.286 0 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'arrow-circle-o-down'
};
export const playCircleO = {
  icon: [
    878,
    1000,
    [],
    '',
    [
      'M676.571 512c0 13.143-6.857 25.143-18.286 31.429l-310.857 182.857c-5.714 3.429-12 5.143-18.286 5.143s-12.571-1.714-18.286-4.571c-11.429-6.857-18.286-18.857-18.286-32v-365.714c0-13.143 6.857-25.143 18.286-32 11.429-6.286 25.714-6.286 36.571 0.571l310.857 182.857c11.429 6.286 18.286 18.286 18.286 31.429zM749.714 512c0-171.429-139.429-310.857-310.857-310.857s-310.857 139.429-310.857 310.857 139.429 310.857 310.857 310.857 310.857-139.429 310.857-310.857zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'play-circle-o'
};
export const play2 = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM384 288l384 224-384 224z'
    ]
  ],
  prefix: 'fd',
  iconName: 'play2'
};
export const longArrowRight = {
  icon: [
    987.4285714285713,
    1000,
    [],
    '',
    [
      'M987.429 510.286c0 5.143-2.286 10.286-5.714 13.714l-219.429 202.286c-5.714 5.143-13.143 6.286-20 3.429-6.286-2.857-10.857-9.143-10.857-16.571v-128h-713.143c-10.286 0-18.286-8-18.286-18.286v-109.714c0-10.286 8-18.286 18.286-18.286h713.143v-128c0-7.429 4-13.714 10.857-16.571s14.286-1.714 20 2.857l219.429 200c3.429 3.429 5.714 8 5.714 13.143v0z'
    ]
  ],
  prefix: 'fd',
  iconName: 'long-arrow-right'
};
export const arrowsV = {
  icon: [
    439,
    1000,
    [],
    '',
    [
      'M402.286 182.857c0 20-16.571 36.571-36.571 36.571h-73.143v585.143h73.143c20 0 36.571 16.571 36.571 36.571 0 9.714-4 18.857-10.857 25.714l-146.286 146.286c-6.857 6.857-16 10.857-25.714 10.857s-18.857-4-25.714-10.857l-146.286-146.286c-6.857-6.857-10.857-16-10.857-25.714 0-20 16.571-36.571 36.571-36.571h73.143v-585.143h-73.143c-20 0-36.571-16.571-36.571-36.571 0-9.714 4-18.857 10.857-25.714l146.286-146.286c6.857-6.857 16-10.857 25.714-10.857s18.857 4 25.714 10.857l146.286 146.286c6.857 6.857 10.857 16 10.857 25.714z'
    ]
  ],
  prefix: 'fd',
  iconName: 'arrows-v'
};
export const chevronUp = {
  icon: [
    1024,
    1000,
    [],
    '',
    [
      'M961.714 760.571l-94.857 94.286c-14.286 14.286-37.143 14.286-51.429 0l-303.429-303.429-303.429 303.429c-14.286 14.286-37.143 14.286-51.429 0l-94.857-94.286c-14.286-14.286-14.286-37.714 0-52l424-423.429c14.286-14.286 37.143-14.286 51.429 0l424 423.429c14.286 14.286 14.286 37.714 0 52z'
    ]
  ],
  prefix: 'fd',
  iconName: 'chevron-up'
};
export const caretUp = {
  icon: [
    585.1428571428571,
    1000,
    [],
    '',
    [
      'M585.143 694.857c0 20-16.571 36.571-36.571 36.571h-512c-20 0-36.571-16.571-36.571-36.571 0-9.714 4-18.857 10.857-25.714l256-256c6.857-6.857 16-10.857 25.714-10.857s18.857 4 25.714 10.857l256 256c6.857 6.857 10.857 16 10.857 25.714z'
    ]
  ],
  prefix: 'fd',
  iconName: 'caret-up'
};
export const folderOpen = {
  icon: [
    1073.7371428571428,
    1000,
    [],
    '',
    [
      'M1073.714 544c0 13.714-8.571 27.429-17.714 37.714l-192 226.286c-33.143 38.857-100.571 69.714-150.857 69.714h-621.714c-20.571 0-49.714-6.286-49.714-32 0-13.714 8.571-27.429 17.714-37.714l192-226.286c33.143-38.857 100.571-69.714 150.857-69.714h621.714c20.571 0 49.714 6.286 49.714 32zM877.714 347.429v91.429h-475.429c-71.429 0-160 40.571-206.286 95.429l-195.429 229.714c0-4.571-0.571-9.714-0.571-14.286v-548.571c0-70.286 57.714-128 128-128h182.857c70.286 0 128 57.714 128 128v18.286h310.857c70.286 0 128 57.714 128 128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'folder-open'
};
export const folder = {
  icon: [
    950.8571428571428,
    1000,
    [],
    '',
    [
      'M950.857 347.429v402.286c0 70.286-57.714 128-128 128h-694.857c-70.286 0-128-57.714-128-128v-548.571c0-70.286 57.714-128 128-128h182.857c70.286 0 128 57.714 128 128v18.286h384c70.286 0 128 57.714 128 128z'
    ]
  ],
  prefix: 'fd',
  iconName: 'folder'
};
export const folderOpenO = {
  icon: [
    1090.8525714285713,
    1000,
    [],
    '',
    [
      'M1017.714 532c0-16-17.714-20-30.286-20h-621.714c-30.286 0-70.286 18.857-89.714 42.286l-168 207.429c-5.143 6.857-10.286 14.286-10.286 22.857 0 16 17.714 20 30.286 20h621.714c30.286 0 70.286-18.857 89.714-42.857l168-207.429c5.143-6.286 10.286-13.714 10.286-22.286zM365.714 438.857h438.857v-91.429c0-30.286-24.571-54.857-54.857-54.857h-329.143c-30.286 0-54.857-24.571-54.857-54.857v-36.571c0-30.286-24.571-54.857-54.857-54.857h-182.857c-30.286 0-54.857 24.571-54.857 54.857v487.429l146.286-180c33.143-40.571 94.286-69.714 146.286-69.714zM1090.857 532c0 25.143-10.857 49.143-26.286 68.571l-168.571 207.429c-32.571 40-94.857 69.714-146.286 69.714h-621.714c-70.286 0-128-57.714-128-128v-548.571c0-70.286 57.714-128 128-128h182.857c70.286 0 128 57.714 128 128v18.286h310.857c70.286 0 128 57.714 128 128v91.429h109.714c38.857 0 77.714 17.714 94.857 54.286 5.714 12 8.571 25.143 8.571 38.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'folder-open-o'
};
export const smileO = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M648 614.286c-28.571 92-112.571 153.714-209.143 153.714s-180.571-61.714-209.143-153.714c-6.286-19.429 4.571-39.429 24-45.714 18.857-6.286 39.429 4.571 45.714 24 18.857 61.143 75.429 102.286 139.429 102.286s120.571-41.143 139.429-102.286c6.286-19.429 26.857-30.286 46.286-24 18.857 6.286 29.714 26.286 23.429 45.714zM365.714 365.714c0 40.571-32.571 73.143-73.143 73.143s-73.143-32.571-73.143-73.143 32.571-73.143 73.143-73.143 73.143 32.571 73.143 73.143zM658.286 365.714c0 40.571-32.571 73.143-73.143 73.143s-73.143-32.571-73.143-73.143 32.571-73.143 73.143-73.143 73.143 32.571 73.143 73.143zM804.571 512c0-201.714-164-365.714-365.714-365.714s-365.714 164-365.714 365.714 164 365.714 365.714 365.714 365.714-164 365.714-365.714zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'smile-o'
};
export const frownO = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M648 702.286c6.286 19.429-4.571 39.429-23.429 45.714-19.429 6.286-40-4.571-46.286-24-18.857-61.143-75.429-102.286-139.429-102.286s-120.571 41.143-139.429 102.286c-6.286 19.429-26.857 30.286-45.714 24-19.429-6.286-30.286-26.286-24-45.714 28.571-92 112.571-153.714 209.143-153.714s180.571 61.714 209.143 153.714zM365.714 365.714c0 40.571-32.571 73.143-73.143 73.143s-73.143-32.571-73.143-73.143 32.571-73.143 73.143-73.143 73.143 32.571 73.143 73.143zM658.286 365.714c0 40.571-32.571 73.143-73.143 73.143s-73.143-32.571-73.143-73.143 32.571-73.143 73.143-73.143 73.143 32.571 73.143 73.143zM804.571 512c0-201.714-164-365.714-365.714-365.714s-365.714 164-365.714 365.714 164 365.714 365.714 365.714 365.714-164 365.714-365.714zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'frown-o'
};
export const mehO = {
  icon: [
    877.7142857142857,
    1000,
    [],
    '',
    [
      'M658.286 621.714c0 20-16.571 36.571-36.571 36.571h-365.714c-20 0-36.571-16.571-36.571-36.571s16.571-36.571 36.571-36.571h365.714c20 0 36.571 16.571 36.571 36.571zM365.714 365.714c0 40.571-32.571 73.143-73.143 73.143s-73.143-32.571-73.143-73.143 32.571-73.143 73.143-73.143 73.143 32.571 73.143 73.143zM658.286 365.714c0 40.571-32.571 73.143-73.143 73.143s-73.143-32.571-73.143-73.143 32.571-73.143 73.143-73.143 73.143 32.571 73.143 73.143zM804.571 512c0-201.714-164-365.714-365.714-365.714s-365.714 164-365.714 365.714 164 365.714 365.714 365.714 365.714-164 365.714-365.714zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'meh-o'
};
export const lock = {
  icon: [
    658.2857142857142,
    1000,
    [],
    '',
    [
      'M182.857 438.857h292.571v-109.714c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286v109.714zM658.286 493.714v329.143c0 30.286-24.571 54.857-54.857 54.857h-548.571c-30.286 0-54.857-24.571-54.857-54.857v-329.143c0-30.286 24.571-54.857 54.857-54.857h18.286v-109.714c0-140.571 115.429-256 256-256s256 115.429 256 256v109.714h18.286c30.286 0 54.857 24.571 54.857 54.857z'
    ]
  ],
  prefix: 'fd',
  iconName: 'lock'
};
export const unlockAlt = {
  icon: [
    658.2857142857142,
    1000,
    [],
    '',
    [
      'M603.429 438.857c30.286 0 54.857 24.571 54.857 54.857v329.143c0 30.286-24.571 54.857-54.857 54.857h-548.571c-30.286 0-54.857-24.571-54.857-54.857v-329.143c0-30.286 24.571-54.857 54.857-54.857h18.286v-182.857c0-141.143 114.857-256 256-256s256 114.857 256 256c0 20-16.571 36.571-36.571 36.571h-36.571c-20 0-36.571-16.571-36.571-36.571 0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286v182.857h420.571z'
    ]
  ],
  prefix: 'fd',
  iconName: 'unlock-alt'
};
export const starFull = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z'
    ]
  ],
  prefix: 'fd',
  iconName: 'star-full'
};
export const eye = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z'
    ]
  ],
  prefix: 'fd',
  iconName: 'eye'
};
export const eyePlus = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M1024 128h-128v-128h-128v128h-128v128h128v128h128v-128h128z',
      'M863.862 446.028c18.436 20.478 35.192 42.53 50.022 65.972-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.86-25.486-252.454-73.704-60.156-38.372-111.136-89.772-149.43-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 141.382 114.616 256 256 256 141.38 0 256-114.618 256-256 0-0.692-0.018-1.38-0.024-2.072-109.284-28.138-190.298-126.63-191.932-244.31-21.026-2.38-42.394-3.618-64.044-3.618-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.31 0 416.876-130.042 512-320-17.64-35.23-38.676-68.394-62.65-99.054-29.28 17.178-62.272 28.71-97.488 33.082zM416 320c53.020 0 96 42.982 96 96 0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96z'
    ]
  ],
  prefix: 'fd',
  iconName: 'eye-plus'
};
export const eyeMinus = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M640 128h384v128h-384v-128z',
      'M870.32 320h-294.32v-124.388c-21.014-2.376-42.364-3.612-64-3.612-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.31 0 416.876-130.042 512-320-37.396-74.686-90.020-140.1-153.68-192zM416 320c53.020 0 96 42.982 96 96 0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96zM764.448 662.296c-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.86-25.486-252.454-73.704-60.156-38.372-111.136-89.772-149.43-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 141.382 114.616 256 256 256 141.38 0 256-114.618 256-256 0-30.774-5.454-60.268-15.408-87.598 3.976 2.378 7.938 4.802 11.858 7.302 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296z'
    ]
  ],
  prefix: 'fd',
  iconName: 'eye-minus'
};
export const eyeBlocked = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M945.942 14.058c-18.746-18.744-49.136-18.744-67.882 0l-202.164 202.164c-51.938-15.754-106.948-24.222-163.896-24.222-223.318 0-416.882 130.042-512 320 41.122 82.124 100.648 153.040 173.022 207.096l-158.962 158.962c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l864-864c18.744-18.746 18.744-49.138 0-67.884zM416 320c42.24 0 78.082 27.294 90.92 65.196l-121.724 121.724c-37.902-12.838-65.196-48.68-65.196-90.92 0-53.020 42.98-96 96-96zM110.116 512c38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 54.89 17.286 105.738 46.7 147.418l-60.924 60.924c-52.446-36.842-97.202-83.882-131.66-138.342z',
      'M768 442c0-27.166-4.256-53.334-12.102-77.898l-321.808 321.808c24.568 7.842 50.742 12.090 77.91 12.090 141.382 0 256-114.618 256-256z',
      'M830.026 289.974l-69.362 69.362c1.264 0.786 2.53 1.568 3.786 2.368 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-38.664 0-76.902-4.76-113.962-14.040l-76.894 76.894c59.718 21.462 123.95 33.146 190.856 33.146 223.31 0 416.876-130.042 512-320-45.022-89.916-112.118-166.396-193.974-222.026z'
    ]
  ],
  prefix: 'fd',
  iconName: 'eye-blocked'
};
export const lab = {
  icon: [
    1000,
    1000,
    [],
    '',
    [
      'M956.29 804.482l-316.29-527.024v-213.458h32c17.6 0 32-14.4 32-32s-14.4-32-32-32h-320c-17.6 0-32 14.4-32 32s14.4 32 32 32h32v213.458l-316.288 527.024c-72.442 120.734-16.512 219.518 124.288 219.518h640c140.8 0 196.73-98.784 124.29-219.518zM241.038 640l206.962-344.938v-231.062h128v231.062l206.964 344.938h-541.926z'
    ]
  ],
  prefix: 'fd',
  iconName: 'lab'
};
export default [
  flyteBadge,
  circle,
  fileLogo,
  database,
  ban,
  caretRight,
  flytedeskLogo,
  flyteboard,
  nova,
  flytedesk,
  paperPlane,
  paperPlaneEmpty,
  print,
  specialEdition,
  billboard,
  brandedCoasters,
  flyering,
  postering,
  fullPage,
  juniorPage,
  halfPage,
  quarterPage,
  largeRectangle,
  wideSkyscraper,
  halfPageDigital,
  button1,
  squarePopup,
  squareButton,
  eighthPage,
  rectangle,
  mediumRectangle,
  skyscraper,
  verticalBanner,
  leaderboard,
  ribbon,
  inserts,
  stickers,
  brandedCoastersMug,
  bank,
  productSampling,
  mail,
  mailAlt,
  heartEmpty,
  heart,
  bellAlt,
  trashEmpty,
  pencil,
  printer,
  type,
  ellipsis,
  ellipsisV,
  sliders,
  music,
  filter,
  sortAmountAsc,
  sortAmountDesc,
  percent,
  dashboard,
  chartPie,
  chartLine,
  medium,
  link,
  infoCircled,
  helpCircled,
  exclamationCircle,
  attention,
  warning,
  calendarCheckO,
  calendarPlusO,
  calendar,
  clock,
  hourglass1,
  hourglass2,
  hourglass3,
  infinite,
  picture,
  location,
  phone,
  basket,
  magic,
  thumbsUp,
  lightbulb,
  wrench,
  camera,
  attach,
  cogAlt,
  cog1,
  cog,
  chat,
  chatEmpty,
  bubble,
  commentEmpty,
  social,
  commenting,
  commentingO,
  tags,
  tag,
  dollar,
  money,
  userCircle,
  userCircleO,
  users,
  user,
  male,
  userPlus,
  addressBookO,
  edit,
  linkExt,
  shareSquareO,
  checkEmpty,
  check,
  cancel,
  stop,
  pause1,
  plus,
  minus,
  download,
  upload,
  arrowsCw,
  rotateDoc,
  loop,
  retweet,
  share,
  angleDoubleLeft,
  angleDoubleRight,
  angleLeft,
  angleRight,
  angleUp,
  angleDown,
  folderEmpty,
  archive,
  inbox,
  signup,
  docs,
  docText,
  fileArchive,
  fileImage,
  filePdf,
  desktop,
  digital,
  laptop,
  tablet,
  outdoor,
  mobile1,
  mobile,
  creditCard,
  creditCardAlt,
  ccVisa,
  ccMastercard,
  ccDiscover,
  ccAmex,
  ccStripe,
  twitter,
  facebook,
  linkedinSquared,
  instagram,
  tailwind,
  earth,
  home3,
  search,
  zoomIn,
  zoomOut,
  sortUnsorted,
  bullhorn,
  okCircled,
  checkCircleO,
  ok,
  disable,
  plusCircle,
  arrowCircleODown,
  playCircleO,
  play2,
  longArrowRight,
  arrowsV,
  chevronUp,
  caretUp,
  folderOpen,
  folder,
  folderOpenO,
  smileO,
  frownO,
  mehO,
  lock,
  unlockAlt,
  starFull,
  eye,
  eyePlus,
  eyeMinus,
  eyeBlocked,
  lab
];
